/* tslint:disable */
/* eslint-disable */
/**
 * HYOUMANBOX APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { Configuration } from './configuration';
import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import Store from '../store';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from './base';

/**
 * 
 * @export
 * @interface AccessLog
 */
export interface AccessLog {
    /**
     * 
     * @type {string}
     * @memberof AccessLog
     */
    'datetime'?: string;
    /**
     * 
     * @type {string}
     * @memberof AccessLog
     */
    'userFullName'?: string;
    /**
     * 
     * @type {string}
     * @memberof AccessLog
     */
    'pageName'?: string;
    /**
     * 
     * @type {string}
     * @memberof AccessLog
     */
    'action'?: string;
    /**
     * 
     * @type {string}
     * @memberof AccessLog
     */
    'targetName'?: string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const ApplicantStatsEnum = {
    Screening: 'screening',
    Hired: 'hired',
    NotHired: 'not_hired',
    Joined: 'joined'
} as const;

export type ApplicantStatsEnum = typeof ApplicantStatsEnum[keyof typeof ApplicantStatsEnum];


/**
 * 
 * @export
 * @interface ApplicantStatus
 */
export interface ApplicantStatus {
    /**
     * 
     * @type {string}
     * @memberof ApplicantStatus
     */
    'code': string;
    /**
     * 
     * @type {string}
     * @memberof ApplicantStatus
     */
    'name': string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const ApplicantStatusEnum = {
    Screening: 'screening',
    Hired: 'hired',
    NotHired: 'not_hired',
    Joined: 'joined'
} as const;

export type ApplicantStatusEnum = typeof ApplicantStatusEnum[keyof typeof ApplicantStatusEnum];


/**
 * 
 * @export
 * @enum {string}
 */

export const AsBroadcastStatusEnum = {
    None: 'none',
    Sent: 'sent',
    Answering: 'answering',
    Done: 'done',
    Revoked: 'revoked',
    Expired: 'expired'
} as const;

export type AsBroadcastStatusEnum = typeof AsBroadcastStatusEnum[keyof typeof AsBroadcastStatusEnum];


/**
 * 
 * @export
 * @enum {string}
 */

export const AsBroadcastTypeEnum = {
    Employee: '1',
    Applicant: '2'
} as const;

export type AsBroadcastTypeEnum = typeof AsBroadcastTypeEnum[keyof typeof AsBroadcastTypeEnum];


/**
 * 
 * @export
 * @enum {string}
 */

export const AsExportTypeEnum = {
    EmployeeWithDept: 'EmployeeWithDept',
    ApplicantWithStatus: 'ApplicantWithStatus',
    ApplicantAll: 'ApplicantAll'
} as const;

export type AsExportTypeEnum = typeof AsExportTypeEnum[keyof typeof AsExportTypeEnum];


/**
 * 
 * @export
 * @interface AsSendTaskBatchSendRequest
 */
export interface AsSendTaskBatchSendRequest {
    /**
     * 
     * @type {Array<any>}
     * @memberof AsSendTaskBatchSendRequest
     */
    'asSendTaskIds': Array<any>;
    /**
     * 
     * @type {string}
     * @memberof AsSendTaskBatchSendRequest
     */
    'broadcastType': string;
    /**
     * 
     * @type {string}
     * @memberof AsSendTaskBatchSendRequest
     */
    'emailSubject': string;
    /**
     * 
     * @type {string}
     * @memberof AsSendTaskBatchSendRequest
     */
    'emailMessage': string;
}
/**
 * 
 * @export
 * @interface AsSendTaskBatchSendResponse
 */
export interface AsSendTaskBatchSendResponse {
    /**
     * 
     * @type {Array<any>}
     * @memberof AsSendTaskBatchSendResponse
     */
    'asSendTaskIds'?: Array<any>;
}
/**
 * 
 * @export
 * @interface AsSendTaskDetails
 */
export interface AsSendTaskDetails {
    /**
     * 
     * @type {string}
     * @memberof AsSendTaskDetails
     */
    'asBroadcastId'?: string;
    /**
     * 
     * @type {string}
     * @memberof AsSendTaskDetails
     */
    'sid'?: string;
    /**
     * 
     * @type {string}
     * @memberof AsSendTaskDetails
     */
    'url'?: string;
    /**
     * 
     * @type {string}
     * @memberof AsSendTaskDetails
     */
    'destAddr'?: string;
    /**
     * 
     * @type {string}
     * @memberof AsSendTaskDetails
     */
    'destPersonName'?: string;
    /**
     * 
     * @type {string}
     * @memberof AsSendTaskDetails
     */
    'status'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof AsSendTaskDetails
     */
    'emailSentErrorFlag'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof AsSendTaskDetails
     */
    'emailDateTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof AsSendTaskDetails
     */
    'examStartDateTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof AsSendTaskDetails
     */
    'answeredDateTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof AsSendTaskDetails
     */
    'resultFixedDateTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof AsSendTaskDetails
     */
    'asEmailTemplateId'?: string;
}
/**
 * 
 * @export
 * @interface AssignmentAptitude
 */
export interface AssignmentAptitude {
    /**
     * 
     * @type {Array<string>}
     * @memberof AssignmentAptitude
     */
    'high'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof AssignmentAptitude
     */
    'low'?: Array<string>;
}
/**
 * 
 * @export
 * @interface AttachTag
 */
export interface AttachTag {
    /**
     * 
     * @type {Array<string>}
     * @memberof AttachTag
     */
    'tagIds': Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof AttachTag
     */
    'employeeIds'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof AttachTag
     */
    'applicantIds'?: Array<string>;
}
/**
 * 
 * @export
 * @interface AttachTagResponse
 */
export interface AttachTagResponse {
    /**
     * 
     * @type {string}
     * @memberof AttachTagResponse
     */
    'message'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof AttachTagResponse
     */
    'name_list'?: Array<string>;
}
/**
 * 
 * @export
 * @interface Career
 */
export interface Career {
    /**
     * 
     * @type {string}
     * @memberof Career
     */
    'code': string;
    /**
     * 
     * @type {string}
     * @memberof Career
     */
    'name': string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const CareerEnum = {
    New: 'new',
    Mid: 'mid'
} as const;

export type CareerEnum = typeof CareerEnum[keyof typeof CareerEnum];


/**
 * 
 * @export
 * @interface ChangePasswordRequest
 */
export interface ChangePasswordRequest {
    /**
     * 
     * @type {string}
     * @memberof ChangePasswordRequest
     */
    'username': string;
    /**
     * 
     * @type {string}
     * @memberof ChangePasswordRequest
     */
    'oldpassword': string;
    /**
     * 
     * @type {string}
     * @memberof ChangePasswordRequest
     */
    'newpassword': string;
    /**
     * 
     * @type {string}
     * @memberof ChangePasswordRequest
     */
    'userId'?: string;
}
/**
 * 
 * @export
 * @interface Child
 */
export interface Child {
    /**
     * 
     * @type {string}
     * @memberof Child
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof Child
     */
    'name': string;
    /**
     * 
     * @type {Array<Child>}
     * @memberof Child
     */
    'child'?: Array<Child>;
}
/**
 * 
 * @export
 * @interface Client
 */
export interface Client {
    /**
     * 
     * @type {string}
     * @memberof Client
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof Client
     */
    'name': string;
    /**
     * 
     * @type {Array<ServicePlanEnum>}
     * @memberof Client
     */
    'servicePlans': Array<ServicePlanEnum>;
    /**
     * 
     * @type {PricePlanEnum}
     * @memberof Client
     */
    'pricePlan': PricePlanEnum;
    /**
     * 
     * @type {string}
     * @memberof Client
     */
    'planStart'?: string;
    /**
     * 
     * @type {string}
     * @memberof Client
     */
    'planEnd'?: string;
    /**
     * 
     * @type {string}
     * @memberof Client
     */
    'max_employees'?: string;
    /**
     * 
     * @type {Array<ClientPlanScheduledChange>}
     * @memberof Client
     */
    'scheduledChanges'?: Array<ClientPlanScheduledChange>;
    /**
     * 
     * @type {string}
     * @memberof Client
     */
    'createdAt': string;
}
/**
 * 
 * @export
 * @interface ClientPlanScheduledChange
 */
export interface ClientPlanScheduledChange {
    /**
     * 
     * @type {string}
     * @memberof ClientPlanScheduledChange
     */
    'clientId'?: string;
    /**
     * 
     * @type {string}
     * @memberof ClientPlanScheduledChange
     */
    'plannedDate'?: string;
    /**
     * 
     * @type {ClientScheduledChangeEnum}
     * @memberof ClientPlanScheduledChange
     */
    'plannedAction'?: ClientScheduledChangeEnum;
    /**
     * 
     * @type {PricePlanEnum}
     * @memberof ClientPlanScheduledChange
     */
    'targetPricePlan'?: PricePlanEnum;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const ClientScheduledChangeEnum = {
    ChangePlan: 'ChangePricePlan',
    Delete: 'Delete'
} as const;

export type ClientScheduledChangeEnum = typeof ClientScheduledChangeEnum[keyof typeof ClientScheduledChangeEnum];


/**
 * 
 * @export
 * @interface CodeName
 */
export interface CodeName {
    /**
     * 
     * @type {string}
     * @memberof CodeName
     */
    'code': string;
    /**
     * 
     * @type {string}
     * @memberof CodeName
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface ConfirmForgotPasswordRequest
 */
export interface ConfirmForgotPasswordRequest {
    /**
     * 
     * @type {string}
     * @memberof ConfirmForgotPasswordRequest
     */
    'username': string;
    /**
     * 
     * @type {string}
     * @memberof ConfirmForgotPasswordRequest
     */
    'confirmationCode': string;
    /**
     * 
     * @type {string}
     * @memberof ConfirmForgotPasswordRequest
     */
    'password': string;
}
/**
 * 
 * @export
 * @interface ContractType
 */
export interface ContractType {
    /**
     * 
     * @type {string}
     * @memberof ContractType
     */
    'code'?: string;
    /**
     * 
     * @type {string}
     * @memberof ContractType
     */
    'name'?: string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const ContractTypeEnum = {
    officer: '役員',
    employee: '従業員',
    contracted: '契約社員',
    dispatched: '派遣社員',
    entrustment: '業務委託',
    part: 'パート/アルバイト',
    others: 'その他'
} as const;

export type ContractTypeEnum = typeof ContractTypeEnum[keyof typeof ContractTypeEnum];


/**
 * 
 * @export
 * @interface CreateApplicantRequest
 */
export interface CreateApplicantRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateApplicantRequest
     */
    'firstName': string;
    /**
     * 
     * @type {string}
     * @memberof CreateApplicantRequest
     */
    'lastName': string;
    /**
     * 
     * @type {GenderEnum}
     * @memberof CreateApplicantRequest
     */
    'gender'?: GenderEnum;
    /**
     * 
     * @type {string}
     * @memberof CreateApplicantRequest
     */
    'contractType'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateApplicantRequest
     */
    'career': string;
    /**
     * 
     * @type {string}
     * @memberof CreateApplicantRequest
     */
    'email'?: string;
    /**
     * 
     * @type {ApplicantStatusEnum}
     * @memberof CreateApplicantRequest
     */
    'status': ApplicantStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof CreateApplicantRequest
     */
    'departmentId'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateApplicantRequest
     */
    'occupationId'?: string;
}
/**
 * 
 * @export
 * @interface CreateAsBroadcastRequest
 */
export interface CreateAsBroadcastRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateAsBroadcastRequest
     */
    'name': string;
    /**
     * 
     * @type {AsBroadcastTypeEnum}
     * @memberof CreateAsBroadcastRequest
     */
    'type': AsBroadcastTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof CreateAsBroadcastRequest
     */
    'startDateTime': string;
    /**
     * 
     * @type {string}
     * @memberof CreateAsBroadcastRequest
     */
    'endDateTime': string;
    /**
     * 
     * @type {string}
     * @memberof CreateAsBroadcastRequest
     */
    'completionEmail'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateAsBroadcastRequest
     */
    'employeeIds'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateAsBroadcastRequest
     */
    'applicantIds'?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof CreateAsBroadcastRequest
     */
    'participantRemind'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateAsBroadcastRequest
     */
    'adminRemind'?: boolean;
}
/**
 * 
 * @export
 * @interface CreateAsBroadcastResponse
 */
export interface CreateAsBroadcastResponse {
    /**
     * 
     * @type {string}
     * @memberof CreateAsBroadcastResponse
     */
    'asBroadcastId': string;
    /**
     * 
     * @type {string}
     * @memberof CreateAsBroadcastResponse
     */
    'name': string;
    /**
     * 
     * @type {AsBroadcastTypeEnum}
     * @memberof CreateAsBroadcastResponse
     */
    'type': AsBroadcastTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof CreateAsBroadcastResponse
     */
    'startDateTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateAsBroadcastResponse
     */
    'endDateTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateAsBroadcastResponse
     */
    'completionEmail'?: string;
    /**
     * 
     * @type {Array<any>}
     * @memberof CreateAsBroadcastResponse
     */
    'employeeIds'?: Array<any>;
    /**
     * 
     * @type {Array<any>}
     * @memberof CreateAsBroadcastResponse
     */
    'applicantIds'?: Array<any>;
    /**
     * 
     * @type {Array<any>}
     * @memberof CreateAsBroadcastResponse
     */
    'asSendTaskIds'?: Array<any>;
}
/**
 * 
 * @export
 * @interface CreateClientRequest
 */
export interface CreateClientRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateClientRequest
     */
    'name': string;
    /**
     * 
     * @type {Array<ServicePlanEnum>}
     * @memberof CreateClientRequest
     */
    'servicePlans': Array<ServicePlanEnum>;
    /**
     * 
     * @type {PricePlanEnum}
     * @memberof CreateClientRequest
     */
    'pricePlan': PricePlanEnum;
    /**
     * 
     * @type {string}
     * @memberof CreateClientRequest
     */
    'max_employees'?: string;
}
/**
 * 
 * @export
 * @interface CreateDepartmentRequest
 */
export interface CreateDepartmentRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateDepartmentRequest
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof CreateDepartmentRequest
     */
    'parentId': string;
}
/**
 * 
 * @export
 * @interface CreateEmployee
 */
export interface CreateEmployee {
    /**
     * 
     * @type {string}
     * @memberof CreateEmployee
     */
    'username'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateEmployee
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateEmployee
     */
    'firstName'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateEmployee
     */
    'lastName'?: string;
    /**
     * 
     * @type {GenderEnum}
     * @memberof CreateEmployee
     */
    'gender'?: GenderEnum;
    /**
     * 
     * @type {string}
     * @memberof CreateEmployee
     */
    'contractType'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateEmployee
     */
    'career'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateEmployee
     */
    'enrollment'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateEmployee
     */
    'retirementDate'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateEmployee
     */
    'retirementReasons'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof CreateEmployee
     */
    'departmentId'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateEmployee
     */
    'aditionalDepartmentIds'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateEmployee
     */
    'anotherDepartmentIds'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof CreateEmployee
     */
    'occupationId'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateEmployee
     */
    'positionId'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateEmployee
     */
    'role'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateEmployee
     */
    'noSendInviteMailFlg'?: boolean;
}
/**
 * 
 * @export
 * @interface CreateEmployeeResponse
 */
export interface CreateEmployeeResponse {
    /**
     * 
     * @type {string}
     * @memberof CreateEmployeeResponse
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof CreateEmployeeResponse
     */
    'username': string;
    /**
     * 
     * @type {string}
     * @memberof CreateEmployeeResponse
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof CreateEmployeeResponse
     */
    'firstName': string;
    /**
     * 
     * @type {string}
     * @memberof CreateEmployeeResponse
     */
    'lastName': string;
    /**
     * 
     * @type {GenderEnum}
     * @memberof CreateEmployeeResponse
     */
    'gender'?: GenderEnum;
    /**
     * 
     * @type {string}
     * @memberof CreateEmployeeResponse
     */
    'enrollment': string;
    /**
     * 
     * @type {string}
     * @memberof CreateEmployeeResponse
     */
    'retirementDate'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateEmployeeResponse
     */
    'retirementReasons'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof CreateEmployeeResponse
     */
    'departmentId': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateEmployeeResponse
     */
    'aditionalDepartmentIds'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateEmployeeResponse
     */
    'anotherDepartmentIds'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof CreateEmployeeResponse
     */
    'occupationId': string;
    /**
     * 
     * @type {string}
     * @memberof CreateEmployeeResponse
     */
    'positionId'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateEmployeeResponse
     */
    'role': string;
}
/**
 * 
 * @export
 * @interface CreateHrCriteriaRequest
 */
export interface CreateHrCriteriaRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateHrCriteriaRequest
     */
    'name': string;
    /**
     * 
     * @type {Array<GetHrCriterionCriteriaItem>}
     * @memberof CreateHrCriteriaRequest
     */
    'criteria'?: Array<GetHrCriterionCriteriaItem>;
}
/**
 * 
 * @export
 * @interface CreatePositionRequest
 */
export interface CreatePositionRequest {
    /**
     * 
     * @type {string}
     * @memberof CreatePositionRequest
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface CreateTag
 */
export interface CreateTag {
    /**
     * 
     * @type {string}
     * @memberof CreateTag
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof CreateTag
     */
    'type': string;
}
/**
 * 
 * @export
 * @interface CreateTrialAccountRequest
 */
export interface CreateTrialAccountRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateTrialAccountRequest
     */
    'clientName'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateTrialAccountRequest
     */
    'departmentNames': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof CreateTrialAccountRequest
     */
    'maxEmployees': string;
}
/**
 * 
 * @export
 * @interface CreateUserRequest
 */
export interface CreateUserRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateUserRequest
     */
    'username': string;
    /**
     * 
     * @type {string}
     * @memberof CreateUserRequest
     */
    'firstName': string;
    /**
     * 
     * @type {string}
     * @memberof CreateUserRequest
     */
    'lastName': string;
    /**
     * 
     * @type {string}
     * @memberof CreateUserRequest
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof CreateUserRequest
     */
    'role': string;
}
/**
 * 
 * @export
 * @interface CriteriaJudgmentResultItem
 */
export interface CriteriaJudgmentResultItem {
    /**
     * 
     * @type {string}
     * @memberof CriteriaJudgmentResultItem
     */
    'code'?: string;
    /**
     * 
     * @type {string}
     * @memberof CriteriaJudgmentResultItem
     */
    'point'?: string;
}
/**
 * 
 * @export
 * @interface DeleteAsSendTasksRequest
 */
export interface DeleteAsSendTasksRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof DeleteAsSendTasksRequest
     */
    'asSendTaskIds'?: Array<string>;
}
/**
 * 
 * @export
 * @interface Department
 */
export interface Department {
    /**
     * 
     * @type {string}
     * @memberof Department
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof Department
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface DepartmentHierarchy
 */
export interface DepartmentHierarchy {
    /**
     * 
     * @type {string}
     * @memberof DepartmentHierarchy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof DepartmentHierarchy
     */
    'name': string;
    /**
     * 
     * @type {Array<Child>}
     * @memberof DepartmentHierarchy
     */
    'child'?: Array<Child>;
}
/**
 * 
 * @export
 * @interface DetachTag
 */
export interface DetachTag {
    /**
     * 
     * @type {Array<string>}
     * @memberof DetachTag
     */
    'employeeIds'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof DetachTag
     */
    'applicantIds'?: Array<string>;
}
/**
 * 
 * @export
 * @interface EmailTemplateCreate
 */
export interface EmailTemplateCreate {
    /**
     * 
     * @type {EmailTemplateTypeEnum}
     * @memberof EmailTemplateCreate
     */
    'emailTemplateType': EmailTemplateTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof EmailTemplateCreate
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof EmailTemplateCreate
     */
    'message': string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const EmailTemplateTypeEnum = {
    As: 'as'
} as const;

export type EmailTemplateTypeEnum = typeof EmailTemplateTypeEnum[keyof typeof EmailTemplateTypeEnum];


/**
 * 
 * @export
 * @interface EmailTemplateUpdate
 */
export interface EmailTemplateUpdate {
    /**
     * 
     * @type {string}
     * @memberof EmailTemplateUpdate
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof EmailTemplateUpdate
     */
    'message': string;
}
/**
 * 
 * @export
 * @interface Employee
 */
export interface Employee {
    /**
     * 
     * @type {string}
     * @memberof Employee
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof Employee
     */
    'username': string;
    /**
     * 
     * @type {string}
     * @memberof Employee
     */
    'firstName': string;
    /**
     * 
     * @type {string}
     * @memberof Employee
     */
    'lastName': string;
    /**
     * 
     * @type {string}
     * @memberof Employee
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof Employee
     */
    'image'?: string;
    /**
     * 
     * @type {string}
     * @memberof Employee
     */
    'employeeId'?: string;
    /**
     * 
     * @type {string}
     * @memberof Employee
     */
    'role': string;
    /**
     * 
     * @type {string}
     * @memberof Employee
     */
    'userId': string;
    /**
     * 
     * @type {GenderEnum}
     * @memberof Employee
     */
    'gender'?: GenderEnum;
    /**
     * 
     * @type {string}
     * @memberof Employee
     */
    'contractType'?: string;
    /**
     * 
     * @type {string}
     * @memberof Employee
     */
    'career'?: string;
    /**
     * 
     * @type {string}
     * @memberof Employee
     */
    'enrollment'?: string;
    /**
     * 
     * @type {string}
     * @memberof Employee
     */
    'retirementDate'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof Employee
     */
    'retirementReasons'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof Employee
     */
    'departmentId': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof Employee
     */
    'aditionalDepartmentIds'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof Employee
     */
    'anotherDepartmentIds'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof Employee
     */
    'occupationId': string;
    /**
     * 
     * @type {string}
     * @memberof Employee
     */
    'positionId'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Employee
     */
    'noSendInviteMailFlg'?: boolean;
}
/**
 * 
 * @export
 * @interface EmployeeAllOf
 */
export interface EmployeeAllOf {
    /**
     * 
     * @type {string}
     * @memberof EmployeeAllOf
     */
    'userId': string;
    /**
     * 
     * @type {GenderEnum}
     * @memberof EmployeeAllOf
     */
    'gender'?: GenderEnum;
    /**
     * 
     * @type {string}
     * @memberof EmployeeAllOf
     */
    'contractType'?: string;
    /**
     * 
     * @type {string}
     * @memberof EmployeeAllOf
     */
    'career'?: string;
    /**
     * 
     * @type {string}
     * @memberof EmployeeAllOf
     */
    'enrollment'?: string;
    /**
     * 
     * @type {string}
     * @memberof EmployeeAllOf
     */
    'retirementDate'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof EmployeeAllOf
     */
    'retirementReasons'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof EmployeeAllOf
     */
    'departmentId': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof EmployeeAllOf
     */
    'aditionalDepartmentIds'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof EmployeeAllOf
     */
    'anotherDepartmentIds'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof EmployeeAllOf
     */
    'occupationId': string;
    /**
     * 
     * @type {string}
     * @memberof EmployeeAllOf
     */
    'positionId'?: string;
    /**
     * 
     * @type {string}
     * @memberof EmployeeAllOf
     */
    'role'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof EmployeeAllOf
     */
    'noSendInviteMailFlg'?: boolean;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const EnrollmentEnum = {
    enrolled: '在籍中',
    leave: '休職中',
    retiring: '退職予定',
    retired: '退職済'
} as const;

export type EnrollmentEnum = typeof EnrollmentEnum[keyof typeof EnrollmentEnum];


/**
 * 
 * @export
 * @interface ErrorData
 */
export interface ErrorData {
    /**
     * A message describing this error
     * @type {string}
     * @memberof ErrorData
     */
    'message': string;
    /**
     * The name spcifying a validated field
     * @type {string}
     * @memberof ErrorData
     */
    'field'?: string;
    /**
     * 
     * @type {ErrorDataValue}
     * @memberof ErrorData
     */
    'value'?: ErrorDataValue;
}
/**
 * @type ErrorDataValue
 * Given value in the field
 * @export
 */
export type ErrorDataValue = boolean | number | object | string;

/**
 * 
 * @export
 * @interface ErrorResponse
 */
export interface ErrorResponse {
    /**
     * An error message describing this error
     * @type {string}
     * @memberof ErrorResponse
     */
    'message': string;
    /**
     * HTTP status code describing this error
     * @type {number}
     * @memberof ErrorResponse
     */
    'statusCode': number;
    /**
     * HTTP status message describing this error
     * @type {string}
     * @memberof ErrorResponse
     */
    'error': string;
    /**
     * 
     * @type {Array<ErrorData>}
     * @memberof ErrorResponse
     */
    'errorData'?: Array<ErrorData>;
}
/**
 * 
 * @export
 * @interface ForgotPasswordRequest
 */
export interface ForgotPasswordRequest {
    /**
     * 
     * @type {string}
     * @memberof ForgotPasswordRequest
     */
    'username': string;
    /**
     * 
     * @type {string}
     * @memberof ForgotPasswordRequest
     */
    'email'?: string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const GenderEnum = {
    Male: 'Male',
    Female: 'Female',
    Unknown: 'Unknown'
} as const;

export type GenderEnum = typeof GenderEnum[keyof typeof GenderEnum];


/**
 * 
 * @export
 * @interface GetAccessLogs200Response
 */
export interface GetAccessLogs200Response {
    /**
     * 
     * @type {string}
     * @memberof GetAccessLogs200Response
     */
    'offset'?: string;
    /**
     * 
     * @type {Array<AccessLog>}
     * @memberof GetAccessLogs200Response
     */
    'lists'?: Array<AccessLog>;
}
/**
 * 
 * @export
 * @interface GetActivityMotivationDetail
 */
export interface GetActivityMotivationDetail {
    /**
     * 
     * @type {string}
     * @memberof GetActivityMotivationDetail
     */
    'description'?: string;
    /**
     * 
     * @type {Array<GetActivityMotivationDetailItemsInner>}
     * @memberof GetActivityMotivationDetail
     */
    'items'?: Array<GetActivityMotivationDetailItemsInner>;
}
/**
 * 
 * @export
 * @interface GetActivityMotivationDetailItemsInner
 */
export interface GetActivityMotivationDetailItemsInner {
    /**
     * 
     * @type {string}
     * @memberof GetActivityMotivationDetailItemsInner
     */
    'name'?: string;
    /**
     * 
     * @type {number}
     * @memberof GetActivityMotivationDetailItemsInner
     */
    'value'?: number;
    /**
     * 
     * @type {string}
     * @memberof GetActivityMotivationDetailItemsInner
     */
    'description'?: string;
    /**
     * 
     * @type {PersonalityDetailItemTooltip}
     * @memberof GetActivityMotivationDetailItemsInner
     */
    'tooltip'?: PersonalityDetailItemTooltip;
}
/**
 * 
 * @export
 * @interface GetApplicantProfile
 */
export interface GetApplicantProfile {
    /**
     * 
     * @type {string}
     * @memberof GetApplicantProfile
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetApplicantProfile
     */
    'username'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetApplicantProfile
     */
    'firstName': string;
    /**
     * 
     * @type {string}
     * @memberof GetApplicantProfile
     */
    'lastName': string;
    /**
     * 
     * @type {string}
     * @memberof GetApplicantProfile
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof GetApplicantProfile
     */
    'image'?: string;
    /**
     * 
     * @type {GenderEnum}
     * @memberof GetApplicantProfile
     */
    'gender'?: GenderEnum;
    /**
     * 
     * @type {Department}
     * @memberof GetApplicantProfile
     */
    'department'?: Department;
    /**
     * 
     * @type {Array<GetTagResponse>}
     * @memberof GetApplicantProfile
     */
    'tags'?: Array<GetTagResponse>;
    /**
     * 
     * @type {ContractType}
     * @memberof GetApplicantProfile
     */
    'contractType'?: ContractType;
    /**
     * 
     * @type {Career}
     * @memberof GetApplicantProfile
     */
    'career'?: Career;
    /**
     * 
     * @type {GetApplicantProfileAllOfPosition}
     * @memberof GetApplicantProfile
     */
    'position'?: GetApplicantProfileAllOfPosition;
    /**
     * 
     * @type {Occupation}
     * @memberof GetApplicantProfile
     */
    'occupation'?: Occupation;
    /**
     * 
     * @type {ApplicantStatus}
     * @memberof GetApplicantProfile
     */
    'status'?: ApplicantStatus;
    /**
     * 
     * @type {string}
     * @memberof GetApplicantProfile
     */
    'lastExamDate'?: string;
}
/**
 * 
 * @export
 * @interface GetApplicantProfileAllOf
 */
export interface GetApplicantProfileAllOf {
    /**
     * 
     * @type {ContractType}
     * @memberof GetApplicantProfileAllOf
     */
    'contractType'?: ContractType;
    /**
     * 
     * @type {Career}
     * @memberof GetApplicantProfileAllOf
     */
    'career'?: Career;
    /**
     * 
     * @type {GetApplicantProfileAllOfPosition}
     * @memberof GetApplicantProfileAllOf
     */
    'position'?: GetApplicantProfileAllOfPosition;
    /**
     * 
     * @type {Department}
     * @memberof GetApplicantProfileAllOf
     */
    'department'?: Department;
    /**
     * 
     * @type {Occupation}
     * @memberof GetApplicantProfileAllOf
     */
    'occupation'?: Occupation;
    /**
     * 
     * @type {ApplicantStatus}
     * @memberof GetApplicantProfileAllOf
     */
    'status'?: ApplicantStatus;
    /**
     * 
     * @type {string}
     * @memberof GetApplicantProfileAllOf
     */
    'lastExamDate'?: string;
}
/**
 * 
 * @export
 * @interface GetApplicantProfileAllOfPosition
 */
export interface GetApplicantProfileAllOfPosition {
    /**
     * 
     * @type {string}
     * @memberof GetApplicantProfileAllOfPosition
     */
    'name'?: string;
}
/**
 * 
 * @export
 * @interface GetApplicants200Response
 */
export interface GetApplicants200Response {
    /**
     * 
     * @type {string}
     * @memberof GetApplicants200Response
     */
    'totalCount'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetApplicants200Response
     */
    'offset'?: string;
    /**
     * 
     * @type {Array<GetApplicantProfile>}
     * @memberof GetApplicants200Response
     */
    'lists'?: Array<GetApplicantProfile>;
}
/**
 * 
 * @export
 * @interface GetAsBroadcast
 */
export interface GetAsBroadcast {
    /**
     * 
     * @type {string}
     * @memberof GetAsBroadcast
     */
    'asBroadcastId': string;
    /**
     * 
     * @type {string}
     * @memberof GetAsBroadcast
     */
    'name': string;
    /**
     * 
     * @type {AsBroadcastTypeEnum}
     * @memberof GetAsBroadcast
     */
    'type': AsBroadcastTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof GetAsBroadcast
     */
    'startDateTime': string;
    /**
     * 
     * @type {string}
     * @memberof GetAsBroadcast
     */
    'endDateTime': string;
    /**
     * 
     * @type {boolean}
     * @memberof GetAsBroadcast
     */
    'participantRemind'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetAsBroadcast
     */
    'adminRemind'?: boolean;
}
/**
 * 
 * @export
 * @interface GetAsBroadcastDetail
 */
export interface GetAsBroadcastDetail {
    /**
     * 
     * @type {string}
     * @memberof GetAsBroadcastDetail
     */
    'completionEmail'?: string;
    /**
     * 
     * @type {Array<GetAsBroadcastDetailEmployeesInner>}
     * @memberof GetAsBroadcastDetail
     */
    'employees'?: Array<GetAsBroadcastDetailEmployeesInner>;
    /**
     * 
     * @type {Array<GetAsBroadcastDetailApplicantsInner>}
     * @memberof GetAsBroadcastDetail
     */
    'applicants'?: Array<GetAsBroadcastDetailApplicantsInner>;
}
/**
 * 
 * @export
 * @interface GetAsBroadcastDetailApplicantsInner
 */
export interface GetAsBroadcastDetailApplicantsInner {
    /**
     * 
     * @type {string}
     * @memberof GetAsBroadcastDetailApplicantsInner
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetAsBroadcastDetailApplicantsInner
     */
    'username'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetAsBroadcastDetailApplicantsInner
     */
    'firstName': string;
    /**
     * 
     * @type {string}
     * @memberof GetAsBroadcastDetailApplicantsInner
     */
    'lastName': string;
    /**
     * 
     * @type {string}
     * @memberof GetAsBroadcastDetailApplicantsInner
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof GetAsBroadcastDetailApplicantsInner
     */
    'image'?: string;
    /**
     * 
     * @type {GenderEnum}
     * @memberof GetAsBroadcastDetailApplicantsInner
     */
    'gender'?: GenderEnum;
    /**
     * 
     * @type {Department}
     * @memberof GetAsBroadcastDetailApplicantsInner
     */
    'department'?: Department;
    /**
     * 
     * @type {Array<GetTagResponse>}
     * @memberof GetAsBroadcastDetailApplicantsInner
     */
    'tags'?: Array<GetTagResponse>;
    /**
     * 
     * @type {ContractType}
     * @memberof GetAsBroadcastDetailApplicantsInner
     */
    'contractType'?: ContractType;
    /**
     * 
     * @type {Career}
     * @memberof GetAsBroadcastDetailApplicantsInner
     */
    'career'?: Career;
    /**
     * 
     * @type {GetApplicantProfileAllOfPosition}
     * @memberof GetAsBroadcastDetailApplicantsInner
     */
    'position'?: GetApplicantProfileAllOfPosition;
    /**
     * 
     * @type {Occupation}
     * @memberof GetAsBroadcastDetailApplicantsInner
     */
    'occupation'?: Occupation;
    /**
     * 
     * @type {ApplicantStatus}
     * @memberof GetAsBroadcastDetailApplicantsInner
     */
    'status'?: ApplicantStatus;
    /**
     * 
     * @type {string}
     * @memberof GetAsBroadcastDetailApplicantsInner
     */
    'lastExamDate'?: string;
    /**
     * 
     * @type {GetAsBroadcastStatusSendTask}
     * @memberof GetAsBroadcastDetailApplicantsInner
     */
    'sendTask'?: GetAsBroadcastStatusSendTask;
}
/**
 * 
 * @export
 * @interface GetAsBroadcastDetailEmployeesInner
 */
export interface GetAsBroadcastDetailEmployeesInner {
    /**
     * 
     * @type {string}
     * @memberof GetAsBroadcastDetailEmployeesInner
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetAsBroadcastDetailEmployeesInner
     */
    'username': string;
    /**
     * 
     * @type {string}
     * @memberof GetAsBroadcastDetailEmployeesInner
     */
    'firstName': string;
    /**
     * 
     * @type {string}
     * @memberof GetAsBroadcastDetailEmployeesInner
     */
    'lastName': string;
    /**
     * 
     * @type {string}
     * @memberof GetAsBroadcastDetailEmployeesInner
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof GetAsBroadcastDetailEmployeesInner
     */
    'image'?: string;
    /**
     * 
     * @type {GenderEnum}
     * @memberof GetAsBroadcastDetailEmployeesInner
     */
    'gender'?: GenderEnum;
    /**
     * 
     * @type {Department}
     * @memberof GetAsBroadcastDetailEmployeesInner
     */
    'department'?: Department;
    /**
     * 
     * @type {Array<GetTagResponse>}
     * @memberof GetAsBroadcastDetailEmployeesInner
     */
    'tags'?: Array<GetTagResponse>;
    /**
     * 
     * @type {string}
     * @memberof GetAsBroadcastDetailEmployeesInner
     */
    'userId': string;
    /**
     * 
     * @type {string}
     * @memberof GetAsBroadcastDetailEmployeesInner
     */
    'role'?: string;
    /**
     * 
     * @type {Occupation}
     * @memberof GetAsBroadcastDetailEmployeesInner
     */
    'occupation'?: Occupation;
    /**
     * 
     * @type {Position}
     * @memberof GetAsBroadcastDetailEmployeesInner
     */
    'position'?: Position;
    /**
     * 
     * @type {ContractType}
     * @memberof GetAsBroadcastDetailEmployeesInner
     */
    'contractType'?: ContractType;
    /**
     * 
     * @type {Career}
     * @memberof GetAsBroadcastDetailEmployeesInner
     */
    'career'?: Career;
    /**
     * 
     * @type {string}
     * @memberof GetAsBroadcastDetailEmployeesInner
     */
    'enrollment'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetAsBroadcastDetailEmployeesInner
     */
    'retirementDate'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetAsBroadcastDetailEmployeesInner
     */
    'retirementReasons'?: Array<string>;
    /**
     * 
     * @type {Array<Department>}
     * @memberof GetAsBroadcastDetailEmployeesInner
     */
    'additionalDepartments'?: Array<Department>;
    /**
     * 
     * @type {Array<Department>}
     * @memberof GetAsBroadcastDetailEmployeesInner
     */
    'anotherDepartments'?: Array<Department>;
    /**
     * 
     * @type {string}
     * @memberof GetAsBroadcastDetailEmployeesInner
     */
    'lastExamDate'?: string;
    /**
     * 
     * @type {GetAsBroadcastStatusSendTask}
     * @memberof GetAsBroadcastDetailEmployeesInner
     */
    'sendTask'?: GetAsBroadcastStatusSendTask;
}
/**
 * 
 * @export
 * @interface GetAsBroadcastResponse
 */
export interface GetAsBroadcastResponse {
    /**
     * 
     * @type {string}
     * @memberof GetAsBroadcastResponse
     */
    'asBroadcastId': string;
    /**
     * 
     * @type {string}
     * @memberof GetAsBroadcastResponse
     */
    'name': string;
    /**
     * 
     * @type {AsBroadcastTypeEnum}
     * @memberof GetAsBroadcastResponse
     */
    'type': AsBroadcastTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof GetAsBroadcastResponse
     */
    'startDateTime': string;
    /**
     * 
     * @type {string}
     * @memberof GetAsBroadcastResponse
     */
    'endDateTime': string;
    /**
     * 
     * @type {boolean}
     * @memberof GetAsBroadcastResponse
     */
    'participantRemind'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetAsBroadcastResponse
     */
    'adminRemind'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof GetAsBroadcastResponse
     */
    'completionEmail'?: string;
    /**
     * 
     * @type {Array<GetAsBroadcastDetailEmployeesInner>}
     * @memberof GetAsBroadcastResponse
     */
    'employees'?: Array<GetAsBroadcastDetailEmployeesInner>;
    /**
     * 
     * @type {Array<GetAsBroadcastDetailApplicantsInner>}
     * @memberof GetAsBroadcastResponse
     */
    'applicants'?: Array<GetAsBroadcastDetailApplicantsInner>;
}
/**
 * 
 * @export
 * @interface GetAsBroadcastStatus
 */
export interface GetAsBroadcastStatus {
    /**
     * 
     * @type {GetAsBroadcastStatusSendTask}
     * @memberof GetAsBroadcastStatus
     */
    'sendTask'?: GetAsBroadcastStatusSendTask;
}
/**
 * 
 * @export
 * @interface GetAsBroadcastStatusSendTask
 */
export interface GetAsBroadcastStatusSendTask {
    /**
     * 
     * @type {string}
     * @memberof GetAsBroadcastStatusSendTask
     */
    'asSendTaskId': string;
    /**
     * 
     * @type {string}
     * @memberof GetAsBroadcastStatusSendTask
     */
    'sid': string;
    /**
     * 
     * @type {string}
     * @memberof GetAsBroadcastStatusSendTask
     */
    'url'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof GetAsBroadcastStatusSendTask
     */
    'emailSentErrorFlag'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof GetAsBroadcastStatusSendTask
     */
    'emailDateTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetAsBroadcastStatusSendTask
     */
    'answeredDateTime'?: string;
    /**
     * 
     * @type {AsBroadcastStatusEnum}
     * @memberof GetAsBroadcastStatusSendTask
     */
    'status'?: AsBroadcastStatusEnum;
}
/**
 * 
 * @export
 * @interface GetAsBroadcasts
 */
export interface GetAsBroadcasts {
    /**
     * 
     * @type {string}
     * @memberof GetAsBroadcasts
     */
    'asBroadcastId': string;
    /**
     * 
     * @type {string}
     * @memberof GetAsBroadcasts
     */
    'name': string;
    /**
     * 
     * @type {AsBroadcastTypeEnum}
     * @memberof GetAsBroadcasts
     */
    'type': AsBroadcastTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof GetAsBroadcasts
     */
    'startDateTime': string;
    /**
     * 
     * @type {string}
     * @memberof GetAsBroadcasts
     */
    'endDateTime': string;
    /**
     * 
     * @type {boolean}
     * @memberof GetAsBroadcasts
     */
    'participantRemind'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetAsBroadcasts
     */
    'adminRemind'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof GetAsBroadcasts
     */
    'participantsCount': number;
    /**
     * 
     * @type {number}
     * @memberof GetAsBroadcasts
     */
    'participatedCount': number;
}
/**
 * 
 * @export
 * @interface GetAsBroadcastsAllOf
 */
export interface GetAsBroadcastsAllOf {
    /**
     * 
     * @type {number}
     * @memberof GetAsBroadcastsAllOf
     */
    'participantsCount': number;
    /**
     * 
     * @type {number}
     * @memberof GetAsBroadcastsAllOf
     */
    'participatedCount': number;
}
/**
 * 
 * @export
 * @interface GetBehavior
 */
export interface GetBehavior {
    /**
     * 
     * @type {number}
     * @memberof GetBehavior
     */
    'x': number;
    /**
     * 
     * @type {number}
     * @memberof GetBehavior
     */
    'y': number;
}
/**
 * 
 * @export
 * @interface GetCriteriaItem
 */
export interface GetCriteriaItem {
    /**
     * 
     * @type {string}
     * @memberof GetCriteriaItem
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetCriteriaItem
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface GetCriteriaJudgmentItem
 */
export interface GetCriteriaJudgmentItem {
    /**
     * 
     * @type {string}
     * @memberof GetCriteriaJudgmentItem
     */
    'name'?: string;
    /**
     * 
     * @type {Array<number>}
     * @memberof GetCriteriaJudgmentItem
     */
    'range'?: Array<number>;
    /**
     * 
     * @type {number}
     * @memberof GetCriteriaJudgmentItem
     */
    'point': number;
    /**
     * 
     * @type {string}
     * @memberof GetCriteriaJudgmentItem
     */
    'judgmentResult'?: string;
}
/**
 * 
 * @export
 * @interface GetDepartmentResponse
 */
export interface GetDepartmentResponse {
    /**
     * 
     * @type {string}
     * @memberof GetDepartmentResponse
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetDepartmentResponse
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof GetDepartmentResponse
     */
    'parentId'?: string;
    /**
     * 
     * @type {Array<IdName>}
     * @memberof GetDepartmentResponse
     */
    'selectableParents': Array<IdName>;
}
/**
 * 
 * @export
 * @interface GetEmailTemplate
 */
export interface GetEmailTemplate {
    /**
     * 
     * @type {string}
     * @memberof GetEmailTemplate
     */
    'emailTemplateId': string;
    /**
     * 
     * @type {string}
     * @memberof GetEmailTemplate
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof GetEmailTemplate
     */
    'message': string;
    /**
     * 
     * @type {string}
     * @memberof GetEmailTemplate
     */
    'sourceEmailAddress': string;
}
/**
 * 
 * @export
 * @interface GetEmployeeProfile
 */
export interface GetEmployeeProfile {
    /**
     * 
     * @type {string}
     * @memberof GetEmployeeProfile
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetEmployeeProfile
     */
    'username': string;
    /**
     * 
     * @type {string}
     * @memberof GetEmployeeProfile
     */
    'firstName': string;
    /**
     * 
     * @type {string}
     * @memberof GetEmployeeProfile
     */
    'lastName': string;
    /**
     * 
     * @type {string}
     * @memberof GetEmployeeProfile
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof GetEmployeeProfile
     */
    'image'?: string;
    /**
     * 
     * @type {GenderEnum}
     * @memberof GetEmployeeProfile
     */
    'gender'?: GenderEnum;
    /**
     * 
     * @type {Department}
     * @memberof GetEmployeeProfile
     */
    'department'?: Department;
    /**
     * 
     * @type {Array<GetTagResponse>}
     * @memberof GetEmployeeProfile
     */
    'tags'?: Array<GetTagResponse>;
    /**
     * 
     * @type {string}
     * @memberof GetEmployeeProfile
     */
    'userId': string;
    /**
     * 
     * @type {string}
     * @memberof GetEmployeeProfile
     */
    'role'?: string;
    /**
     * 
     * @type {Occupation}
     * @memberof GetEmployeeProfile
     */
    'occupation'?: Occupation;
    /**
     * 
     * @type {Position}
     * @memberof GetEmployeeProfile
     */
    'position'?: Position;
    /**
     * 
     * @type {ContractType}
     * @memberof GetEmployeeProfile
     */
    'contractType'?: ContractType;
    /**
     * 
     * @type {Career}
     * @memberof GetEmployeeProfile
     */
    'career'?: Career;
    /**
     * 
     * @type {string}
     * @memberof GetEmployeeProfile
     */
    'enrollment'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetEmployeeProfile
     */
    'retirementDate'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetEmployeeProfile
     */
    'retirementReasons'?: Array<string>;
    /**
     * 
     * @type {Array<Department>}
     * @memberof GetEmployeeProfile
     */
    'additionalDepartments'?: Array<Department>;
    /**
     * 
     * @type {Array<Department>}
     * @memberof GetEmployeeProfile
     */
    'anotherDepartments'?: Array<Department>;
    /**
     * 
     * @type {string}
     * @memberof GetEmployeeProfile
     */
    'lastExamDate'?: string;
}
/**
 * 
 * @export
 * @interface GetEmployeeProfileAllOf
 */
export interface GetEmployeeProfileAllOf {
    /**
     * 
     * @type {string}
     * @memberof GetEmployeeProfileAllOf
     */
    'userId': string;
    /**
     * 
     * @type {string}
     * @memberof GetEmployeeProfileAllOf
     */
    'username': string;
    /**
     * 
     * @type {string}
     * @memberof GetEmployeeProfileAllOf
     */
    'role'?: string;
    /**
     * 
     * @type {Department}
     * @memberof GetEmployeeProfileAllOf
     */
    'department'?: Department;
    /**
     * 
     * @type {Occupation}
     * @memberof GetEmployeeProfileAllOf
     */
    'occupation'?: Occupation;
    /**
     * 
     * @type {Position}
     * @memberof GetEmployeeProfileAllOf
     */
    'position'?: Position;
    /**
     * 
     * @type {ContractType}
     * @memberof GetEmployeeProfileAllOf
     */
    'contractType'?: ContractType;
    /**
     * 
     * @type {Career}
     * @memberof GetEmployeeProfileAllOf
     */
    'career'?: Career;
    /**
     * 
     * @type {string}
     * @memberof GetEmployeeProfileAllOf
     */
    'enrollment'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetEmployeeProfileAllOf
     */
    'retirementDate'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetEmployeeProfileAllOf
     */
    'retirementReasons'?: Array<string>;
    /**
     * 
     * @type {Array<Department>}
     * @memberof GetEmployeeProfileAllOf
     */
    'additionalDepartments'?: Array<Department>;
    /**
     * 
     * @type {Array<Department>}
     * @memberof GetEmployeeProfileAllOf
     */
    'anotherDepartments'?: Array<Department>;
    /**
     * 
     * @type {string}
     * @memberof GetEmployeeProfileAllOf
     */
    'lastExamDate'?: string;
}
/**
 * 
 * @export
 * @interface GetEmployees200Response
 */
export interface GetEmployees200Response {
    /**
     * 
     * @type {string}
     * @memberof GetEmployees200Response
     */
    'offset'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetEmployees200Response
     */
    'totalCount'?: string;
    /**
     * 
     * @type {Array<GetEmployeeProfile>}
     * @memberof GetEmployees200Response
     */
    'lists'?: Array<GetEmployeeProfile>;
}
/**
 * 
 * @export
 * @interface GetExamDate
 */
export interface GetExamDate {
    /**
     * 
     * @type {Array<string>}
     * @memberof GetExamDate
     */
    'examDates'?: Array<string>;
}
/**
 * 
 * @export
 * @interface GetHrCriterion
 */
export interface GetHrCriterion {
    /**
     * 
     * @type {string}
     * @memberof GetHrCriterion
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetHrCriterion
     */
    'name': string;
    /**
     * 
     * @type {Array<GetHrCriterionCriteriaItem>}
     * @memberof GetHrCriterion
     */
    'criteria': Array<GetHrCriterionCriteriaItem>;
    /**
     * 
     * @type {number}
     * @memberof GetHrCriterion
     */
    'result'?: number;
    /**
     * 
     * @type {number}
     * @memberof GetHrCriterion
     */
    'fitnessPoint'?: number;
}
/**
 * 
 * @export
 * @interface GetHrCriterionCriteriaItem
 */
export interface GetHrCriterionCriteriaItem {
    /**
     * 
     * @type {string}
     * @memberof GetHrCriterionCriteriaItem
     */
    'code': string;
    /**
     * 
     * @type {string}
     * @memberof GetHrCriterionCriteriaItem
     */
    'name'?: string;
    /**
     * 
     * @type {number}
     * @memberof GetHrCriterionCriteriaItem
     */
    'thresholdMin': number;
    /**
     * 
     * @type {number}
     * @memberof GetHrCriterionCriteriaItem
     */
    'thresholdMax': number;
    /**
     * 
     * @type {number}
     * @memberof GetHrCriterionCriteriaItem
     */
    'point'?: number;
    /**
     * 
     * @type {string}
     * @memberof GetHrCriterionCriteriaItem
     */
    'judgmentResult'?: string;
}
/**
 * 
 * @export
 * @interface GetHrCriterionItem
 */
export interface GetHrCriterionItem {
    /**
     * 
     * @type {string}
     * @memberof GetHrCriterionItem
     */
    'code': string;
    /**
     * 
     * @type {string}
     * @memberof GetHrCriterionItem
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface GetJudgement
 */
export interface GetJudgement {
    /**
     * 
     * @type {GetJudgementOverall}
     * @memberof GetJudgement
     */
    'overall': GetJudgementOverall;
    /**
     * 
     * @type {Array<TendencyItem>}
     * @memberof GetJudgement
     */
    'tendency': Array<TendencyItem>;
    /**
     * 
     * @type {Array<SocialityItem>}
     * @memberof GetJudgement
     */
    'jobAptitude': Array<SocialityItem>;
    /**
     * 
     * @type {AssignmentAptitude}
     * @memberof GetJudgement
     */
    'assignmentAptitude1': AssignmentAptitude;
    /**
     * 
     * @type {AssignmentAptitude}
     * @memberof GetJudgement
     */
    'assignmentAptitude2': AssignmentAptitude;
    /**
     * 
     * @type {AssignmentAptitude}
     * @memberof GetJudgement
     */
    'assignmentAptitude3': AssignmentAptitude;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetJudgement
     */
    'jobInterst'?: Array<string>;
}
/**
 * 
 * @export
 * @interface GetJudgementOverall
 */
export interface GetJudgementOverall {
    /**
     * 
     * @type {number}
     * @memberof GetJudgementOverall
     */
    'stability': number;
    /**
     * 
     * @type {string}
     * @memberof GetJudgementOverall
     */
    'evaluation': string;
}
/**
 * 
 * @export
 * @interface GetLogin
 */
export interface GetLogin {
    /**
     * 
     * @type {string}
     * @memberof GetLogin
     */
    'clientId': string;
    /**
     * 
     * @type {string}
     * @memberof GetLogin
     */
    'departmentId': string;
    /**
     * 
     * @type {User}
     * @memberof GetLogin
     */
    'user': User;
    /**
     * 
     * @type {string}
     * @memberof GetLogin
     */
    'pricePlan': string;
    /**
     * 
     * @type {string}
     * @memberof GetLogin
     */
    'planStart'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetLogin
     */
    'planEnd'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof GetLogin
     */
    'isUpgradeScheduled'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetLogin
     */
    'isDeleteScheduled'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof GetLogin
     */
    'employeeId'?: string;
}
/**
 * 
 * @export
 * @interface GetPDAnalytics
 */
export interface GetPDAnalytics {
    /**
     * 
     * @type {GetProfile}
     * @memberof GetPDAnalytics
     */
    'partner': GetProfile;
    /**
     * 
     * @type {number}
     * @memberof GetPDAnalytics
     */
    'staticValue': number;
    /**
     * 
     * @type {number}
     * @memberof GetPDAnalytics
     */
    'dynamicValue': number;
}
/**
 * 
 * @export
 * @interface GetPMAnalytics
 */
export interface GetPMAnalytics {
    /**
     * 
     * @type {number}
     * @memberof GetPMAnalytics
     */
    'performance'?: number;
    /**
     * 
     * @type {number}
     * @memberof GetPMAnalytics
     */
    'maintenance'?: number;
}
/**
 * 
 * @export
 * @interface GetPersonalityDetail
 */
export interface GetPersonalityDetail {
    /**
     * 
     * @type {Array<string>}
     * @memberof GetPersonalityDetail
     */
    'description': Array<string>;
    /**
     * 
     * @type {Array<PersonalityDetailItem>}
     * @memberof GetPersonalityDetail
     */
    'items': Array<PersonalityDetailItem>;
}
/**
 * 
 * @export
 * @interface GetPersonalityMatrix
 */
export interface GetPersonalityMatrix {
    /**
     * 
     * @type {number}
     * @memberof GetPersonalityMatrix
     */
    'per_mx': number;
    /**
     * 
     * @type {number}
     * @memberof GetPersonalityMatrix
     */
    'per_my': number;
    /**
     * 
     * @type {number}
     * @memberof GetPersonalityMatrix
     */
    'subtype': number;
}
/**
 * 
 * @export
 * @interface GetPricePlan
 */
export interface GetPricePlan {
    /**
     * 
     * @type {PricePlanEnum}
     * @memberof GetPricePlan
     */
    'code': PricePlanEnum;
    /**
     * 
     * @type {string}
     * @memberof GetPricePlan
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface GetProfile
 */
export interface GetProfile {
    /**
     * 
     * @type {string}
     * @memberof GetProfile
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetProfile
     */
    'username'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetProfile
     */
    'firstName': string;
    /**
     * 
     * @type {string}
     * @memberof GetProfile
     */
    'lastName': string;
    /**
     * 
     * @type {string}
     * @memberof GetProfile
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof GetProfile
     */
    'image'?: string;
    /**
     * 
     * @type {GenderEnum}
     * @memberof GetProfile
     */
    'gender'?: GenderEnum;
    /**
     * 
     * @type {Department}
     * @memberof GetProfile
     */
    'department'?: Department;
    /**
     * 
     * @type {Array<GetTagResponse>}
     * @memberof GetProfile
     */
    'tags'?: Array<GetTagResponse>;
}
/**
 * 
 * @export
 * @interface GetQueueManageItem
 */
export interface GetQueueManageItem {
    /**
     * 
     * @type {number}
     * @memberof GetQueueManageItem
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof GetQueueManageItem
     */
    'filename'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetQueueManageItem
     */
    'type': string;
    /**
     * 
     * @type {string}
     * @memberof GetQueueManageItem
     */
    'uploadDateTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetQueueManageItem
     */
    'status': string;
    /**
     * 
     * @type {string}
     * @memberof GetQueueManageItem
     */
    'uploadBy'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetQueueManageItem
     */
    'errors'?: Array<string>;
}
/**
 * 
 * @export
 * @interface GetRetired200Response
 */
export interface GetRetired200Response {
    /**
     * 
     * @type {string}
     * @memberof GetRetired200Response
     */
    'offset'?: string;
    /**
     * 
     * @type {Array<GetRetiredProfile>}
     * @memberof GetRetired200Response
     */
    'lists'?: Array<GetRetiredProfile>;
}
/**
 * 
 * @export
 * @interface GetRetiredProfile
 */
export interface GetRetiredProfile {
    /**
     * 
     * @type {string}
     * @memberof GetRetiredProfile
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetRetiredProfile
     */
    'username'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetRetiredProfile
     */
    'firstName': string;
    /**
     * 
     * @type {string}
     * @memberof GetRetiredProfile
     */
    'lastName': string;
    /**
     * 
     * @type {string}
     * @memberof GetRetiredProfile
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof GetRetiredProfile
     */
    'image'?: string;
    /**
     * 
     * @type {GenderEnum}
     * @memberof GetRetiredProfile
     */
    'gender'?: GenderEnum;
    /**
     * 
     * @type {string}
     * @memberof GetRetiredProfile
     */
    'department'?: string;
    /**
     * 
     * @type {Array<GetTagResponse>}
     * @memberof GetRetiredProfile
     */
    'tags'?: Array<GetTagResponse>;
    /**
     * 
     * @type {string}
     * @memberof GetRetiredProfile
     */
    'SK': string;
    /**
     * 
     * @type {string}
     * @memberof GetRetiredProfile
     */
    'occupation'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetRetiredProfile
     */
    'position'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetRetiredProfile
     */
    'retirementDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetRetiredProfile
     */
    'lastExamDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetRetiredProfile
     */
    'updatedAt'?: string;
}
/**
 * 
 * @export
 * @interface GetRetiredProfileAllOf
 */
export interface GetRetiredProfileAllOf {
    /**
     * 
     * @type {string}
     * @memberof GetRetiredProfileAllOf
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetRetiredProfileAllOf
     */
    'SK': string;
    /**
     * 
     * @type {string}
     * @memberof GetRetiredProfileAllOf
     */
    'firstName': string;
    /**
     * 
     * @type {string}
     * @memberof GetRetiredProfileAllOf
     */
    'lastName': string;
    /**
     * 
     * @type {string}
     * @memberof GetRetiredProfileAllOf
     */
    'department'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetRetiredProfileAllOf
     */
    'occupation'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetRetiredProfileAllOf
     */
    'position'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetRetiredProfileAllOf
     */
    'retirementDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetRetiredProfileAllOf
     */
    'lastExamDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetRetiredProfileAllOf
     */
    'updatedAt'?: string;
}
/**
 * 
 * @export
 * @interface GetServicePlan
 */
export interface GetServicePlan {
    /**
     * 
     * @type {ServicePlanEnum}
     * @memberof GetServicePlan
     */
    'code': ServicePlanEnum;
    /**
     * 
     * @type {string}
     * @memberof GetServicePlan
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface GetStat
 */
export interface GetStat {
    /**
     * 
     * @type {GetStatRDAnalytics}
     * @memberof GetStat
     */
    'RDAnalytics'?: GetStatRDAnalytics;
    /**
     * 
     * @type {Array<GetPDAnalytics>}
     * @memberof GetStat
     */
    'PDAnalytics'?: Array<GetPDAnalytics>;
    /**
     * 
     * @type {GetPMAnalytics}
     * @memberof GetStat
     */
    'PMAnalytics'?: GetPMAnalytics;
    /**
     * 
     * @type {GetPersonalityMatrix}
     * @memberof GetStat
     */
    'PersonalityMatrix'?: GetPersonalityMatrix;
    /**
     * 
     * @type {GetStatBehavior}
     * @memberof GetStat
     */
    'Behavior'?: GetStatBehavior;
    /**
     * 
     * @type {Array<SummaryItemInner>}
     * @memberof GetStat
     */
    'CulturalFit'?: Array<SummaryItemInner>;
    /**
     * 
     * @type {Array<SummaryItemInner>}
     * @memberof GetStat
     */
    'HumanSkill'?: Array<SummaryItemInner>;
    /**
     * 
     * @type {GetPersonalityDetail}
     * @memberof GetStat
     */
    'PersonalityDetail'?: GetPersonalityDetail;
    /**
     * 
     * @type {Array<SocialityItem>}
     * @memberof GetStat
     */
    'Sociality'?: Array<SocialityItem>;
    /**
     * 
     * @type {GetActivityMotivationDetail}
     * @memberof GetStat
     */
    'ActivityMotivationDetail'?: GetActivityMotivationDetail;
    /**
     * 
     * @type {Array<SelfEvaluationItem>}
     * @memberof GetStat
     */
    'SelfEvaluation'?: Array<SelfEvaluationItem>;
    /**
     * 
     * @type {Array<SimilarityItem>}
     * @memberof GetStat
     */
    'Similarity'?: Array<SimilarityItem>;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetStat
     */
    'InterviewTips'?: Array<string>;
    /**
     * 
     * @type {GetJudgement}
     * @memberof GetStat
     */
    'Judgement'?: GetJudgement;
    /**
     * 
     * @type {number}
     * @memberof GetStat
     */
    'Reliability'?: number;
    /**
     * 
     * @type {GetCriteriaItem}
     * @memberof GetStat
     */
    'CriteriaSelectable'?: GetCriteriaItem;
    /**
     * 
     * @type {string}
     * @memberof GetStat
     */
    'lastExamDate'?: string;
    /**
     * 
     * @type {GetExamDate}
     * @memberof GetStat
     */
    'ExamDate'?: GetExamDate;
    /**
     * 
     * @type {Array<ProgressInfo>}
     * @memberof GetStat
     */
    'Progress'?: Array<ProgressInfo>;
}
/**
 * 
 * @export
 * @interface GetStatBehavior
 */
export interface GetStatBehavior {
    /**
     * 
     * @type {number}
     * @memberof GetStatBehavior
     */
    'x': number;
    /**
     * 
     * @type {number}
     * @memberof GetStatBehavior
     */
    'y': number;
}
/**
 * 
 * @export
 * @interface GetStatRDAnalytics
 */
export interface GetStatRDAnalytics {
    /**
     * 
     * @type {number}
     * @memberof GetStatRDAnalytics
     */
    'rd_mx': number;
    /**
     * 
     * @type {number}
     * @memberof GetStatRDAnalytics
     */
    'rd_my': number;
}
/**
 * 
 * @export
 * @interface GetStats
 */
export interface GetStats {
    /**
     * 
     * @type {GetStatsAdditionalProperties}
     * @memberof GetStats
     */
    'additionalProperties'?: GetStatsAdditionalProperties;
}
/**
 * 
 * @export
 * @interface GetStatsAdditionalProperties
 */
export interface GetStatsAdditionalProperties {
    /**
     * 
     * @type {GetStat}
     * @memberof GetStatsAdditionalProperties
     */
    'stats': GetStat;
    /**
     * 
     * @type {GetProfile}
     * @memberof GetStatsAdditionalProperties
     */
    'profile'?: GetProfile;
}
/**
 * 
 * @export
 * @interface GetSummaryResponse
 */
export interface GetSummaryResponse {
    /**
     * 
     * @type {Array<SummaryItemInner>}
     * @memberof GetSummaryResponse
     */
    'PersonalityMatrix'?: Array<SummaryItemInner>;
    /**
     * 
     * @type {Array<SummaryItemInner>}
     * @memberof GetSummaryResponse
     */
    'PMAnalytics'?: Array<SummaryItemInner>;
    /**
     * 
     * @type {Array<SummaryItemInner>}
     * @memberof GetSummaryResponse
     */
    'RDAnalytics'?: Array<SummaryItemInner>;
    /**
     * 
     * @type {Array<SummaryItemInner>}
     * @memberof GetSummaryResponse
     */
    'CulturalFit'?: Array<SummaryItemInner>;
    /**
     * 
     * @type {Array<SummaryItemInner>}
     * @memberof GetSummaryResponse
     */
    'HumanSkill'?: Array<SummaryItemInner>;
    /**
     * 
     * @type {Array<SummaryItemInner>}
     * @memberof GetSummaryResponse
     */
    'PersonalityActivityMotivation'?: Array<SummaryItemInner>;
}
/**
 * 
 * @export
 * @interface GetTagResponse
 */
export interface GetTagResponse {
    /**
     * 
     * @type {string}
     * @memberof GetTagResponse
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetTagResponse
     */
    'name'?: string;
}
/**
 * 
 * @export
 * @interface GetToken
 */
export interface GetToken {
    /**
     * 
     * @type {string}
     * @memberof GetToken
     */
    'accessToken': string;
    /**
     * 
     * @type {string}
     * @memberof GetToken
     */
    'refreshToken': string;
}
/**
 * 
 * @export
 * @interface IdName
 */
export interface IdName {
    /**
     * 
     * @type {string}
     * @memberof IdName
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof IdName
     */
    'name': string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const ImportItemEnum = {
    Employees: 'employees',
    Applicants: 'applicants'
} as const;

export type ImportItemEnum = typeof ImportItemEnum[keyof typeof ImportItemEnum];


/**
 * 
 * @export
 * @interface IssueAsUrl200Response
 */
export interface IssueAsUrl200Response {
    /**
     * 
     * @type {string}
     * @memberof IssueAsUrl200Response
     */
    'url'?: string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const LanguagesEnum = {
    ja: '日本語',
    en: '英語'
} as const;

export type LanguagesEnum = typeof LanguagesEnum[keyof typeof LanguagesEnum];


/**
 * 
 * @export
 * @interface LoginResponse
 */
export interface LoginResponse {
    /**
     * 
     * @type {string}
     * @memberof LoginResponse
     */
    'clientId': string;
    /**
     * 
     * @type {string}
     * @memberof LoginResponse
     */
    'departmentId': string;
    /**
     * 
     * @type {User}
     * @memberof LoginResponse
     */
    'user': User;
    /**
     * 
     * @type {string}
     * @memberof LoginResponse
     */
    'pricePlan': string;
    /**
     * 
     * @type {string}
     * @memberof LoginResponse
     */
    'planStart'?: string;
    /**
     * 
     * @type {string}
     * @memberof LoginResponse
     */
    'planEnd'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof LoginResponse
     */
    'isUpgradeScheduled'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof LoginResponse
     */
    'isDeleteScheduled'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof LoginResponse
     */
    'employeeId'?: string;
    /**
     * 
     * @type {string}
     * @memberof LoginResponse
     */
    'accessToken': string;
    /**
     * 
     * @type {string}
     * @memberof LoginResponse
     */
    'refreshToken': string;
}
/**
 * 
 * @export
 * @interface NavNode
 */
export interface NavNode {
    /**
     * 
     * @type {string}
     * @memberof NavNode
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof NavNode
     */
    'name': string;
    /**
     * 
     * @type {Array<Child>}
     * @memberof NavNode
     */
    'child'?: Array<Child>;
    /**
     * 
     * @type {string}
     * @memberof NavNode
     */
    'path': string;
}
/**
 * 
 * @export
 * @interface NavNodeAllOf
 */
export interface NavNodeAllOf {
    /**
     * 
     * @type {string}
     * @memberof NavNodeAllOf
     */
    'path'?: string;
}
/**
 * 
 * @export
 * @interface Notification
 */
export interface Notification {
    /**
     * 
     * @type {string}
     * @memberof Notification
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof Notification
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof Notification
     */
    'content': string;
    /**
     * 
     * @type {NotificationLanguageEnum}
     * @memberof Notification
     */
    'language'?: NotificationLanguageEnum;
    /**
     * 
     * @type {NotificationCategoryEnum}
     * @memberof Notification
     */
    'category': NotificationCategoryEnum;
    /**
     * 
     * @type {NotificationContextEnum}
     * @memberof Notification
     */
    'context': NotificationContextEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof Notification
     */
    'displayTime'?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof Notification
     */
    'isRead': boolean;
    /**
     * 
     * @type {string}
     * @memberof Notification
     */
    'readAt': string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const NotificationCategoryEnum = {
    general: 'GENERAL',
    announcement: 'ANNOUNCEMENT'
} as const;

export type NotificationCategoryEnum = typeof NotificationCategoryEnum[keyof typeof NotificationCategoryEnum];


/**
 * 
 * @export
 * @enum {string}
 */

export const NotificationContextEnum = {
    all: 'ALL',
    mgtScreen: 'MANAGEMENT_SCREEN',
    addons: 'ADD_ONS',
    examScreen: 'EXAM_SCREEN'
} as const;

export type NotificationContextEnum = typeof NotificationContextEnum[keyof typeof NotificationContextEnum];


/**
 * 
 * @export
 * @enum {string}
 */

export const NotificationLanguageEnum = {
    en: '英語',
    jp: '日本語'
} as const;

export type NotificationLanguageEnum = typeof NotificationLanguageEnum[keyof typeof NotificationLanguageEnum];


/**
 * 
 * @export
 * @interface NotificationRequest
 */
export interface NotificationRequest {
    /**
     * 
     * @type {string}
     * @memberof NotificationRequest
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof NotificationRequest
     */
    'content': string;
    /**
     * 
     * @type {NotificationLanguageEnum}
     * @memberof NotificationRequest
     */
    'language'?: NotificationLanguageEnum;
    /**
     * 
     * @type {NotificationCategoryEnum}
     * @memberof NotificationRequest
     */
    'category': NotificationCategoryEnum;
    /**
     * 
     * @type {NotificationContextEnum}
     * @memberof NotificationRequest
     */
    'context': NotificationContextEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof NotificationRequest
     */
    'displayTime'?: Array<string>;
}
/**
 * 
 * @export
 * @interface Occupation
 */
export interface Occupation {
    /**
     * 
     * @type {string}
     * @memberof Occupation
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof Occupation
     */
    'name': string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const OperationRangesEnum = {
    all: '全ての部署',
    belongTree: '配下部署含む',
    belong: '所属のみ',
    myself: '本人のみ'
} as const;

export type OperationRangesEnum = typeof OperationRangesEnum[keyof typeof OperationRangesEnum];


/**
 * 
 * @export
 * @interface PageId
 */
export interface PageId {
    /**
     * 
     * @type {string}
     * @memberof PageId
     */
    'key'?: string;
    /**
     * 
     * @type {string}
     * @memberof PageId
     */
    'name'?: string;
}
/**
 * 
 * @export
 * @interface PersonalityDetailItem
 */
export interface PersonalityDetailItem {
    /**
     * 
     * @type {PersonalityDetailItemTypeEnum}
     * @memberof PersonalityDetailItem
     */
    'type': PersonalityDetailItemTypeEnum;
    /**
     * 
     * @type {PersonalityDetailItemAspectEnum}
     * @memberof PersonalityDetailItem
     */
    'aspect': PersonalityDetailItemAspectEnum;
    /**
     * 
     * @type {string}
     * @memberof PersonalityDetailItem
     */
    'evaluation': string;
    /**
     * 
     * @type {number}
     * @memberof PersonalityDetailItem
     */
    'value': number;
    /**
     * 
     * @type {PersonalityDetailItemTooltip}
     * @memberof PersonalityDetailItem
     */
    'tooltip'?: PersonalityDetailItemTooltip;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const PersonalityDetailItemAspectEnum = {
    Introversive: 'Introversive',
    Objective: 'Objective',
    Physical: 'Physical',
    Emotional: 'Emotional',
    Persistency: 'Persistency',
    Regulality: 'Regulality',
    Competitive: 'Competitive',
    SelfRespective: 'SelfRespective',
    Carefull: 'Carefull',
    Timid: 'Timid'
} as const;

export type PersonalityDetailItemAspectEnum = typeof PersonalityDetailItemAspectEnum[keyof typeof PersonalityDetailItemAspectEnum];


/**
 * 
 * @export
 * @interface PersonalityDetailItemTooltip
 */
export interface PersonalityDetailItemTooltip {
    /**
     * 
     * @type {string}
     * @memberof PersonalityDetailItemTooltip
     */
    'high'?: string;
    /**
     * 
     * @type {string}
     * @memberof PersonalityDetailItemTooltip
     */
    'low'?: string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const PersonalityDetailItemTypeEnum = {
    Thinking: 'Thinking',
    Active: 'Active',
    Hardworking: 'Hardworking',
    Positive: 'Positive',
    SelfControl: 'SelfControl'
} as const;

export type PersonalityDetailItemTypeEnum = typeof PersonalityDetailItemTypeEnum[keyof typeof PersonalityDetailItemTypeEnum];


/**
 * 
 * @export
 * @interface Position
 */
export interface Position {
    /**
     * 
     * @type {string}
     * @memberof Position
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof Position
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface PostNotificationReceipt
 */
export interface PostNotificationReceipt {
    /**
     * 
     * @type {Array<string>}
     * @memberof PostNotificationReceipt
     */
    'notificationIds'?: Array<string>;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const PricePlanEnum = {
    Trial: 'as-trial',
    A: 'as-A',
    B: 'as-B'
} as const;

export type PricePlanEnum = typeof PricePlanEnum[keyof typeof PricePlanEnum];


/**
 * 
 * @export
 * @interface PrivacyPolicyRequest
 */
export interface PrivacyPolicyRequest {
    /**
     * 
     * @type {string}
     * @memberof PrivacyPolicyRequest
     */
    'language': string;
    /**
     * 
     * @type {string}
     * @memberof PrivacyPolicyRequest
     */
    'policy': string;
    /**
     * 
     * @type {string}
     * @memberof PrivacyPolicyRequest
     */
    'contactName': string;
    /**
     * 
     * @type {string}
     * @memberof PrivacyPolicyRequest
     */
    'contactEmail': string;
}
/**
 * 
 * @export
 * @interface PrivacyPolicyResponse
 */
export interface PrivacyPolicyResponse {
    /**
     * 
     * @type {string}
     * @memberof PrivacyPolicyResponse
     */
    'policy'?: string;
    /**
     * 
     * @type {string}
     * @memberof PrivacyPolicyResponse
     */
    'contactName'?: string;
    /**
     * 
     * @type {string}
     * @memberof PrivacyPolicyResponse
     */
    'contactEmail'?: string;
}
/**
 * 
 * @export
 * @interface ProgressInfo
 */
export interface ProgressInfo {
    /**
     * 
     * @type {string}
     * @memberof ProgressInfo
     */
    'date': string;
    /**
     * 
     * @type {Array<ProgressScore>}
     * @memberof ProgressInfo
     */
    'score': Array<ProgressScore>;
}
/**
 * 
 * @export
 * @interface ProgressScore
 */
export interface ProgressScore {
    /**
     * 
     * @type {string}
     * @memberof ProgressScore
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof ProgressScore
     */
    'value': number;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const QueueManageStatusEnum = {
    NotStarted: '0',
    ExecStart: '10',
    ExecFinish: '20',
    Error: '90'
} as const;

export type QueueManageStatusEnum = typeof QueueManageStatusEnum[keyof typeof QueueManageStatusEnum];


/**
 * 
 * @export
 * @enum {string}
 */

export const QueueManageTypeEnum = {
    EmployeeExcel: '1',
    ApplicantExcel: '2'
} as const;

export type QueueManageTypeEnum = typeof QueueManageTypeEnum[keyof typeof QueueManageTypeEnum];


/**
 * 
 * @export
 * @interface RegisterAsSendTaskRequest
 */
export interface RegisterAsSendTaskRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof RegisterAsSendTaskRequest
     */
    'employeeIds'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof RegisterAsSendTaskRequest
     */
    'applicantIds'?: Array<string>;
}
/**
 * 
 * @export
 * @interface Role
 */
export interface Role {
    /**
     * 
     * @type {string}
     * @memberof Role
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof Role
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof Role
     */
    'operationRange': string;
    /**
     * 
     * @type {RolePermissions}
     * @memberof Role
     */
    'permissions': RolePermissions;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const RoleName = {
    SystemAdmin: '1',
    ClientAdmin: '2',
    DepartmentOwner: '3',
    Viewer: '4'
} as const;

export type RoleName = typeof RoleName[keyof typeof RoleName];


/**
 * 
 * @export
 * @interface RolePermissions
 */
export interface RolePermissions {
    /**
     * 
     * @type {Array<string>}
     * @memberof RolePermissions
     */
    'employee'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof RolePermissions
     */
    'applicant'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof RolePermissions
     */
    'analysis'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof RolePermissions
     */
    'manage'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof RolePermissions
     */
    'specialManage'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof RolePermissions
     */
    'asBroadcast'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof RolePermissions
     */
    'employeeStats'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof RolePermissions
     */
    'applicantStats'?: Array<string>;
}
/**
 * 
 * @export
 * @interface RoleRequest
 */
export interface RoleRequest {
    /**
     * 
     * @type {string}
     * @memberof RoleRequest
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof RoleRequest
     */
    'operationRange'?: string;
    /**
     * 
     * @type {RolePermissions}
     * @memberof RoleRequest
     */
    'permissions'?: RolePermissions;
}
/**
 * 
 * @export
 * @interface SearchEmployees200Response
 */
export interface SearchEmployees200Response {
    /**
     * 
     * @type {string}
     * @memberof SearchEmployees200Response
     */
    'totalCount'?: string;
    /**
     * 
     * @type {Array<GetEmployeeProfile>}
     * @memberof SearchEmployees200Response
     */
    'lists'?: Array<GetEmployeeProfile>;
}
/**
 * 
 * @export
 * @interface SelfEvaluationItem
 */
export interface SelfEvaluationItem {
    /**
     * 
     * @type {SocialityItem}
     * @memberof SelfEvaluationItem
     */
    'majorClass': SocialityItem;
    /**
     * 
     * @type {Array<SocialityItem>}
     * @memberof SelfEvaluationItem
     */
    'minorClasses'?: Array<SocialityItem>;
}
/**
 * 
 * @export
 * @interface SelfEvaluationMinorClass
 */
export interface SelfEvaluationMinorClass {
    /**
     * 
     * @type {string}
     * @memberof SelfEvaluationMinorClass
     */
    'name'?: string;
    /**
     * 
     * @type {number}
     * @memberof SelfEvaluationMinorClass
     */
    'value'?: number;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const ServicePlanEnum = {
    As: 'as',
    Sv: 'sv',
    El: 'el'
} as const;

export type ServicePlanEnum = typeof ServicePlanEnum[keyof typeof ServicePlanEnum];


/**
 * 
 * @export
 * @interface SimilarityItem
 */
export interface SimilarityItem {
    /**
     * 
     * @type {string}
     * @memberof SimilarityItem
     */
    'name': string;
    /**
     * 
     * @type {Array<SimilarityPeople>}
     * @memberof SimilarityItem
     */
    'people': Array<SimilarityPeople>;
}
/**
 * 
 * @export
 * @interface SimilarityPeople
 */
export interface SimilarityPeople {
    /**
     * 
     * @type {string}
     * @memberof SimilarityPeople
     */
    'firstName': string;
    /**
     * 
     * @type {string}
     * @memberof SimilarityPeople
     */
    'lastName': string;
    /**
     * 
     * @type {string}
     * @memberof SimilarityPeople
     */
    'image'?: string;
    /**
     * 
     * @type {string}
     * @memberof SimilarityPeople
     */
    'value': string;
}
/**
 * 
 * @export
 * @interface SocialityItem
 */
export interface SocialityItem {
    /**
     * 
     * @type {string}
     * @memberof SocialityItem
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof SocialityItem
     */
    'value': number;
    /**
     * 
     * @type {string}
     * @memberof SocialityItem
     */
    'description'?: string;
    /**
     * 
     * @type {PersonalityDetailItemTooltip}
     * @memberof SocialityItem
     */
    'tooltip'?: PersonalityDetailItemTooltip;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const StatsItemEnum = {
    PersonalityMatrix: 'PersonalityMatrix',
    PmAnalytics: 'PMAnalytics',
    RdAnalytics: 'RDAnalytics',
    CulturalFit: 'CulturalFit',
    HumanSkill: 'HumanSkill',
    PersonalityActivityMotivation: 'PersonalityActivityMotivation',
    PdAnalytics: 'PDAnalytics',
    PdAnalyticsStatic: 'PDAnalytics-static',
    PdAnalyticsDynamic: 'PDAnalytics-dynamic',
    PersonalityDetail: 'PersonalityDetail',
    Sociality: 'Sociality',
    ActivityMotivationDetail: 'ActivityMotivationDetail',
    Behavior: 'Behavior',
    SelfEvaluation: 'SelfEvaluation',
    SimilarType: 'SimilarType',
    InterviewTips: 'InterviewTips',
    JobInterest: 'JobInterest',
    Reliability: 'Reliability',
    Judgement: 'Judgement',
    LastExamDate: 'LastExamDate',
    ExamDate: 'ExamDate',
    Progress: 'Progress'
} as const;

export type StatsItemEnum = typeof StatsItemEnum[keyof typeof StatsItemEnum];


/**
 * 
 * @export
 * @interface SummaryItemInner
 */
export interface SummaryItemInner {
    /**
     * 
     * @type {string}
     * @memberof SummaryItemInner
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof SummaryItemInner
     */
    'value': number;
    /**
     * 
     * @type {string}
     * @memberof SummaryItemInner
     */
    'description'?: string;
}
/**
 * 
 * @export
 * @interface Tag
 */
export interface Tag {
    /**
     * 
     * @type {string}
     * @memberof Tag
     */
    'tagId'?: string;
    /**
     * 
     * @type {string}
     * @memberof Tag
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof Tag
     */
    'type'?: string;
}
/**
 * 
 * @export
 * @interface TendencyItem
 */
export interface TendencyItem {
    /**
     * 
     * @type {number}
     * @memberof TendencyItem
     */
    'value': number;
    /**
     * 
     * @type {string}
     * @memberof TendencyItem
     */
    'left': string;
    /**
     * 
     * @type {string}
     * @memberof TendencyItem
     */
    'right': string;
}
/**
 * 
 * @export
 * @interface UpdateApplicantRequest
 */
export interface UpdateApplicantRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateApplicantRequest
     */
    'firstName': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateApplicantRequest
     */
    'lastName': string;
    /**
     * 
     * @type {GenderEnum}
     * @memberof UpdateApplicantRequest
     */
    'gender'?: GenderEnum;
    /**
     * 
     * @type {string}
     * @memberof UpdateApplicantRequest
     */
    'contractType'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateApplicantRequest
     */
    'career': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateApplicantRequest
     */
    'email'?: string;
    /**
     * 
     * @type {ApplicantStatusEnum}
     * @memberof UpdateApplicantRequest
     */
    'status': ApplicantStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof UpdateApplicantRequest
     */
    'departmentId'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateApplicantRequest
     */
    'occupationId'?: string;
}
/**
 * 
 * @export
 * @interface UpdateAsBroadcastRequest
 */
export interface UpdateAsBroadcastRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateAsBroadcastRequest
     */
    'name'?: string;
    /**
     * 
     * @type {AsBroadcastTypeEnum}
     * @memberof UpdateAsBroadcastRequest
     */
    'type'?: AsBroadcastTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof UpdateAsBroadcastRequest
     */
    'startDateTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateAsBroadcastRequest
     */
    'endDateTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateAsBroadcastRequest
     */
    'completionEmail'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateAsBroadcastRequest
     */
    'participantRemind'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateAsBroadcastRequest
     */
    'adminRemind'?: boolean;
}
/**
 * 
 * @export
 * @interface UpdateAsExaminationRecordRequestInner
 */
export interface UpdateAsExaminationRecordRequestInner {
    /**
     * 
     * @type {string}
     * @memberof UpdateAsExaminationRecordRequestInner
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateAsExaminationRecordRequestInner
     */
    'answer'?: string;
}
/**
 * 
 * @export
 * @interface UpdateAvatar
 */
export interface UpdateAvatar {
    /**
     * 
     * @type {string}
     * @memberof UpdateAvatar
     */
    'image': string;
}
/**
 * 
 * @export
 * @interface UpdateClientRequest
 */
export interface UpdateClientRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateClientRequest
     */
    'name'?: string;
    /**
     * 
     * @type {Array<ServicePlanEnum>}
     * @memberof UpdateClientRequest
     */
    'servicePlans'?: Array<ServicePlanEnum>;
    /**
     * 
     * @type {PricePlanEnum}
     * @memberof UpdateClientRequest
     */
    'pricePlan'?: PricePlanEnum;
    /**
     * 
     * @type {string}
     * @memberof UpdateClientRequest
     */
    'max_employees'?: string;
}
/**
 * 
 * @export
 * @interface UpdateDepartmentRequest
 */
export interface UpdateDepartmentRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateDepartmentRequest
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateDepartmentRequest
     */
    'parentId': string;
}
/**
 * 
 * @export
 * @interface UpdateEmployee
 */
export interface UpdateEmployee {
    /**
     * 
     * @type {string}
     * @memberof UpdateEmployee
     */
    'username'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateEmployee
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateEmployee
     */
    'firstName'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateEmployee
     */
    'lastName'?: string;
    /**
     * 
     * @type {GenderEnum}
     * @memberof UpdateEmployee
     */
    'gender'?: GenderEnum;
    /**
     * 
     * @type {string}
     * @memberof UpdateEmployee
     */
    'contractType'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateEmployee
     */
    'career'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateEmployee
     */
    'enrollment'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateEmployee
     */
    'retirementDate'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateEmployee
     */
    'retirementReasons'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof UpdateEmployee
     */
    'departmentId'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateEmployee
     */
    'aditionalDepartmentIds'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateEmployee
     */
    'anotherDepartmentIds'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof UpdateEmployee
     */
    'occupationId'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateEmployee
     */
    'positionId'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateEmployee
     */
    'role'?: string;
}
/**
 * 
 * @export
 * @interface UpdateTag
 */
export interface UpdateTag {
    /**
     * 
     * @type {string}
     * @memberof UpdateTag
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateTag
     */
    'type': string;
}
/**
 * 
 * @export
 * @interface UpdateUserRequest
 */
export interface UpdateUserRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateUserRequest
     */
    'password'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateUserRequest
     */
    'firstName'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateUserRequest
     */
    'lastName'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateUserRequest
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateUserRequest
     */
    'role'?: string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const UploadItemEnum = {
    Employees: 'employees',
    Applicants: 'applicants'
} as const;

export type UploadItemEnum = typeof UploadItemEnum[keyof typeof UploadItemEnum];


/**
 * 
 * @export
 * @interface User
 */
export interface User {
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'username': string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'firstName': string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'lastName': string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'image'?: string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'employeeId'?: string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'role': string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const UserTypeEnum = {
    Employee: 'employee',
    Applicant: 'applicant'
} as const;

export type UserTypeEnum = typeof UserTypeEnum[keyof typeof UserTypeEnum];




/**
 * ADDONApi - axios parameter creator
 * @export
 */
export const ADDONApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Authenticate the candidate
         * @param {string} authorization 認証情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authenticateAsCandidate: async (authorization: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('authenticateAsCandidate', 'authorization', authorization)
            const localVarPath = `/as/auth`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create an examination record
         * @param {string} authorization 認証情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAsExaminationRecord: async (authorization: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('createAsExaminationRecord', 'authorization', authorization)
            const localVarPath = `/as/exam`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Record an examination input
         * @param {string} authorization 認証情報
         * @param {Array<UpdateAsExaminationRecordRequestInner>} updateAsExaminationRecordRequestInner 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAsExaminationRecord: async (authorization: string, updateAsExaminationRecordRequestInner: Array<UpdateAsExaminationRecordRequestInner>, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('updateAsExaminationRecord', 'authorization', authorization)
            // verify required parameter 'updateAsExaminationRecordRequestInner' is not null or undefined
            assertParamExists('updateAsExaminationRecord', 'updateAsExaminationRecordRequestInner', updateAsExaminationRecordRequestInner)
            const localVarPath = `/as/exam`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateAsExaminationRecordRequestInner, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ADDONApi - functional programming interface
 * @export
 */
export const ADDONApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ADDONApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Authenticate the candidate
         * @param {string} authorization 認証情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authenticateAsCandidate(authorization: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<User>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authenticateAsCandidate(authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Create an examination record
         * @param {string} authorization 認証情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createAsExaminationRecord(authorization: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createAsExaminationRecord(authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Record an examination input
         * @param {string} authorization 認証情報
         * @param {Array<UpdateAsExaminationRecordRequestInner>} updateAsExaminationRecordRequestInner 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateAsExaminationRecord(authorization: string, updateAsExaminationRecordRequestInner: Array<UpdateAsExaminationRecordRequestInner>, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateAsExaminationRecord(authorization, updateAsExaminationRecordRequestInner, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ADDONApi - factory interface
 * @export
 */
export const ADDONApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ADDONApiFp(configuration)
    return {
        /**
         * 
         * @summary Authenticate the candidate
         * @param {string} authorization 認証情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authenticateAsCandidate(authorization: string, options?: any): AxiosPromise<User> {
            return localVarFp.authenticateAsCandidate(authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create an examination record
         * @param {string} authorization 認証情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAsExaminationRecord(authorization: string, options?: any): AxiosPromise<object> {
            return localVarFp.createAsExaminationRecord(authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Record an examination input
         * @param {string} authorization 認証情報
         * @param {Array<UpdateAsExaminationRecordRequestInner>} updateAsExaminationRecordRequestInner 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAsExaminationRecord(authorization: string, updateAsExaminationRecordRequestInner: Array<UpdateAsExaminationRecordRequestInner>, options?: any): AxiosPromise<object> {
            return localVarFp.updateAsExaminationRecord(authorization, updateAsExaminationRecordRequestInner, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ADDONApi - object-oriented interface
 * @export
 * @class ADDONApi
 * @extends {BaseAPI}
 */
export class ADDONApi extends BaseAPI {
    /**
     * 
     * @summary Authenticate the candidate
     * @param {string} authorization 認証情報
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ADDONApi
     */
    public authenticateAsCandidate(params: { authorization?: string,  }, options?: any) {
				const _params = {} as any;
				_params['authorization'] = params['authorization']
				// @ts-ignore
				_params.authorization = 'Bearer ' + ( params.authorization || Store.getInstance().getAccessToken())!
				_params.clientId = ((params as any).clientId || (Store.getInstance().getAuth() || {}).clientId)!;
        return ADDONApiFp(this.configuration).authenticateAsCandidate(_params.authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create an examination record
     * @param {string} authorization 認証情報
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ADDONApi
     */
    public createAsExaminationRecord(params: { authorization?: string,  }, options?: any) {
				const _params = {} as any;
				_params['authorization'] = params['authorization']
				// @ts-ignore
				_params.authorization = 'Bearer ' + ( params.authorization || Store.getInstance().getAccessToken())!
				_params.clientId = ((params as any).clientId || (Store.getInstance().getAuth() || {}).clientId)!;
        return ADDONApiFp(this.configuration).createAsExaminationRecord(_params.authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Record an examination input
     * @param {string} authorization 認証情報
     * @param {Array<UpdateAsExaminationRecordRequestInner>} updateAsExaminationRecordRequestInner 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ADDONApi
     */
    public updateAsExaminationRecord(params: { authorization?: string, updateAsExaminationRecordRequestInner: Array<UpdateAsExaminationRecordRequestInner>,  }, options?: any) {
				const _params = {} as any;
				_params['authorization'] = params['authorization']
				_params['updateAsExaminationRecordRequestInner'] = params['updateAsExaminationRecordRequestInner']
				// @ts-ignore
				_params.authorization = 'Bearer ' + ( params.authorization || Store.getInstance().getAccessToken())!
				_params.clientId = ((params as any).clientId || (Store.getInstance().getAuth() || {}).clientId)!;
        return ADDONApiFp(this.configuration).updateAsExaminationRecord(_params.authorization, _params.updateAsExaminationRecordRequestInner, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AccessLogApi - axios parameter creator
 * @export
 */
export const AccessLogApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 対象クライアントのアクセスログを取得する。
         * @summary Get AccessLog list
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {string} [name] 
         * @param {string} [pageId] 
         * @param {string} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccessLogs: async (authorization: string, clientId: string, startDate?: string, endDate?: string, name?: string, pageId?: string, offset?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('getAccessLogs', 'authorization', authorization)
            // verify required parameter 'clientId' is not null or undefined
            assertParamExists('getAccessLogs', 'clientId', clientId)
            const localVarPath = `/clients/{clientId}/accesslogs`
                .replace(`{${"clientId"}}`, encodeURIComponent(String(clientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = endDate;
            }

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (pageId !== undefined) {
                localVarQueryParameter['pageId'] = pageId;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 対象クライアントの画面ID一覧を取得する。
         * @summary Get AccessLog pageId list
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPageIds: async (authorization: string, clientId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('getPageIds', 'authorization', authorization)
            // verify required parameter 'clientId' is not null or undefined
            assertParamExists('getPageIds', 'clientId', clientId)
            const localVarPath = `/clients/{clientId}/pageIds`
                .replace(`{${"clientId"}}`, encodeURIComponent(String(clientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AccessLogApi - functional programming interface
 * @export
 */
export const AccessLogApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AccessLogApiAxiosParamCreator(configuration)
    return {
        /**
         * 対象クライアントのアクセスログを取得する。
         * @summary Get AccessLog list
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {string} [name] 
         * @param {string} [pageId] 
         * @param {string} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAccessLogs(authorization: string, clientId: string, startDate?: string, endDate?: string, name?: string, pageId?: string, offset?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetAccessLogs200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAccessLogs(authorization, clientId, startDate, endDate, name, pageId, offset, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 対象クライアントの画面ID一覧を取得する。
         * @summary Get AccessLog pageId list
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPageIds(authorization: string, clientId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PageId>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPageIds(authorization, clientId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AccessLogApi - factory interface
 * @export
 */
export const AccessLogApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AccessLogApiFp(configuration)
    return {
        /**
         * 対象クライアントのアクセスログを取得する。
         * @summary Get AccessLog list
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {string} [name] 
         * @param {string} [pageId] 
         * @param {string} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccessLogs(authorization: string, clientId: string, startDate?: string, endDate?: string, name?: string, pageId?: string, offset?: string, options?: any): AxiosPromise<GetAccessLogs200Response> {
            return localVarFp.getAccessLogs(authorization, clientId, startDate, endDate, name, pageId, offset, options).then((request) => request(axios, basePath));
        },
        /**
         * 対象クライアントの画面ID一覧を取得する。
         * @summary Get AccessLog pageId list
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPageIds(authorization: string, clientId: string, options?: any): AxiosPromise<Array<PageId>> {
            return localVarFp.getPageIds(authorization, clientId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AccessLogApi - object-oriented interface
 * @export
 * @class AccessLogApi
 * @extends {BaseAPI}
 */
export class AccessLogApi extends BaseAPI {
    /**
     * 対象クライアントのアクセスログを取得する。
     * @summary Get AccessLog list
     * @param {string} authorization 認証情報
     * @param {string} clientId クライアントID
     * @param {string} [startDate] 
     * @param {string} [endDate] 
     * @param {string} [name] 
     * @param {string} [pageId] 
     * @param {string} [offset] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccessLogApi
     */
    public getAccessLogs(params: { authorization?: string, clientId?: string, startDate?: string, endDate?: string, name?: string, pageId?: string, offset?: string,  }, options?: any) {
				const _params = {} as any;
				_params['authorization'] = params['authorization']
				_params['clientId'] = params['clientId']
				_params['startDate'] = params['startDate']
				_params['endDate'] = params['endDate']
				_params['name'] = params['name']
				_params['pageId'] = params['pageId']
				_params['offset'] = params['offset']
				// @ts-ignore
				_params.authorization = 'Bearer ' + ( params.authorization || Store.getInstance().getAccessToken())!
				_params.clientId = ((params as any).clientId || (Store.getInstance().getAuth() || {}).clientId)!;
        return AccessLogApiFp(this.configuration).getAccessLogs(_params.authorization, _params.clientId, _params.startDate, _params.endDate, _params.name, _params.pageId, _params.offset, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 対象クライアントの画面ID一覧を取得する。
     * @summary Get AccessLog pageId list
     * @param {string} authorization 認証情報
     * @param {string} clientId クライアントID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccessLogApi
     */
    public getPageIds(params: { authorization?: string, clientId?: string,  }, options?: any) {
				const _params = {} as any;
				_params['authorization'] = params['authorization']
				_params['clientId'] = params['clientId']
				// @ts-ignore
				_params.authorization = 'Bearer ' + ( params.authorization || Store.getInstance().getAccessToken())!
				_params.clientId = ((params as any).clientId || (Store.getInstance().getAuth() || {}).clientId)!;
        return AccessLogApiFp(this.configuration).getPageIds(_params.authorization, _params.clientId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ApplicantApi - axios parameter creator
 * @export
 */
export const ApplicantApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 対象クライアントの応募者を作成する。
         * @summary Create an applicant
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {CreateApplicantRequest} createApplicantRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createApplicant: async (authorization: string, clientId: string, createApplicantRequest: CreateApplicantRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('createApplicant', 'authorization', authorization)
            // verify required parameter 'clientId' is not null or undefined
            assertParamExists('createApplicant', 'clientId', clientId)
            // verify required parameter 'createApplicantRequest' is not null or undefined
            assertParamExists('createApplicant', 'createApplicantRequest', createApplicantRequest)
            const localVarPath = `/clients/{clientId}/applicants`
                .replace(`{${"clientId"}}`, encodeURIComponent(String(clientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createApplicantRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 対象クライアントの応募者を削除する。
         * @summary Delete an applicant
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {string} applicantId 応募者ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteApplicant: async (authorization: string, clientId: string, applicantId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('deleteApplicant', 'authorization', authorization)
            // verify required parameter 'clientId' is not null or undefined
            assertParamExists('deleteApplicant', 'clientId', clientId)
            // verify required parameter 'applicantId' is not null or undefined
            assertParamExists('deleteApplicant', 'applicantId', applicantId)
            const localVarPath = `/clients/{clientId}/applicants/{applicantId}`
                .replace(`{${"clientId"}}`, encodeURIComponent(String(clientId)))
                .replace(`{${"applicantId"}}`, encodeURIComponent(String(applicantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 対象クライアントの応募者を取得する。
         * @summary Get applicant list
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {string} applicantId 応募者ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApplicant: async (authorization: string, clientId: string, applicantId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('getApplicant', 'authorization', authorization)
            // verify required parameter 'clientId' is not null or undefined
            assertParamExists('getApplicant', 'clientId', clientId)
            // verify required parameter 'applicantId' is not null or undefined
            assertParamExists('getApplicant', 'applicantId', applicantId)
            const localVarPath = `/clients/{clientId}/applicants/{applicantId}`
                .replace(`{${"clientId"}}`, encodeURIComponent(String(clientId)))
                .replace(`{${"applicantId"}}`, encodeURIComponent(String(applicantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 対象クライアントの応募者を取得する。
         * @summary Get applicant list
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {string} [limit] レスポンスのデータ制限
         * @param {string} [occupationId] 
         * @param {string} [departmentId] 
         * @param {string} [status] 
         * @param {string} [offset] 
         * @param {string} [name] 
         * @param {Array<string>} [departments] 
         * @param {Array<string>} [occupations] 
         * @param {string} [examStartDate] 
         * @param {string} [examEndDate] 
         * @param {boolean} [analysisFlg] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApplicants: async (authorization: string, clientId: string, limit?: string, occupationId?: string, departmentId?: string, status?: string, offset?: string, name?: string, departments?: Array<string>, occupations?: Array<string>, examStartDate?: string, examEndDate?: string, analysisFlg?: boolean, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('getApplicants', 'authorization', authorization)
            // verify required parameter 'clientId' is not null or undefined
            assertParamExists('getApplicants', 'clientId', clientId)
            const localVarPath = `/clients/{clientId}/applicants`
                .replace(`{${"clientId"}}`, encodeURIComponent(String(clientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (occupationId !== undefined) {
                localVarQueryParameter['occupationId'] = occupationId;
            }

            if (departmentId !== undefined) {
                localVarQueryParameter['departmentId'] = departmentId;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (departments) {
                localVarQueryParameter['departments'] = departments;
            }

            if (occupations) {
                localVarQueryParameter['occupations'] = occupations;
            }

            if (examStartDate !== undefined) {
                localVarQueryParameter['examStartDate'] = examStartDate;
            }

            if (examEndDate !== undefined) {
                localVarQueryParameter['examEndDate'] = examEndDate;
            }

            if (analysisFlg !== undefined) {
                localVarQueryParameter['analysisFlg'] = analysisFlg;
            }

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 対象クライアントの応募者を従業員に変換する。
         * @summary Convert an applicant to an employee
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {string} applicantId 応募者ID
         * @param {CreateEmployee} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        toEmployee: async (authorization: string, clientId: string, applicantId: string, body: CreateEmployee, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('toEmployee', 'authorization', authorization)
            // verify required parameter 'clientId' is not null or undefined
            assertParamExists('toEmployee', 'clientId', clientId)
            // verify required parameter 'applicantId' is not null or undefined
            assertParamExists('toEmployee', 'applicantId', applicantId)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('toEmployee', 'body', body)
            const localVarPath = `/clients/{clientId}/applicants/{applicantId}/conversion`
                .replace(`{${"clientId"}}`, encodeURIComponent(String(clientId)))
                .replace(`{${"applicantId"}}`, encodeURIComponent(String(applicantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 対象クライアントの応募者を更新する。
         * @summary Update an applicant
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {string} applicantId 応募者ID
         * @param {UpdateApplicantRequest} updateApplicantRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateApplicant: async (authorization: string, clientId: string, applicantId: string, updateApplicantRequest: UpdateApplicantRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('updateApplicant', 'authorization', authorization)
            // verify required parameter 'clientId' is not null or undefined
            assertParamExists('updateApplicant', 'clientId', clientId)
            // verify required parameter 'applicantId' is not null or undefined
            assertParamExists('updateApplicant', 'applicantId', applicantId)
            // verify required parameter 'updateApplicantRequest' is not null or undefined
            assertParamExists('updateApplicant', 'updateApplicantRequest', updateApplicantRequest)
            const localVarPath = `/clients/{clientId}/applicants/{applicantId}`
                .replace(`{${"clientId"}}`, encodeURIComponent(String(clientId)))
                .replace(`{${"applicantId"}}`, encodeURIComponent(String(applicantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateApplicantRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ApplicantApi - functional programming interface
 * @export
 */
export const ApplicantApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ApplicantApiAxiosParamCreator(configuration)
    return {
        /**
         * 対象クライアントの応募者を作成する。
         * @summary Create an applicant
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {CreateApplicantRequest} createApplicantRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createApplicant(authorization: string, clientId: string, createApplicantRequest: CreateApplicantRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createApplicant(authorization, clientId, createApplicantRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 対象クライアントの応募者を削除する。
         * @summary Delete an applicant
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {string} applicantId 応募者ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteApplicant(authorization: string, clientId: string, applicantId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteApplicant(authorization, clientId, applicantId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 対象クライアントの応募者を取得する。
         * @summary Get applicant list
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {string} applicantId 応募者ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getApplicant(authorization: string, clientId: string, applicantId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetApplicantProfile>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getApplicant(authorization, clientId, applicantId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 対象クライアントの応募者を取得する。
         * @summary Get applicant list
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {string} [limit] レスポンスのデータ制限
         * @param {string} [occupationId] 
         * @param {string} [departmentId] 
         * @param {string} [status] 
         * @param {string} [offset] 
         * @param {string} [name] 
         * @param {Array<string>} [departments] 
         * @param {Array<string>} [occupations] 
         * @param {string} [examStartDate] 
         * @param {string} [examEndDate] 
         * @param {boolean} [analysisFlg] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getApplicants(authorization: string, clientId: string, limit?: string, occupationId?: string, departmentId?: string, status?: string, offset?: string, name?: string, departments?: Array<string>, occupations?: Array<string>, examStartDate?: string, examEndDate?: string, analysisFlg?: boolean, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetApplicants200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getApplicants(authorization, clientId, limit, occupationId, departmentId, status, offset, name, departments, occupations, examStartDate, examEndDate, analysisFlg, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 対象クライアントの応募者を従業員に変換する。
         * @summary Convert an applicant to an employee
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {string} applicantId 応募者ID
         * @param {CreateEmployee} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async toEmployee(authorization: string, clientId: string, applicantId: string, body: CreateEmployee, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateEmployeeResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.toEmployee(authorization, clientId, applicantId, body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 対象クライアントの応募者を更新する。
         * @summary Update an applicant
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {string} applicantId 応募者ID
         * @param {UpdateApplicantRequest} updateApplicantRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateApplicant(authorization: string, clientId: string, applicantId: string, updateApplicantRequest: UpdateApplicantRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateApplicant(authorization, clientId, applicantId, updateApplicantRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ApplicantApi - factory interface
 * @export
 */
export const ApplicantApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ApplicantApiFp(configuration)
    return {
        /**
         * 対象クライアントの応募者を作成する。
         * @summary Create an applicant
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {CreateApplicantRequest} createApplicantRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createApplicant(authorization: string, clientId: string, createApplicantRequest: CreateApplicantRequest, options?: any): AxiosPromise<void> {
            return localVarFp.createApplicant(authorization, clientId, createApplicantRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 対象クライアントの応募者を削除する。
         * @summary Delete an applicant
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {string} applicantId 応募者ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteApplicant(authorization: string, clientId: string, applicantId: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteApplicant(authorization, clientId, applicantId, options).then((request) => request(axios, basePath));
        },
        /**
         * 対象クライアントの応募者を取得する。
         * @summary Get applicant list
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {string} applicantId 応募者ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApplicant(authorization: string, clientId: string, applicantId: string, options?: any): AxiosPromise<GetApplicantProfile> {
            return localVarFp.getApplicant(authorization, clientId, applicantId, options).then((request) => request(axios, basePath));
        },
        /**
         * 対象クライアントの応募者を取得する。
         * @summary Get applicant list
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {string} [limit] レスポンスのデータ制限
         * @param {string} [occupationId] 
         * @param {string} [departmentId] 
         * @param {string} [status] 
         * @param {string} [offset] 
         * @param {string} [name] 
         * @param {Array<string>} [departments] 
         * @param {Array<string>} [occupations] 
         * @param {string} [examStartDate] 
         * @param {string} [examEndDate] 
         * @param {boolean} [analysisFlg] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApplicants(authorization: string, clientId: string, limit?: string, occupationId?: string, departmentId?: string, status?: string, offset?: string, name?: string, departments?: Array<string>, occupations?: Array<string>, examStartDate?: string, examEndDate?: string, analysisFlg?: boolean, options?: any): AxiosPromise<GetApplicants200Response> {
            return localVarFp.getApplicants(authorization, clientId, limit, occupationId, departmentId, status, offset, name, departments, occupations, examStartDate, examEndDate, analysisFlg, options).then((request) => request(axios, basePath));
        },
        /**
         * 対象クライアントの応募者を従業員に変換する。
         * @summary Convert an applicant to an employee
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {string} applicantId 応募者ID
         * @param {CreateEmployee} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        toEmployee(authorization: string, clientId: string, applicantId: string, body: CreateEmployee, options?: any): AxiosPromise<CreateEmployeeResponse> {
            return localVarFp.toEmployee(authorization, clientId, applicantId, body, options).then((request) => request(axios, basePath));
        },
        /**
         * 対象クライアントの応募者を更新する。
         * @summary Update an applicant
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {string} applicantId 応募者ID
         * @param {UpdateApplicantRequest} updateApplicantRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateApplicant(authorization: string, clientId: string, applicantId: string, updateApplicantRequest: UpdateApplicantRequest, options?: any): AxiosPromise<void> {
            return localVarFp.updateApplicant(authorization, clientId, applicantId, updateApplicantRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ApplicantApi - object-oriented interface
 * @export
 * @class ApplicantApi
 * @extends {BaseAPI}
 */
export class ApplicantApi extends BaseAPI {
    /**
     * 対象クライアントの応募者を作成する。
     * @summary Create an applicant
     * @param {string} authorization 認証情報
     * @param {string} clientId クライアントID
     * @param {CreateApplicantRequest} createApplicantRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicantApi
     */
    public createApplicant(params: { authorization?: string, clientId?: string, createApplicantRequest: CreateApplicantRequest,  }, options?: any) {
				const _params = {} as any;
				_params['authorization'] = params['authorization']
				_params['clientId'] = params['clientId']
				_params['createApplicantRequest'] = params['createApplicantRequest']
				// @ts-ignore
				_params.authorization = 'Bearer ' + ( params.authorization || Store.getInstance().getAccessToken())!
				_params.clientId = ((params as any).clientId || (Store.getInstance().getAuth() || {}).clientId)!;
        return ApplicantApiFp(this.configuration).createApplicant(_params.authorization, _params.clientId, _params.createApplicantRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 対象クライアントの応募者を削除する。
     * @summary Delete an applicant
     * @param {string} authorization 認証情報
     * @param {string} clientId クライアントID
     * @param {string} applicantId 応募者ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicantApi
     */
    public deleteApplicant(params: { authorization?: string, clientId?: string, applicantId: string,  }, options?: any) {
				const _params = {} as any;
				_params['authorization'] = params['authorization']
				_params['clientId'] = params['clientId']
				_params['applicantId'] = params['applicantId']
				// @ts-ignore
				_params.authorization = 'Bearer ' + ( params.authorization || Store.getInstance().getAccessToken())!
				_params.clientId = ((params as any).clientId || (Store.getInstance().getAuth() || {}).clientId)!;
        return ApplicantApiFp(this.configuration).deleteApplicant(_params.authorization, _params.clientId, _params.applicantId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 対象クライアントの応募者を取得する。
     * @summary Get applicant list
     * @param {string} authorization 認証情報
     * @param {string} clientId クライアントID
     * @param {string} applicantId 応募者ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicantApi
     */
    public getApplicant(params: { authorization?: string, clientId?: string, applicantId: string,  }, options?: any) {
				const _params = {} as any;
				_params['authorization'] = params['authorization']
				_params['clientId'] = params['clientId']
				_params['applicantId'] = params['applicantId']
				// @ts-ignore
				_params.authorization = 'Bearer ' + ( params.authorization || Store.getInstance().getAccessToken())!
				_params.clientId = ((params as any).clientId || (Store.getInstance().getAuth() || {}).clientId)!;
        return ApplicantApiFp(this.configuration).getApplicant(_params.authorization, _params.clientId, _params.applicantId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 対象クライアントの応募者を取得する。
     * @summary Get applicant list
     * @param {string} authorization 認証情報
     * @param {string} clientId クライアントID
     * @param {string} [limit] レスポンスのデータ制限
     * @param {string} [occupationId] 
     * @param {string} [departmentId] 
     * @param {string} [status] 
     * @param {string} [offset] 
     * @param {string} [name] 
     * @param {Array<string>} [departments] 
     * @param {Array<string>} [occupations] 
     * @param {string} [examStartDate] 
     * @param {string} [examEndDate] 
     * @param {boolean} [analysisFlg] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicantApi
     */
    public getApplicants(params: { authorization?: string, clientId?: string, limit?: string, occupationId?: string, departmentId?: string, status?: string, offset?: string, name?: string, departments?: Array<string>, occupations?: Array<string>, examStartDate?: string, examEndDate?: string, analysisFlg?: boolean,  }, options?: any) {
				const _params = {} as any;
				_params['authorization'] = params['authorization']
				_params['clientId'] = params['clientId']
				_params['limit'] = params['limit']
				_params['occupationId'] = params['occupationId']
				_params['departmentId'] = params['departmentId']
				_params['status'] = params['status']
				_params['offset'] = params['offset']
				_params['name'] = params['name']
				_params['departments'] = params['departments']
				_params['occupations'] = params['occupations']
				_params['examStartDate'] = params['examStartDate']
				_params['examEndDate'] = params['examEndDate']
				_params['analysisFlg'] = params['analysisFlg']
				// @ts-ignore
				_params.authorization = 'Bearer ' + ( params.authorization || Store.getInstance().getAccessToken())!
				_params.clientId = ((params as any).clientId || (Store.getInstance().getAuth() || {}).clientId)!;
        return ApplicantApiFp(this.configuration).getApplicants(_params.authorization, _params.clientId, _params.limit, _params.occupationId, _params.departmentId, _params.status, _params.offset, _params.name, _params.departments, _params.occupations, _params.examStartDate, _params.examEndDate, _params.analysisFlg, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 対象クライアントの応募者を従業員に変換する。
     * @summary Convert an applicant to an employee
     * @param {string} authorization 認証情報
     * @param {string} clientId クライアントID
     * @param {string} applicantId 応募者ID
     * @param {CreateEmployee} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicantApi
     */
    public toEmployee(params: { authorization?: string, clientId?: string, applicantId: string, body: CreateEmployee,  }, options?: any) {
				const _params = {} as any;
				_params['authorization'] = params['authorization']
				_params['clientId'] = params['clientId']
				_params['applicantId'] = params['applicantId']
				_params['body'] = params['body']
				// @ts-ignore
				_params.authorization = 'Bearer ' + ( params.authorization || Store.getInstance().getAccessToken())!
				_params.clientId = ((params as any).clientId || (Store.getInstance().getAuth() || {}).clientId)!;
        return ApplicantApiFp(this.configuration).toEmployee(_params.authorization, _params.clientId, _params.applicantId, _params.body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 対象クライアントの応募者を更新する。
     * @summary Update an applicant
     * @param {string} authorization 認証情報
     * @param {string} clientId クライアントID
     * @param {string} applicantId 応募者ID
     * @param {UpdateApplicantRequest} updateApplicantRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicantApi
     */
    public updateApplicant(params: { authorization?: string, clientId?: string, applicantId: string, updateApplicantRequest: UpdateApplicantRequest,  }, options?: any) {
				const _params = {} as any;
				_params['authorization'] = params['authorization']
				_params['clientId'] = params['clientId']
				_params['applicantId'] = params['applicantId']
				_params['updateApplicantRequest'] = params['updateApplicantRequest']
				// @ts-ignore
				_params.authorization = 'Bearer ' + ( params.authorization || Store.getInstance().getAccessToken())!
				_params.clientId = ((params as any).clientId || (Store.getInstance().getAuth() || {}).clientId)!;
        return ApplicantApiFp(this.configuration).updateApplicant(_params.authorization, _params.clientId, _params.applicantId, _params.updateApplicantRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AsApi - axios parameter creator
 * @export
 */
export const AsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Authenticate the candidate
         * @param {string} authorization 認証情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authenticateAsCandidate: async (authorization: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('authenticateAsCandidate', 'authorization', authorization)
            const localVarPath = `/as/auth`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 対象クライアントのアセスメントサーベイの受験用URLを一斉送信する。
         * @summary Sendbatchemails
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {AsSendTaskBatchSendRequest} asSendTaskBatchSendRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        batchPostSendTask: async (authorization: string, clientId: string, asSendTaskBatchSendRequest: AsSendTaskBatchSendRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('batchPostSendTask', 'authorization', authorization)
            // verify required parameter 'clientId' is not null or undefined
            assertParamExists('batchPostSendTask', 'clientId', clientId)
            // verify required parameter 'asSendTaskBatchSendRequest' is not null or undefined
            assertParamExists('batchPostSendTask', 'asSendTaskBatchSendRequest', asSendTaskBatchSendRequest)
            const localVarPath = `/clients/{clientId}/asSendTask/batchSend`
                .replace(`{${"clientId"}}`, encodeURIComponent(String(clientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2PasswordBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(asSendTaskBatchSendRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 対象クライアントにアセスメントサーベイ一覧を作成する。
         * @summary Create Asbroadcast
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {CreateAsBroadcastRequest} createAsBroadcastRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAsBroadcast: async (authorization: string, clientId: string, createAsBroadcastRequest: CreateAsBroadcastRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('createAsBroadcast', 'authorization', authorization)
            // verify required parameter 'clientId' is not null or undefined
            assertParamExists('createAsBroadcast', 'clientId', clientId)
            // verify required parameter 'createAsBroadcastRequest' is not null or undefined
            assertParamExists('createAsBroadcast', 'createAsBroadcastRequest', createAsBroadcastRequest)
            const localVarPath = `/clients/{clientId}/asBroadcast`
                .replace(`{${"clientId"}}`, encodeURIComponent(String(clientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2PasswordBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createAsBroadcastRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create an examination record
         * @param {string} authorization 認証情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAsExaminationRecord: async (authorization: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('createAsExaminationRecord', 'authorization', authorization)
            const localVarPath = `/as/exam`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 対象クライアントのアセスメントサーベイを削除する。
         * @summary Delete Asbroadcast
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {string} asBroadcastId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAsBroadcast: async (authorization: string, clientId: string, asBroadcastId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('deleteAsBroadcast', 'authorization', authorization)
            // verify required parameter 'clientId' is not null or undefined
            assertParamExists('deleteAsBroadcast', 'clientId', clientId)
            // verify required parameter 'asBroadcastId' is not null or undefined
            assertParamExists('deleteAsBroadcast', 'asBroadcastId', asBroadcastId)
            const localVarPath = `/clients/{clientId}/asBroadcast/{asBroadcastId}`
                .replace(`{${"clientId"}}`, encodeURIComponent(String(clientId)))
                .replace(`{${"asBroadcastId"}}`, encodeURIComponent(String(asBroadcastId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2PasswordBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 対象クライアントのアセスメントサーベイから従業員、応募者を解除する。
         * @summary Delete AsSendTasks
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {string} asBroadcastId 
         * @param {DeleteAsSendTasksRequest} deleteAsSendTasksRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAsSendTasks: async (authorization: string, clientId: string, asBroadcastId: string, deleteAsSendTasksRequest: DeleteAsSendTasksRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('deleteAsSendTasks', 'authorization', authorization)
            // verify required parameter 'clientId' is not null or undefined
            assertParamExists('deleteAsSendTasks', 'clientId', clientId)
            // verify required parameter 'asBroadcastId' is not null or undefined
            assertParamExists('deleteAsSendTasks', 'asBroadcastId', asBroadcastId)
            // verify required parameter 'deleteAsSendTasksRequest' is not null or undefined
            assertParamExists('deleteAsSendTasks', 'deleteAsSendTasksRequest', deleteAsSendTasksRequest)
            const localVarPath = `/clients/{clientId}/asBroadcast/{asBroadcastId}/asSendTask/delete`
                .replace(`{${"clientId"}}`, encodeURIComponent(String(clientId)))
                .replace(`{${"asBroadcastId"}}`, encodeURIComponent(String(asBroadcastId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2PasswordBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(deleteAsSendTasksRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 対象クライアントのアセスメントサーベイの情報を取得する。
         * @summary Get an AS Broadcast
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {string} asBroadcastId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAsBroadcast: async (authorization: string, clientId: string, asBroadcastId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('getAsBroadcast', 'authorization', authorization)
            // verify required parameter 'clientId' is not null or undefined
            assertParamExists('getAsBroadcast', 'clientId', clientId)
            // verify required parameter 'asBroadcastId' is not null or undefined
            assertParamExists('getAsBroadcast', 'asBroadcastId', asBroadcastId)
            const localVarPath = `/clients/{clientId}/asBroadcast/{asBroadcastId}`
                .replace(`{${"clientId"}}`, encodeURIComponent(String(clientId)))
                .replace(`{${"asBroadcastId"}}`, encodeURIComponent(String(asBroadcastId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 対象クライアントのアセスメントサーベイ一覧を取得する。
         * @summary Read Asbroadcast
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {string} [q] 
         * @param {AsBroadcastTypeEnum} [type] 
         * @param {boolean} [onPeriod] 
         * @param {boolean} [excludeCompletion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAsBroadcasts: async (authorization: string, clientId: string, q?: string, type?: AsBroadcastTypeEnum, onPeriod?: boolean, excludeCompletion?: boolean, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('getAsBroadcasts', 'authorization', authorization)
            // verify required parameter 'clientId' is not null or undefined
            assertParamExists('getAsBroadcasts', 'clientId', clientId)
            const localVarPath = `/clients/{clientId}/asBroadcast`
                .replace(`{${"clientId"}}`, encodeURIComponent(String(clientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2PasswordBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }

            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }

            if (onPeriod !== undefined) {
                localVarQueryParameter['onPeriod'] = onPeriod;
            }

            if (excludeCompletion !== undefined) {
                localVarQueryParameter['excludeCompletion'] = excludeCompletion;
            }

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Assendtaskdetails
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {string} asSendTaskId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAsSendTask: async (authorization: string, clientId: string, asSendTaskId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('getAsSendTask', 'authorization', authorization)
            // verify required parameter 'clientId' is not null or undefined
            assertParamExists('getAsSendTask', 'clientId', clientId)
            // verify required parameter 'asSendTaskId' is not null or undefined
            assertParamExists('getAsSendTask', 'asSendTaskId', asSendTaskId)
            const localVarPath = `/clients/{clientId}/asSendTask/{asSendTaskId}`
                .replace(`{${"clientId"}}`, encodeURIComponent(String(clientId)))
                .replace(`{${"asSendTaskId"}}`, encodeURIComponent(String(asSendTaskId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2PasswordBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 対象クライアントのアセスメントサーベイの受検URLを一括送信する。
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {string} asSendTaskId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invalidateAsUrl: async (authorization: string, clientId: string, asSendTaskId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('invalidateAsUrl', 'authorization', authorization)
            // verify required parameter 'clientId' is not null or undefined
            assertParamExists('invalidateAsUrl', 'clientId', clientId)
            // verify required parameter 'asSendTaskId' is not null or undefined
            assertParamExists('invalidateAsUrl', 'asSendTaskId', asSendTaskId)
            const localVarPath = `/clients/{clientId}/asSendTask/{asSendTaskId}/invalidate`
                .replace(`{${"clientId"}}`, encodeURIComponent(String(clientId)))
                .replace(`{${"asSendTaskId"}}`, encodeURIComponent(String(asSendTaskId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 対象クライアントのアセスメントサーベイの受検URLを再発行する。
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {string} asSendTaskId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        issueAsUrl: async (authorization: string, clientId: string, asSendTaskId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('issueAsUrl', 'authorization', authorization)
            // verify required parameter 'clientId' is not null or undefined
            assertParamExists('issueAsUrl', 'clientId', clientId)
            // verify required parameter 'asSendTaskId' is not null or undefined
            assertParamExists('issueAsUrl', 'asSendTaskId', asSendTaskId)
            const localVarPath = `/clients/{clientId}/asSendTask/{asSendTaskId}/issue`
                .replace(`{${"clientId"}}`, encodeURIComponent(String(clientId)))
                .replace(`{${"asSendTaskId"}}`, encodeURIComponent(String(asSendTaskId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 対象クライアントのアセスメントサーベイに従業員、応募者を設定する。
         * @summary Register AsSendTask
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {string} asBroadcastId 
         * @param {RegisterAsSendTaskRequest} registerAsSendTaskRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerAsSendtask: async (authorization: string, clientId: string, asBroadcastId: string, registerAsSendTaskRequest: RegisterAsSendTaskRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('registerAsSendtask', 'authorization', authorization)
            // verify required parameter 'clientId' is not null or undefined
            assertParamExists('registerAsSendtask', 'clientId', clientId)
            // verify required parameter 'asBroadcastId' is not null or undefined
            assertParamExists('registerAsSendtask', 'asBroadcastId', asBroadcastId)
            // verify required parameter 'registerAsSendTaskRequest' is not null or undefined
            assertParamExists('registerAsSendtask', 'registerAsSendTaskRequest', registerAsSendTaskRequest)
            const localVarPath = `/clients/{clientId}/asBroadcast/{asBroadcastId}/asSendTask/register`
                .replace(`{${"clientId"}}`, encodeURIComponent(String(clientId)))
                .replace(`{${"asBroadcastId"}}`, encodeURIComponent(String(asBroadcastId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2PasswordBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(registerAsSendTaskRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 対象クライアントのアセスメントサーベイを更新する。
         * @summary Update Asbroadcast
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {string} asBroadcastId 
         * @param {UpdateAsBroadcastRequest} updateAsBroadcastRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAsBroadcast: async (authorization: string, clientId: string, asBroadcastId: string, updateAsBroadcastRequest: UpdateAsBroadcastRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('updateAsBroadcast', 'authorization', authorization)
            // verify required parameter 'clientId' is not null or undefined
            assertParamExists('updateAsBroadcast', 'clientId', clientId)
            // verify required parameter 'asBroadcastId' is not null or undefined
            assertParamExists('updateAsBroadcast', 'asBroadcastId', asBroadcastId)
            // verify required parameter 'updateAsBroadcastRequest' is not null or undefined
            assertParamExists('updateAsBroadcast', 'updateAsBroadcastRequest', updateAsBroadcastRequest)
            const localVarPath = `/clients/{clientId}/asBroadcast/{asBroadcastId}`
                .replace(`{${"clientId"}}`, encodeURIComponent(String(clientId)))
                .replace(`{${"asBroadcastId"}}`, encodeURIComponent(String(asBroadcastId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2PasswordBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateAsBroadcastRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Record an examination input
         * @param {string} authorization 認証情報
         * @param {Array<UpdateAsExaminationRecordRequestInner>} updateAsExaminationRecordRequestInner 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAsExaminationRecord: async (authorization: string, updateAsExaminationRecordRequestInner: Array<UpdateAsExaminationRecordRequestInner>, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('updateAsExaminationRecord', 'authorization', authorization)
            // verify required parameter 'updateAsExaminationRecordRequestInner' is not null or undefined
            assertParamExists('updateAsExaminationRecord', 'updateAsExaminationRecordRequestInner', updateAsExaminationRecordRequestInner)
            const localVarPath = `/as/exam`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateAsExaminationRecordRequestInner, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AsApi - functional programming interface
 * @export
 */
export const AsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Authenticate the candidate
         * @param {string} authorization 認証情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authenticateAsCandidate(authorization: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<User>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authenticateAsCandidate(authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 対象クライアントのアセスメントサーベイの受験用URLを一斉送信する。
         * @summary Sendbatchemails
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {AsSendTaskBatchSendRequest} asSendTaskBatchSendRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async batchPostSendTask(authorization: string, clientId: string, asSendTaskBatchSendRequest: AsSendTaskBatchSendRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AsSendTaskBatchSendResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.batchPostSendTask(authorization, clientId, asSendTaskBatchSendRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 対象クライアントにアセスメントサーベイ一覧を作成する。
         * @summary Create Asbroadcast
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {CreateAsBroadcastRequest} createAsBroadcastRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createAsBroadcast(authorization: string, clientId: string, createAsBroadcastRequest: CreateAsBroadcastRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createAsBroadcast(authorization, clientId, createAsBroadcastRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Create an examination record
         * @param {string} authorization 認証情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createAsExaminationRecord(authorization: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createAsExaminationRecord(authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 対象クライアントのアセスメントサーベイを削除する。
         * @summary Delete Asbroadcast
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {string} asBroadcastId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteAsBroadcast(authorization: string, clientId: string, asBroadcastId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteAsBroadcast(authorization, clientId, asBroadcastId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 対象クライアントのアセスメントサーベイから従業員、応募者を解除する。
         * @summary Delete AsSendTasks
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {string} asBroadcastId 
         * @param {DeleteAsSendTasksRequest} deleteAsSendTasksRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteAsSendTasks(authorization: string, clientId: string, asBroadcastId: string, deleteAsSendTasksRequest: DeleteAsSendTasksRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteAsSendTasks(authorization, clientId, asBroadcastId, deleteAsSendTasksRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 対象クライアントのアセスメントサーベイの情報を取得する。
         * @summary Get an AS Broadcast
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {string} asBroadcastId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAsBroadcast(authorization: string, clientId: string, asBroadcastId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetAsBroadcastResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAsBroadcast(authorization, clientId, asBroadcastId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 対象クライアントのアセスメントサーベイ一覧を取得する。
         * @summary Read Asbroadcast
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {string} [q] 
         * @param {AsBroadcastTypeEnum} [type] 
         * @param {boolean} [onPeriod] 
         * @param {boolean} [excludeCompletion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAsBroadcasts(authorization: string, clientId: string, q?: string, type?: AsBroadcastTypeEnum, onPeriod?: boolean, excludeCompletion?: boolean, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetAsBroadcasts>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAsBroadcasts(authorization, clientId, q, type, onPeriod, excludeCompletion, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get Assendtaskdetails
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {string} asSendTaskId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAsSendTask(authorization: string, clientId: string, asSendTaskId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AsSendTaskDetails>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAsSendTask(authorization, clientId, asSendTaskId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 対象クライアントのアセスメントサーベイの受検URLを一括送信する。
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {string} asSendTaskId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async invalidateAsUrl(authorization: string, clientId: string, asSendTaskId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.invalidateAsUrl(authorization, clientId, asSendTaskId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 対象クライアントのアセスメントサーベイの受検URLを再発行する。
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {string} asSendTaskId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async issueAsUrl(authorization: string, clientId: string, asSendTaskId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IssueAsUrl200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.issueAsUrl(authorization, clientId, asSendTaskId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 対象クライアントのアセスメントサーベイに従業員、応募者を設定する。
         * @summary Register AsSendTask
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {string} asBroadcastId 
         * @param {RegisterAsSendTaskRequest} registerAsSendTaskRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async registerAsSendtask(authorization: string, clientId: string, asBroadcastId: string, registerAsSendTaskRequest: RegisterAsSendTaskRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.registerAsSendtask(authorization, clientId, asBroadcastId, registerAsSendTaskRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 対象クライアントのアセスメントサーベイを更新する。
         * @summary Update Asbroadcast
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {string} asBroadcastId 
         * @param {UpdateAsBroadcastRequest} updateAsBroadcastRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateAsBroadcast(authorization: string, clientId: string, asBroadcastId: string, updateAsBroadcastRequest: UpdateAsBroadcastRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateAsBroadcast(authorization, clientId, asBroadcastId, updateAsBroadcastRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Record an examination input
         * @param {string} authorization 認証情報
         * @param {Array<UpdateAsExaminationRecordRequestInner>} updateAsExaminationRecordRequestInner 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateAsExaminationRecord(authorization: string, updateAsExaminationRecordRequestInner: Array<UpdateAsExaminationRecordRequestInner>, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateAsExaminationRecord(authorization, updateAsExaminationRecordRequestInner, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AsApi - factory interface
 * @export
 */
export const AsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AsApiFp(configuration)
    return {
        /**
         * 
         * @summary Authenticate the candidate
         * @param {string} authorization 認証情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authenticateAsCandidate(authorization: string, options?: any): AxiosPromise<User> {
            return localVarFp.authenticateAsCandidate(authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 対象クライアントのアセスメントサーベイの受験用URLを一斉送信する。
         * @summary Sendbatchemails
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {AsSendTaskBatchSendRequest} asSendTaskBatchSendRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        batchPostSendTask(authorization: string, clientId: string, asSendTaskBatchSendRequest: AsSendTaskBatchSendRequest, options?: any): AxiosPromise<AsSendTaskBatchSendResponse> {
            return localVarFp.batchPostSendTask(authorization, clientId, asSendTaskBatchSendRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 対象クライアントにアセスメントサーベイ一覧を作成する。
         * @summary Create Asbroadcast
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {CreateAsBroadcastRequest} createAsBroadcastRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAsBroadcast(authorization: string, clientId: string, createAsBroadcastRequest: CreateAsBroadcastRequest, options?: any): AxiosPromise<any> {
            return localVarFp.createAsBroadcast(authorization, clientId, createAsBroadcastRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create an examination record
         * @param {string} authorization 認証情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAsExaminationRecord(authorization: string, options?: any): AxiosPromise<object> {
            return localVarFp.createAsExaminationRecord(authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 対象クライアントのアセスメントサーベイを削除する。
         * @summary Delete Asbroadcast
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {string} asBroadcastId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAsBroadcast(authorization: string, clientId: string, asBroadcastId: string, options?: any): AxiosPromise<any> {
            return localVarFp.deleteAsBroadcast(authorization, clientId, asBroadcastId, options).then((request) => request(axios, basePath));
        },
        /**
         * 対象クライアントのアセスメントサーベイから従業員、応募者を解除する。
         * @summary Delete AsSendTasks
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {string} asBroadcastId 
         * @param {DeleteAsSendTasksRequest} deleteAsSendTasksRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAsSendTasks(authorization: string, clientId: string, asBroadcastId: string, deleteAsSendTasksRequest: DeleteAsSendTasksRequest, options?: any): AxiosPromise<any> {
            return localVarFp.deleteAsSendTasks(authorization, clientId, asBroadcastId, deleteAsSendTasksRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 対象クライアントのアセスメントサーベイの情報を取得する。
         * @summary Get an AS Broadcast
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {string} asBroadcastId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAsBroadcast(authorization: string, clientId: string, asBroadcastId: string, options?: any): AxiosPromise<GetAsBroadcastResponse> {
            return localVarFp.getAsBroadcast(authorization, clientId, asBroadcastId, options).then((request) => request(axios, basePath));
        },
        /**
         * 対象クライアントのアセスメントサーベイ一覧を取得する。
         * @summary Read Asbroadcast
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {string} [q] 
         * @param {AsBroadcastTypeEnum} [type] 
         * @param {boolean} [onPeriod] 
         * @param {boolean} [excludeCompletion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAsBroadcasts(authorization: string, clientId: string, q?: string, type?: AsBroadcastTypeEnum, onPeriod?: boolean, excludeCompletion?: boolean, options?: any): AxiosPromise<Array<GetAsBroadcasts>> {
            return localVarFp.getAsBroadcasts(authorization, clientId, q, type, onPeriod, excludeCompletion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Assendtaskdetails
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {string} asSendTaskId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAsSendTask(authorization: string, clientId: string, asSendTaskId: string, options?: any): AxiosPromise<AsSendTaskDetails> {
            return localVarFp.getAsSendTask(authorization, clientId, asSendTaskId, options).then((request) => request(axios, basePath));
        },
        /**
         * 対象クライアントのアセスメントサーベイの受検URLを一括送信する。
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {string} asSendTaskId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invalidateAsUrl(authorization: string, clientId: string, asSendTaskId: string, options?: any): AxiosPromise<void> {
            return localVarFp.invalidateAsUrl(authorization, clientId, asSendTaskId, options).then((request) => request(axios, basePath));
        },
        /**
         * 対象クライアントのアセスメントサーベイの受検URLを再発行する。
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {string} asSendTaskId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        issueAsUrl(authorization: string, clientId: string, asSendTaskId: string, options?: any): AxiosPromise<IssueAsUrl200Response> {
            return localVarFp.issueAsUrl(authorization, clientId, asSendTaskId, options).then((request) => request(axios, basePath));
        },
        /**
         * 対象クライアントのアセスメントサーベイに従業員、応募者を設定する。
         * @summary Register AsSendTask
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {string} asBroadcastId 
         * @param {RegisterAsSendTaskRequest} registerAsSendTaskRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerAsSendtask(authorization: string, clientId: string, asBroadcastId: string, registerAsSendTaskRequest: RegisterAsSendTaskRequest, options?: any): AxiosPromise<any> {
            return localVarFp.registerAsSendtask(authorization, clientId, asBroadcastId, registerAsSendTaskRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 対象クライアントのアセスメントサーベイを更新する。
         * @summary Update Asbroadcast
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {string} asBroadcastId 
         * @param {UpdateAsBroadcastRequest} updateAsBroadcastRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAsBroadcast(authorization: string, clientId: string, asBroadcastId: string, updateAsBroadcastRequest: UpdateAsBroadcastRequest, options?: any): AxiosPromise<any> {
            return localVarFp.updateAsBroadcast(authorization, clientId, asBroadcastId, updateAsBroadcastRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Record an examination input
         * @param {string} authorization 認証情報
         * @param {Array<UpdateAsExaminationRecordRequestInner>} updateAsExaminationRecordRequestInner 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAsExaminationRecord(authorization: string, updateAsExaminationRecordRequestInner: Array<UpdateAsExaminationRecordRequestInner>, options?: any): AxiosPromise<object> {
            return localVarFp.updateAsExaminationRecord(authorization, updateAsExaminationRecordRequestInner, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AsApi - object-oriented interface
 * @export
 * @class AsApi
 * @extends {BaseAPI}
 */
export class AsApi extends BaseAPI {
    /**
     * 
     * @summary Authenticate the candidate
     * @param {string} authorization 認証情報
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AsApi
     */
    public authenticateAsCandidate(params: { authorization?: string,  }, options?: any) {
				const _params = {} as any;
				_params['authorization'] = params['authorization']
				// @ts-ignore
				_params.authorization = 'Bearer ' + ( params.authorization || Store.getInstance().getAccessToken())!
				_params.clientId = ((params as any).clientId || (Store.getInstance().getAuth() || {}).clientId)!;
        return AsApiFp(this.configuration).authenticateAsCandidate(_params.authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 対象クライアントのアセスメントサーベイの受験用URLを一斉送信する。
     * @summary Sendbatchemails
     * @param {string} authorization 認証情報
     * @param {string} clientId クライアントID
     * @param {AsSendTaskBatchSendRequest} asSendTaskBatchSendRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AsApi
     */
    public batchPostSendTask(params: { authorization?: string, clientId?: string, asSendTaskBatchSendRequest: AsSendTaskBatchSendRequest,  }, options?: any) {
				const _params = {} as any;
				_params['authorization'] = params['authorization']
				_params['clientId'] = params['clientId']
				_params['asSendTaskBatchSendRequest'] = params['asSendTaskBatchSendRequest']
				// @ts-ignore
				_params.authorization = 'Bearer ' + ( params.authorization || Store.getInstance().getAccessToken())!
				_params.clientId = ((params as any).clientId || (Store.getInstance().getAuth() || {}).clientId)!;
        return AsApiFp(this.configuration).batchPostSendTask(_params.authorization, _params.clientId, _params.asSendTaskBatchSendRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 対象クライアントにアセスメントサーベイ一覧を作成する。
     * @summary Create Asbroadcast
     * @param {string} authorization 認証情報
     * @param {string} clientId クライアントID
     * @param {CreateAsBroadcastRequest} createAsBroadcastRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AsApi
     */
    public createAsBroadcast(params: { authorization?: string, clientId?: string, createAsBroadcastRequest: CreateAsBroadcastRequest,  }, options?: any) {
				const _params = {} as any;
				_params['authorization'] = params['authorization']
				_params['clientId'] = params['clientId']
				_params['createAsBroadcastRequest'] = params['createAsBroadcastRequest']
				// @ts-ignore
				_params.authorization = 'Bearer ' + ( params.authorization || Store.getInstance().getAccessToken())!
				_params.clientId = ((params as any).clientId || (Store.getInstance().getAuth() || {}).clientId)!;
        return AsApiFp(this.configuration).createAsBroadcast(_params.authorization, _params.clientId, _params.createAsBroadcastRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create an examination record
     * @param {string} authorization 認証情報
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AsApi
     */
    public createAsExaminationRecord(params: { authorization?: string,  }, options?: any) {
				const _params = {} as any;
				_params['authorization'] = params['authorization']
				// @ts-ignore
				_params.authorization = 'Bearer ' + ( params.authorization || Store.getInstance().getAccessToken())!
				_params.clientId = ((params as any).clientId || (Store.getInstance().getAuth() || {}).clientId)!;
        return AsApiFp(this.configuration).createAsExaminationRecord(_params.authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 対象クライアントのアセスメントサーベイを削除する。
     * @summary Delete Asbroadcast
     * @param {string} authorization 認証情報
     * @param {string} clientId クライアントID
     * @param {string} asBroadcastId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AsApi
     */
    public deleteAsBroadcast(params: { authorization?: string, clientId?: string, asBroadcastId: string,  }, options?: any) {
				const _params = {} as any;
				_params['authorization'] = params['authorization']
				_params['clientId'] = params['clientId']
				_params['asBroadcastId'] = params['asBroadcastId']
				// @ts-ignore
				_params.authorization = 'Bearer ' + ( params.authorization || Store.getInstance().getAccessToken())!
				_params.clientId = ((params as any).clientId || (Store.getInstance().getAuth() || {}).clientId)!;
        return AsApiFp(this.configuration).deleteAsBroadcast(_params.authorization, _params.clientId, _params.asBroadcastId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 対象クライアントのアセスメントサーベイから従業員、応募者を解除する。
     * @summary Delete AsSendTasks
     * @param {string} authorization 認証情報
     * @param {string} clientId クライアントID
     * @param {string} asBroadcastId 
     * @param {DeleteAsSendTasksRequest} deleteAsSendTasksRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AsApi
     */
    public deleteAsSendTasks(params: { authorization?: string, clientId?: string, asBroadcastId: string, deleteAsSendTasksRequest: DeleteAsSendTasksRequest,  }, options?: any) {
				const _params = {} as any;
				_params['authorization'] = params['authorization']
				_params['clientId'] = params['clientId']
				_params['asBroadcastId'] = params['asBroadcastId']
				_params['deleteAsSendTasksRequest'] = params['deleteAsSendTasksRequest']
				// @ts-ignore
				_params.authorization = 'Bearer ' + ( params.authorization || Store.getInstance().getAccessToken())!
				_params.clientId = ((params as any).clientId || (Store.getInstance().getAuth() || {}).clientId)!;
        return AsApiFp(this.configuration).deleteAsSendTasks(_params.authorization, _params.clientId, _params.asBroadcastId, _params.deleteAsSendTasksRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 対象クライアントのアセスメントサーベイの情報を取得する。
     * @summary Get an AS Broadcast
     * @param {string} authorization 認証情報
     * @param {string} clientId クライアントID
     * @param {string} asBroadcastId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AsApi
     */
    public getAsBroadcast(params: { authorization?: string, clientId?: string, asBroadcastId: string,  }, options?: any) {
				const _params = {} as any;
				_params['authorization'] = params['authorization']
				_params['clientId'] = params['clientId']
				_params['asBroadcastId'] = params['asBroadcastId']
				// @ts-ignore
				_params.authorization = 'Bearer ' + ( params.authorization || Store.getInstance().getAccessToken())!
				_params.clientId = ((params as any).clientId || (Store.getInstance().getAuth() || {}).clientId)!;
        return AsApiFp(this.configuration).getAsBroadcast(_params.authorization, _params.clientId, _params.asBroadcastId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 対象クライアントのアセスメントサーベイ一覧を取得する。
     * @summary Read Asbroadcast
     * @param {string} authorization 認証情報
     * @param {string} clientId クライアントID
     * @param {string} [q] 
     * @param {AsBroadcastTypeEnum} [type] 
     * @param {boolean} [onPeriod] 
     * @param {boolean} [excludeCompletion] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AsApi
     */
    public getAsBroadcasts(params: { authorization?: string, clientId?: string, q?: string, type?: AsBroadcastTypeEnum, onPeriod?: boolean, excludeCompletion?: boolean,  }, options?: any) {
				const _params = {} as any;
				_params['authorization'] = params['authorization']
				_params['clientId'] = params['clientId']
				_params['q'] = params['q']
				_params['type'] = params['type']
				_params['onPeriod'] = params['onPeriod']
				_params['excludeCompletion'] = params['excludeCompletion']
				// @ts-ignore
				_params.authorization = 'Bearer ' + ( params.authorization || Store.getInstance().getAccessToken())!
				_params.clientId = ((params as any).clientId || (Store.getInstance().getAuth() || {}).clientId)!;
        return AsApiFp(this.configuration).getAsBroadcasts(_params.authorization, _params.clientId, _params.q, _params.type, _params.onPeriod, _params.excludeCompletion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Assendtaskdetails
     * @param {string} authorization 認証情報
     * @param {string} clientId クライアントID
     * @param {string} asSendTaskId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AsApi
     */
    public getAsSendTask(params: { authorization?: string, clientId?: string, asSendTaskId: string,  }, options?: any) {
				const _params = {} as any;
				_params['authorization'] = params['authorization']
				_params['clientId'] = params['clientId']
				_params['asSendTaskId'] = params['asSendTaskId']
				// @ts-ignore
				_params.authorization = 'Bearer ' + ( params.authorization || Store.getInstance().getAccessToken())!
				_params.clientId = ((params as any).clientId || (Store.getInstance().getAuth() || {}).clientId)!;
        return AsApiFp(this.configuration).getAsSendTask(_params.authorization, _params.clientId, _params.asSendTaskId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 対象クライアントのアセスメントサーベイの受検URLを一括送信する。
     * @param {string} authorization 認証情報
     * @param {string} clientId クライアントID
     * @param {string} asSendTaskId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AsApi
     */
    public invalidateAsUrl(params: { authorization?: string, clientId?: string, asSendTaskId: string,  }, options?: any) {
				const _params = {} as any;
				_params['authorization'] = params['authorization']
				_params['clientId'] = params['clientId']
				_params['asSendTaskId'] = params['asSendTaskId']
				// @ts-ignore
				_params.authorization = 'Bearer ' + ( params.authorization || Store.getInstance().getAccessToken())!
				_params.clientId = ((params as any).clientId || (Store.getInstance().getAuth() || {}).clientId)!;
        return AsApiFp(this.configuration).invalidateAsUrl(_params.authorization, _params.clientId, _params.asSendTaskId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 対象クライアントのアセスメントサーベイの受検URLを再発行する。
     * @param {string} authorization 認証情報
     * @param {string} clientId クライアントID
     * @param {string} asSendTaskId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AsApi
     */
    public issueAsUrl(params: { authorization?: string, clientId?: string, asSendTaskId: string,  }, options?: any) {
				const _params = {} as any;
				_params['authorization'] = params['authorization']
				_params['clientId'] = params['clientId']
				_params['asSendTaskId'] = params['asSendTaskId']
				// @ts-ignore
				_params.authorization = 'Bearer ' + ( params.authorization || Store.getInstance().getAccessToken())!
				_params.clientId = ((params as any).clientId || (Store.getInstance().getAuth() || {}).clientId)!;
        return AsApiFp(this.configuration).issueAsUrl(_params.authorization, _params.clientId, _params.asSendTaskId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 対象クライアントのアセスメントサーベイに従業員、応募者を設定する。
     * @summary Register AsSendTask
     * @param {string} authorization 認証情報
     * @param {string} clientId クライアントID
     * @param {string} asBroadcastId 
     * @param {RegisterAsSendTaskRequest} registerAsSendTaskRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AsApi
     */
    public registerAsSendtask(params: { authorization?: string, clientId?: string, asBroadcastId: string, registerAsSendTaskRequest: RegisterAsSendTaskRequest,  }, options?: any) {
				const _params = {} as any;
				_params['authorization'] = params['authorization']
				_params['clientId'] = params['clientId']
				_params['asBroadcastId'] = params['asBroadcastId']
				_params['registerAsSendTaskRequest'] = params['registerAsSendTaskRequest']
				// @ts-ignore
				_params.authorization = 'Bearer ' + ( params.authorization || Store.getInstance().getAccessToken())!
				_params.clientId = ((params as any).clientId || (Store.getInstance().getAuth() || {}).clientId)!;
        return AsApiFp(this.configuration).registerAsSendtask(_params.authorization, _params.clientId, _params.asBroadcastId, _params.registerAsSendTaskRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 対象クライアントのアセスメントサーベイを更新する。
     * @summary Update Asbroadcast
     * @param {string} authorization 認証情報
     * @param {string} clientId クライアントID
     * @param {string} asBroadcastId 
     * @param {UpdateAsBroadcastRequest} updateAsBroadcastRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AsApi
     */
    public updateAsBroadcast(params: { authorization?: string, clientId?: string, asBroadcastId: string, updateAsBroadcastRequest: UpdateAsBroadcastRequest,  }, options?: any) {
				const _params = {} as any;
				_params['authorization'] = params['authorization']
				_params['clientId'] = params['clientId']
				_params['asBroadcastId'] = params['asBroadcastId']
				_params['updateAsBroadcastRequest'] = params['updateAsBroadcastRequest']
				// @ts-ignore
				_params.authorization = 'Bearer ' + ( params.authorization || Store.getInstance().getAccessToken())!
				_params.clientId = ((params as any).clientId || (Store.getInstance().getAuth() || {}).clientId)!;
        return AsApiFp(this.configuration).updateAsBroadcast(_params.authorization, _params.clientId, _params.asBroadcastId, _params.updateAsBroadcastRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Record an examination input
     * @param {string} authorization 認証情報
     * @param {Array<UpdateAsExaminationRecordRequestInner>} updateAsExaminationRecordRequestInner 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AsApi
     */
    public updateAsExaminationRecord(params: { authorization?: string, updateAsExaminationRecordRequestInner: Array<UpdateAsExaminationRecordRequestInner>,  }, options?: any) {
				const _params = {} as any;
				_params['authorization'] = params['authorization']
				_params['updateAsExaminationRecordRequestInner'] = params['updateAsExaminationRecordRequestInner']
				// @ts-ignore
				_params.authorization = 'Bearer ' + ( params.authorization || Store.getInstance().getAccessToken())!
				_params.clientId = ((params as any).clientId || (Store.getInstance().getAuth() || {}).clientId)!;
        return AsApiFp(this.configuration).updateAsExaminationRecord(_params.authorization, _params.updateAsExaminationRecordRequestInner, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AuthApi - axios parameter creator
 * @export
 */
export const AuthApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 認証を行い、アクセストークン等の認証情報を返す。
         * @summary Authenticate users
         * @param {string} authorization 認証情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authenticate: async (authorization: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('authenticate', 'authorization', authorization)
            const localVarPath = `/authenticate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * パスワードを変更する。
         * @summary Changepassword
         * @param {ChangePasswordRequest} changePasswordRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changePassword: async (changePasswordRequest: ChangePasswordRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'changePasswordRequest' is not null or undefined
            assertParamExists('changePassword', 'changePasswordRequest', changePasswordRequest)
            const localVarPath = `/change_password`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(changePasswordRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * パスワード再設定の確認をリクエストする。
         * @summary Confirm Forgot Password
         * @param {ConfirmForgotPasswordRequest} confirmForgotPasswordRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirmForgotPassword: async (confirmForgotPasswordRequest: ConfirmForgotPasswordRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'confirmForgotPasswordRequest' is not null or undefined
            assertParamExists('confirmForgotPassword', 'confirmForgotPasswordRequest', confirmForgotPasswordRequest)
            const localVarPath = `/confirm_forgot_password`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(confirmForgotPasswordRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 対象クライアントにロールを作成する。
         * @summary Create role
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {RoleRequest} roleRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRole: async (authorization: string, clientId: string, roleRequest: RoleRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('createRole', 'authorization', authorization)
            // verify required parameter 'clientId' is not null or undefined
            assertParamExists('createRole', 'clientId', clientId)
            // verify required parameter 'roleRequest' is not null or undefined
            assertParamExists('createRole', 'roleRequest', roleRequest)
            const localVarPath = `/clients/{clientId}/roles`
                .replace(`{${"clientId"}}`, encodeURIComponent(String(clientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(roleRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 対象クライアントのロールを削除する。
         * @summary Delete rol
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteRole: async (authorization: string, clientId: string, id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('deleteRole', 'authorization', authorization)
            // verify required parameter 'clientId' is not null or undefined
            assertParamExists('deleteRole', 'clientId', clientId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteRole', 'id', id)
            const localVarPath = `/clients/{clientId}/roles/{id}`
                .replace(`{${"clientId"}}`, encodeURIComponent(String(clientId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * パスワード再設定をリクエストする。
         * @summary Forgot Password
         * @param {ForgotPasswordRequest} forgotPasswordRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        forgotPassword: async (forgotPasswordRequest: ForgotPasswordRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'forgotPasswordRequest' is not null or undefined
            assertParamExists('forgotPassword', 'forgotPasswordRequest', forgotPasswordRequest)
            const localVarPath = `/forgot_password`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(forgotPasswordRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 対象クライアントのロールを取得する。
         * @summary Get roles by login user
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRole: async (authorization: string, clientId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('getRole', 'authorization', authorization)
            // verify required parameter 'clientId' is not null or undefined
            assertParamExists('getRole', 'clientId', clientId)
            const localVarPath = `/clients/{clientId}/role`
                .replace(`{${"clientId"}}`, encodeURIComponent(String(clientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 対象クライアントのロール一覧を取得する。
         * @summary Get roles
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRoles: async (authorization: string, clientId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('getRoles', 'authorization', authorization)
            // verify required parameter 'clientId' is not null or undefined
            assertParamExists('getRoles', 'clientId', clientId)
            const localVarPath = `/clients/{clientId}/roles`
                .replace(`{${"clientId"}}`, encodeURIComponent(String(clientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * ログイン時の認証を行う。ユーザに関する情報とアクセストークンを返す。
         * @summary Get users log in to the system
         * @param {string} username 
         * @param {string} password 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        login: async (username: string, password: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'username' is not null or undefined
            assertParamExists('login', 'username', username)
            // verify required parameter 'password' is not null or undefined
            assertParamExists('login', 'password', password)
            const localVarPath = `/login`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new URLSearchParams();


            if (username !== undefined) { 
                localVarFormParams.set('username', username as any);
            }
    
            if (password !== undefined) { 
                localVarFormParams.set('password', password as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams.toString();

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 指定した認証情報のログアウトをリクエストする。
         * @summary Logout
         * @param {string} authorization 認証情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logout: async (authorization: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('logout', 'authorization', authorization)
            const localVarPath = `/logout`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 対象クライアントのロールを更新する。
         * @summary Update role
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {string} id 
         * @param {RoleRequest} roleRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRole: async (authorization: string, clientId: string, id: string, roleRequest: RoleRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('updateRole', 'authorization', authorization)
            // verify required parameter 'clientId' is not null or undefined
            assertParamExists('updateRole', 'clientId', clientId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateRole', 'id', id)
            // verify required parameter 'roleRequest' is not null or undefined
            assertParamExists('updateRole', 'roleRequest', roleRequest)
            const localVarPath = `/clients/{clientId}/roles/{id}`
                .replace(`{${"clientId"}}`, encodeURIComponent(String(clientId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(roleRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AuthApi - functional programming interface
 * @export
 */
export const AuthApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AuthApiAxiosParamCreator(configuration)
    return {
        /**
         * 認証を行い、アクセストークン等の認証情報を返す。
         * @summary Authenticate users
         * @param {string} authorization 認証情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authenticate(authorization: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetLogin>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authenticate(authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * パスワードを変更する。
         * @summary Changepassword
         * @param {ChangePasswordRequest} changePasswordRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async changePassword(changePasswordRequest: ChangePasswordRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.changePassword(changePasswordRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * パスワード再設定の確認をリクエストする。
         * @summary Confirm Forgot Password
         * @param {ConfirmForgotPasswordRequest} confirmForgotPasswordRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async confirmForgotPassword(confirmForgotPasswordRequest: ConfirmForgotPasswordRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.confirmForgotPassword(confirmForgotPasswordRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 対象クライアントにロールを作成する。
         * @summary Create role
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {RoleRequest} roleRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createRole(authorization: string, clientId: string, roleRequest: RoleRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createRole(authorization, clientId, roleRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 対象クライアントのロールを削除する。
         * @summary Delete rol
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteRole(authorization: string, clientId: string, id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteRole(authorization, clientId, id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * パスワード再設定をリクエストする。
         * @summary Forgot Password
         * @param {ForgotPasswordRequest} forgotPasswordRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async forgotPassword(forgotPasswordRequest: ForgotPasswordRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.forgotPassword(forgotPasswordRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 対象クライアントのロールを取得する。
         * @summary Get roles by login user
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRole(authorization: string, clientId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Role>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRole(authorization, clientId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 対象クライアントのロール一覧を取得する。
         * @summary Get roles
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRoles(authorization: string, clientId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Role>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRoles(authorization, clientId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * ログイン時の認証を行う。ユーザに関する情報とアクセストークンを返す。
         * @summary Get users log in to the system
         * @param {string} username 
         * @param {string} password 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async login(username: string, password: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoginResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.login(username, password, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 指定した認証情報のログアウトをリクエストする。
         * @summary Logout
         * @param {string} authorization 認証情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async logout(authorization: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.logout(authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 対象クライアントのロールを更新する。
         * @summary Update role
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {string} id 
         * @param {RoleRequest} roleRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateRole(authorization: string, clientId: string, id: string, roleRequest: RoleRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateRole(authorization, clientId, id, roleRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AuthApi - factory interface
 * @export
 */
export const AuthApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AuthApiFp(configuration)
    return {
        /**
         * 認証を行い、アクセストークン等の認証情報を返す。
         * @summary Authenticate users
         * @param {string} authorization 認証情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authenticate(authorization: string, options?: any): AxiosPromise<GetLogin> {
            return localVarFp.authenticate(authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * パスワードを変更する。
         * @summary Changepassword
         * @param {ChangePasswordRequest} changePasswordRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changePassword(changePasswordRequest: ChangePasswordRequest, options?: any): AxiosPromise<any> {
            return localVarFp.changePassword(changePasswordRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * パスワード再設定の確認をリクエストする。
         * @summary Confirm Forgot Password
         * @param {ConfirmForgotPasswordRequest} confirmForgotPasswordRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirmForgotPassword(confirmForgotPasswordRequest: ConfirmForgotPasswordRequest, options?: any): AxiosPromise<any> {
            return localVarFp.confirmForgotPassword(confirmForgotPasswordRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 対象クライアントにロールを作成する。
         * @summary Create role
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {RoleRequest} roleRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRole(authorization: string, clientId: string, roleRequest: RoleRequest, options?: any): AxiosPromise<void> {
            return localVarFp.createRole(authorization, clientId, roleRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 対象クライアントのロールを削除する。
         * @summary Delete rol
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteRole(authorization: string, clientId: string, id: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteRole(authorization, clientId, id, options).then((request) => request(axios, basePath));
        },
        /**
         * パスワード再設定をリクエストする。
         * @summary Forgot Password
         * @param {ForgotPasswordRequest} forgotPasswordRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        forgotPassword(forgotPasswordRequest: ForgotPasswordRequest, options?: any): AxiosPromise<any> {
            return localVarFp.forgotPassword(forgotPasswordRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 対象クライアントのロールを取得する。
         * @summary Get roles by login user
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRole(authorization: string, clientId: string, options?: any): AxiosPromise<Role> {
            return localVarFp.getRole(authorization, clientId, options).then((request) => request(axios, basePath));
        },
        /**
         * 対象クライアントのロール一覧を取得する。
         * @summary Get roles
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRoles(authorization: string, clientId: string, options?: any): AxiosPromise<Array<Role>> {
            return localVarFp.getRoles(authorization, clientId, options).then((request) => request(axios, basePath));
        },
        /**
         * ログイン時の認証を行う。ユーザに関する情報とアクセストークンを返す。
         * @summary Get users log in to the system
         * @param {string} username 
         * @param {string} password 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        login(username: string, password: string, options?: any): AxiosPromise<LoginResponse> {
            return localVarFp.login(username, password, options).then((request) => request(axios, basePath));
        },
        /**
         * 指定した認証情報のログアウトをリクエストする。
         * @summary Logout
         * @param {string} authorization 認証情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logout(authorization: string, options?: any): AxiosPromise<any> {
            return localVarFp.logout(authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 対象クライアントのロールを更新する。
         * @summary Update role
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {string} id 
         * @param {RoleRequest} roleRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRole(authorization: string, clientId: string, id: string, roleRequest: RoleRequest, options?: any): AxiosPromise<void> {
            return localVarFp.updateRole(authorization, clientId, id, roleRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AuthApi - object-oriented interface
 * @export
 * @class AuthApi
 * @extends {BaseAPI}
 */
export class AuthApi extends BaseAPI {
    /**
     * 認証を行い、アクセストークン等の認証情報を返す。
     * @summary Authenticate users
     * @param {string} authorization 認証情報
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public authenticate(params: { authorization?: string,  }, options?: any) {
				const _params = {} as any;
				_params['authorization'] = params['authorization']
				// @ts-ignore
				_params.authorization = 'Bearer ' + ( params.authorization || Store.getInstance().getAccessToken())!
				_params.clientId = ((params as any).clientId || (Store.getInstance().getAuth() || {}).clientId)!;
        return AuthApiFp(this.configuration).authenticate(_params.authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * パスワードを変更する。
     * @summary Changepassword
     * @param {ChangePasswordRequest} changePasswordRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public changePassword(params: { changePasswordRequest: ChangePasswordRequest,  }, options?: any) {
				const _params = {} as any;
				_params['changePasswordRequest'] = params['changePasswordRequest']
				// @ts-ignore
				_params.authorization = 'Bearer ' + ( params.authorization || Store.getInstance().getAccessToken())!
				_params.clientId = ((params as any).clientId || (Store.getInstance().getAuth() || {}).clientId)!;
        return AuthApiFp(this.configuration).changePassword(_params.changePasswordRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * パスワード再設定の確認をリクエストする。
     * @summary Confirm Forgot Password
     * @param {ConfirmForgotPasswordRequest} confirmForgotPasswordRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public confirmForgotPassword(params: { confirmForgotPasswordRequest: ConfirmForgotPasswordRequest,  }, options?: any) {
				const _params = {} as any;
				_params['confirmForgotPasswordRequest'] = params['confirmForgotPasswordRequest']
				// @ts-ignore
				_params.authorization = 'Bearer ' + ( params.authorization || Store.getInstance().getAccessToken())!
				_params.clientId = ((params as any).clientId || (Store.getInstance().getAuth() || {}).clientId)!;
        return AuthApiFp(this.configuration).confirmForgotPassword(_params.confirmForgotPasswordRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 対象クライアントにロールを作成する。
     * @summary Create role
     * @param {string} authorization 認証情報
     * @param {string} clientId クライアントID
     * @param {RoleRequest} roleRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public createRole(params: { authorization?: string, clientId?: string, roleRequest: RoleRequest,  }, options?: any) {
				const _params = {} as any;
				_params['authorization'] = params['authorization']
				_params['clientId'] = params['clientId']
				_params['roleRequest'] = params['roleRequest']
				// @ts-ignore
				_params.authorization = 'Bearer ' + ( params.authorization || Store.getInstance().getAccessToken())!
				_params.clientId = ((params as any).clientId || (Store.getInstance().getAuth() || {}).clientId)!;
        return AuthApiFp(this.configuration).createRole(_params.authorization, _params.clientId, _params.roleRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 対象クライアントのロールを削除する。
     * @summary Delete rol
     * @param {string} authorization 認証情報
     * @param {string} clientId クライアントID
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public deleteRole(params: { authorization?: string, clientId?: string, id: string,  }, options?: any) {
				const _params = {} as any;
				_params['authorization'] = params['authorization']
				_params['clientId'] = params['clientId']
				_params['id'] = params['id']
				// @ts-ignore
				_params.authorization = 'Bearer ' + ( params.authorization || Store.getInstance().getAccessToken())!
				_params.clientId = ((params as any).clientId || (Store.getInstance().getAuth() || {}).clientId)!;
        return AuthApiFp(this.configuration).deleteRole(_params.authorization, _params.clientId, _params.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * パスワード再設定をリクエストする。
     * @summary Forgot Password
     * @param {ForgotPasswordRequest} forgotPasswordRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public forgotPassword(params: { forgotPasswordRequest: ForgotPasswordRequest,  }, options?: any) {
				const _params = {} as any;
				_params['forgotPasswordRequest'] = params['forgotPasswordRequest']
				// @ts-ignore
				_params.authorization = 'Bearer ' + ( params.authorization || Store.getInstance().getAccessToken())!
				_params.clientId = ((params as any).clientId || (Store.getInstance().getAuth() || {}).clientId)!;
        return AuthApiFp(this.configuration).forgotPassword(_params.forgotPasswordRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 対象クライアントのロールを取得する。
     * @summary Get roles by login user
     * @param {string} authorization 認証情報
     * @param {string} clientId クライアントID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public getRole(params: { authorization?: string, clientId?: string,  }, options?: any) {
				const _params = {} as any;
				_params['authorization'] = params['authorization']
				_params['clientId'] = params['clientId']
				// @ts-ignore
				_params.authorization = 'Bearer ' + ( params.authorization || Store.getInstance().getAccessToken())!
				_params.clientId = ((params as any).clientId || (Store.getInstance().getAuth() || {}).clientId)!;
        return AuthApiFp(this.configuration).getRole(_params.authorization, _params.clientId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 対象クライアントのロール一覧を取得する。
     * @summary Get roles
     * @param {string} authorization 認証情報
     * @param {string} clientId クライアントID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public getRoles(params: { authorization?: string, clientId?: string,  }, options?: any) {
				const _params = {} as any;
				_params['authorization'] = params['authorization']
				_params['clientId'] = params['clientId']
				// @ts-ignore
				_params.authorization = 'Bearer ' + ( params.authorization || Store.getInstance().getAccessToken())!
				_params.clientId = ((params as any).clientId || (Store.getInstance().getAuth() || {}).clientId)!;
        return AuthApiFp(this.configuration).getRoles(_params.authorization, _params.clientId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ログイン時の認証を行う。ユーザに関する情報とアクセストークンを返す。
     * @summary Get users log in to the system
     * @param {string} username 
     * @param {string} password 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public login(params: { username: string, password: string,  }, options?: any) {
				const _params = {} as any;
				_params['username'] = params['username']
				_params['password'] = params['password']
				// @ts-ignore
				_params.authorization = 'Bearer ' + ( params.authorization || Store.getInstance().getAccessToken())!
				_params.clientId = ((params as any).clientId || (Store.getInstance().getAuth() || {}).clientId)!;
        return AuthApiFp(this.configuration).login(_params.username, _params.password, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 指定した認証情報のログアウトをリクエストする。
     * @summary Logout
     * @param {string} authorization 認証情報
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public logout(params: { authorization?: string,  }, options?: any) {
				const _params = {} as any;
				_params['authorization'] = params['authorization']
				// @ts-ignore
				_params.authorization = 'Bearer ' + ( params.authorization || Store.getInstance().getAccessToken())!
				_params.clientId = ((params as any).clientId || (Store.getInstance().getAuth() || {}).clientId)!;
        return AuthApiFp(this.configuration).logout(_params.authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 対象クライアントのロールを更新する。
     * @summary Update role
     * @param {string} authorization 認証情報
     * @param {string} clientId クライアントID
     * @param {string} id 
     * @param {RoleRequest} roleRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public updateRole(params: { authorization?: string, clientId?: string, id: string, roleRequest: RoleRequest,  }, options?: any) {
				const _params = {} as any;
				_params['authorization'] = params['authorization']
				_params['clientId'] = params['clientId']
				_params['id'] = params['id']
				_params['roleRequest'] = params['roleRequest']
				// @ts-ignore
				_params.authorization = 'Bearer ' + ( params.authorization || Store.getInstance().getAccessToken())!
				_params.clientId = ((params as any).clientId || (Store.getInstance().getAuth() || {}).clientId)!;
        return AuthApiFp(this.configuration).updateRole(_params.authorization, _params.clientId, _params.id, _params.roleRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ClientApi - axios parameter creator
 * @export
 */
export const ClientApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * クライアントを作成する。
         * @summary Create a client
         * @param {string} authorization 認証情報
         * @param {CreateClientRequest} createClientRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createClient: async (authorization: string, createClientRequest: CreateClientRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('createClient', 'authorization', authorization)
            // verify required parameter 'createClientRequest' is not null or undefined
            assertParamExists('createClient', 'createClientRequest', createClientRequest)
            const localVarPath = `/clients`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createClientRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 対象クライアントに採用基準を作成する。
         * @summary Create an HR criteria
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {CreateHrCriteriaRequest} createHrCriteriaRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createHrCriteria: async (authorization: string, clientId: string, createHrCriteriaRequest: CreateHrCriteriaRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('createHrCriteria', 'authorization', authorization)
            // verify required parameter 'clientId' is not null or undefined
            assertParamExists('createHrCriteria', 'clientId', clientId)
            // verify required parameter 'createHrCriteriaRequest' is not null or undefined
            assertParamExists('createHrCriteria', 'createHrCriteriaRequest', createHrCriteriaRequest)
            const localVarPath = `/clients/{clientId}/hrCriteria`
                .replace(`{${"clientId"}}`, encodeURIComponent(String(clientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createHrCriteriaRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 対象クライアントに役職を作成する。
         * @summary Create a position
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {CreatePositionRequest} createPositionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPosition: async (authorization: string, clientId: string, createPositionRequest: CreatePositionRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('createPosition', 'authorization', authorization)
            // verify required parameter 'clientId' is not null or undefined
            assertParamExists('createPosition', 'clientId', clientId)
            // verify required parameter 'createPositionRequest' is not null or undefined
            assertParamExists('createPosition', 'createPositionRequest', createPositionRequest)
            const localVarPath = `/clients/{clientId}/positions`
                .replace(`{${"clientId"}}`, encodeURIComponent(String(clientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createPositionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * クライアントを削除する。
         * @summary Delete a client
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteClient: async (authorization: string, clientId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('deleteClient', 'authorization', authorization)
            // verify required parameter 'clientId' is not null or undefined
            assertParamExists('deleteClient', 'clientId', clientId)
            const localVarPath = `/clients/{clientId}`
                .replace(`{${"clientId"}}`, encodeURIComponent(String(clientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 対象クライアントの採用基準を削除する。
         * @summary Delete an HR criteria
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {string} hrCriterionId 人材基準ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteHrCriteria: async (authorization: string, clientId: string, hrCriterionId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('deleteHrCriteria', 'authorization', authorization)
            // verify required parameter 'clientId' is not null or undefined
            assertParamExists('deleteHrCriteria', 'clientId', clientId)
            // verify required parameter 'hrCriterionId' is not null or undefined
            assertParamExists('deleteHrCriteria', 'hrCriterionId', hrCriterionId)
            const localVarPath = `/clients/{clientId}/hrCriteria/{hrCriterionId}`
                .replace(`{${"clientId"}}`, encodeURIComponent(String(clientId)))
                .replace(`{${"hrCriterionId"}}`, encodeURIComponent(String(hrCriterionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 対象クライアントの役職を削除する。
         * @summary Delete a position
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {string} positionId 役職ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePosition: async (authorization: string, clientId: string, positionId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('deletePosition', 'authorization', authorization)
            // verify required parameter 'clientId' is not null or undefined
            assertParamExists('deletePosition', 'clientId', clientId)
            // verify required parameter 'positionId' is not null or undefined
            assertParamExists('deletePosition', 'positionId', positionId)
            const localVarPath = `/clients/{clientId}/positions/{positionId}`
                .replace(`{${"clientId"}}`, encodeURIComponent(String(clientId)))
                .replace(`{${"positionId"}}`, encodeURIComponent(String(positionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * クライアント一覧を取得する。
         * @summary Get client list
         * @param {string} authorization 認証情報
         * @param {string} [q] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClients: async (authorization: string, q?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('getClients', 'authorization', authorization)
            const localVarPath = `/clients`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Read Email Template
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {EmailTemplateTypeEnum} emailTemplateType 
         * @param {string} emailTemplateId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmailTemplateById: async (authorization: string, clientId: string, emailTemplateType: EmailTemplateTypeEnum, emailTemplateId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('getEmailTemplateById', 'authorization', authorization)
            // verify required parameter 'clientId' is not null or undefined
            assertParamExists('getEmailTemplateById', 'clientId', clientId)
            // verify required parameter 'emailTemplateType' is not null or undefined
            assertParamExists('getEmailTemplateById', 'emailTemplateType', emailTemplateType)
            // verify required parameter 'emailTemplateId' is not null or undefined
            assertParamExists('getEmailTemplateById', 'emailTemplateId', emailTemplateId)
            const localVarPath = `/clients/{clientId}/EmailTemplates/{emailTemplateType}/{emailTemplateId}`
                .replace(`{${"clientId"}}`, encodeURIComponent(String(clientId)))
                .replace(`{${"emailTemplateType"}}`, encodeURIComponent(String(emailTemplateType)))
                .replace(`{${"emailTemplateId"}}`, encodeURIComponent(String(emailTemplateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2PasswordBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 対象クライアントのメールテンプレートを取得する。
         * @summary Read Email Template List
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {EmailTemplateTypeEnum} emailTemplateType 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmailTemplatesByType: async (authorization: string, clientId: string, emailTemplateType: EmailTemplateTypeEnum, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('getEmailTemplatesByType', 'authorization', authorization)
            // verify required parameter 'clientId' is not null or undefined
            assertParamExists('getEmailTemplatesByType', 'clientId', clientId)
            // verify required parameter 'emailTemplateType' is not null or undefined
            assertParamExists('getEmailTemplatesByType', 'emailTemplateType', emailTemplateType)
            const localVarPath = `/clients/{clientId}/EmailTemplates/{emailTemplateType}`
                .replace(`{${"clientId"}}`, encodeURIComponent(String(clientId)))
                .replace(`{${"emailTemplateType"}}`, encodeURIComponent(String(emailTemplateType)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2PasswordBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 対象クライアントの採用基準を取得する。
         * @summary Get human resource criteria list
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {string} [q] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHrCriteria: async (authorization: string, clientId: string, q?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('getHrCriteria', 'authorization', authorization)
            // verify required parameter 'clientId' is not null or undefined
            assertParamExists('getHrCriteria', 'clientId', clientId)
            const localVarPath = `/clients/{clientId}/hrCriteria`
                .replace(`{${"clientId"}}`, encodeURIComponent(String(clientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 対象クライアントの役職一覧を取得する。
         * @summary Get position list
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPositions: async (authorization: string, clientId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('getPositions', 'authorization', authorization)
            // verify required parameter 'clientId' is not null or undefined
            assertParamExists('getPositions', 'clientId', clientId)
            const localVarPath = `/clients/{clientId}/positions`
                .replace(`{${"clientId"}}`, encodeURIComponent(String(clientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 対象クライアントのバックグラウンド処理状況を取得する。
         * @summary Get a queueManage
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {string} [q] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getQueueManage: async (authorization: string, clientId: string, q?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('getQueueManage', 'authorization', authorization)
            // verify required parameter 'clientId' is not null or undefined
            assertParamExists('getQueueManage', 'clientId', clientId)
            const localVarPath = `/clients/{clientId}/queueManage`
                .replace(`{${"clientId"}}`, encodeURIComponent(String(clientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 対象クライアントのワークシートをダウンロードする。
         * @summary Get personal details in excel file (.xlsx)
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {string} personId e.g. employee or applicant SK
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getXlsPersonalWorksheet: async (authorization: string, clientId: string, personId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('getXlsPersonalWorksheet', 'authorization', authorization)
            // verify required parameter 'clientId' is not null or undefined
            assertParamExists('getXlsPersonalWorksheet', 'clientId', clientId)
            // verify required parameter 'personId' is not null or undefined
            assertParamExists('getXlsPersonalWorksheet', 'personId', personId)
            const localVarPath = `/clients/{clientId}/xlsPersonalWorksheet`
                .replace(`{${"clientId"}}`, encodeURIComponent(String(clientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (personId !== undefined) {
                localVarQueryParameter['personId'] = personId;
            }

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 対象クライアントのテンプレートをダウンロードする。
         * @summary Get excel file (.xlsm) template to import employee/applicant
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {string} peopleType e.g. employee or applicant
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getXlsTemplate: async (authorization: string, clientId: string, peopleType: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('getXlsTemplate', 'authorization', authorization)
            // verify required parameter 'clientId' is not null or undefined
            assertParamExists('getXlsTemplate', 'clientId', clientId)
            // verify required parameter 'peopleType' is not null or undefined
            assertParamExists('getXlsTemplate', 'peopleType', peopleType)
            const localVarPath = `/clients/{clientId}/xlsTemplate`
                .replace(`{${"clientId"}}`, encodeURIComponent(String(clientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (peopleType !== undefined) {
                localVarQueryParameter['peopleType'] = peopleType;
            }

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * クライアントを更新する。
         * @summary Update a client
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {UpdateClientRequest} updateClientRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateClient: async (authorization: string, clientId: string, updateClientRequest: UpdateClientRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('updateClient', 'authorization', authorization)
            // verify required parameter 'clientId' is not null or undefined
            assertParamExists('updateClient', 'clientId', clientId)
            // verify required parameter 'updateClientRequest' is not null or undefined
            assertParamExists('updateClient', 'updateClientRequest', updateClientRequest)
            const localVarPath = `/clients/{clientId}`
                .replace(`{${"clientId"}}`, encodeURIComponent(String(clientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateClientRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 対象クライアントの採用基準を更新する。
         * @summary Update an HR criteria
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {string} hrCriterionId 人材基準ID
         * @param {CreateHrCriteriaRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateHrCriteria: async (authorization: string, clientId: string, hrCriterionId: string, body: CreateHrCriteriaRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('updateHrCriteria', 'authorization', authorization)
            // verify required parameter 'clientId' is not null or undefined
            assertParamExists('updateHrCriteria', 'clientId', clientId)
            // verify required parameter 'hrCriterionId' is not null or undefined
            assertParamExists('updateHrCriteria', 'hrCriterionId', hrCriterionId)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('updateHrCriteria', 'body', body)
            const localVarPath = `/clients/{clientId}/hrCriteria/{hrCriterionId}`
                .replace(`{${"clientId"}}`, encodeURIComponent(String(clientId)))
                .replace(`{${"hrCriterionId"}}`, encodeURIComponent(String(hrCriterionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 対象クライアントの役職を更新する。
         * @summary Update a position
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {string} positionId 役職ID
         * @param {CreatePositionRequest} createPositionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePosition: async (authorization: string, clientId: string, positionId: string, createPositionRequest: CreatePositionRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('updatePosition', 'authorization', authorization)
            // verify required parameter 'clientId' is not null or undefined
            assertParamExists('updatePosition', 'clientId', clientId)
            // verify required parameter 'positionId' is not null or undefined
            assertParamExists('updatePosition', 'positionId', positionId)
            // verify required parameter 'createPositionRequest' is not null or undefined
            assertParamExists('updatePosition', 'createPositionRequest', createPositionRequest)
            const localVarPath = `/clients/{clientId}/positions/{positionId}`
                .replace(`{${"clientId"}}`, encodeURIComponent(String(clientId)))
                .replace(`{${"positionId"}}`, encodeURIComponent(String(positionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createPositionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ClientApi - functional programming interface
 * @export
 */
export const ClientApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ClientApiAxiosParamCreator(configuration)
    return {
        /**
         * クライアントを作成する。
         * @summary Create a client
         * @param {string} authorization 認証情報
         * @param {CreateClientRequest} createClientRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createClient(authorization: string, createClientRequest: CreateClientRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Client>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createClient(authorization, createClientRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 対象クライアントに採用基準を作成する。
         * @summary Create an HR criteria
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {CreateHrCriteriaRequest} createHrCriteriaRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createHrCriteria(authorization: string, clientId: string, createHrCriteriaRequest: CreateHrCriteriaRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createHrCriteria(authorization, clientId, createHrCriteriaRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 対象クライアントに役職を作成する。
         * @summary Create a position
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {CreatePositionRequest} createPositionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createPosition(authorization: string, clientId: string, createPositionRequest: CreatePositionRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createPosition(authorization, clientId, createPositionRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * クライアントを削除する。
         * @summary Delete a client
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteClient(authorization: string, clientId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteClient(authorization, clientId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 対象クライアントの採用基準を削除する。
         * @summary Delete an HR criteria
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {string} hrCriterionId 人材基準ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteHrCriteria(authorization: string, clientId: string, hrCriterionId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteHrCriteria(authorization, clientId, hrCriterionId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 対象クライアントの役職を削除する。
         * @summary Delete a position
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {string} positionId 役職ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deletePosition(authorization: string, clientId: string, positionId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deletePosition(authorization, clientId, positionId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * クライアント一覧を取得する。
         * @summary Get client list
         * @param {string} authorization 認証情報
         * @param {string} [q] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getClients(authorization: string, q?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Client>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getClients(authorization, q, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Read Email Template
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {EmailTemplateTypeEnum} emailTemplateType 
         * @param {string} emailTemplateId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEmailTemplateById(authorization: string, clientId: string, emailTemplateType: EmailTemplateTypeEnum, emailTemplateId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetEmailTemplate>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEmailTemplateById(authorization, clientId, emailTemplateType, emailTemplateId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 対象クライアントのメールテンプレートを取得する。
         * @summary Read Email Template List
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {EmailTemplateTypeEnum} emailTemplateType 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEmailTemplatesByType(authorization: string, clientId: string, emailTemplateType: EmailTemplateTypeEnum, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetEmailTemplate>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEmailTemplatesByType(authorization, clientId, emailTemplateType, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 対象クライアントの採用基準を取得する。
         * @summary Get human resource criteria list
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {string} [q] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getHrCriteria(authorization: string, clientId: string, q?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetHrCriterion>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getHrCriteria(authorization, clientId, q, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 対象クライアントの役職一覧を取得する。
         * @summary Get position list
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPositions(authorization: string, clientId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<IdName>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPositions(authorization, clientId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 対象クライアントのバックグラウンド処理状況を取得する。
         * @summary Get a queueManage
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {string} [q] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getQueueManage(authorization: string, clientId: string, q?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetQueueManageItem>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getQueueManage(authorization, clientId, q, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 対象クライアントのワークシートをダウンロードする。
         * @summary Get personal details in excel file (.xlsx)
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {string} personId e.g. employee or applicant SK
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getXlsPersonalWorksheet(authorization: string, clientId: string, personId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getXlsPersonalWorksheet(authorization, clientId, personId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 対象クライアントのテンプレートをダウンロードする。
         * @summary Get excel file (.xlsm) template to import employee/applicant
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {string} peopleType e.g. employee or applicant
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getXlsTemplate(authorization: string, clientId: string, peopleType: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getXlsTemplate(authorization, clientId, peopleType, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * クライアントを更新する。
         * @summary Update a client
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {UpdateClientRequest} updateClientRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateClient(authorization: string, clientId: string, updateClientRequest: UpdateClientRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateClient(authorization, clientId, updateClientRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 対象クライアントの採用基準を更新する。
         * @summary Update an HR criteria
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {string} hrCriterionId 人材基準ID
         * @param {CreateHrCriteriaRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateHrCriteria(authorization: string, clientId: string, hrCriterionId: string, body: CreateHrCriteriaRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateHrCriteria(authorization, clientId, hrCriterionId, body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 対象クライアントの役職を更新する。
         * @summary Update a position
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {string} positionId 役職ID
         * @param {CreatePositionRequest} createPositionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePosition(authorization: string, clientId: string, positionId: string, createPositionRequest: CreatePositionRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePosition(authorization, clientId, positionId, createPositionRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ClientApi - factory interface
 * @export
 */
export const ClientApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ClientApiFp(configuration)
    return {
        /**
         * クライアントを作成する。
         * @summary Create a client
         * @param {string} authorization 認証情報
         * @param {CreateClientRequest} createClientRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createClient(authorization: string, createClientRequest: CreateClientRequest, options?: any): AxiosPromise<Client> {
            return localVarFp.createClient(authorization, createClientRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 対象クライアントに採用基準を作成する。
         * @summary Create an HR criteria
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {CreateHrCriteriaRequest} createHrCriteriaRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createHrCriteria(authorization: string, clientId: string, createHrCriteriaRequest: CreateHrCriteriaRequest, options?: any): AxiosPromise<void> {
            return localVarFp.createHrCriteria(authorization, clientId, createHrCriteriaRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 対象クライアントに役職を作成する。
         * @summary Create a position
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {CreatePositionRequest} createPositionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPosition(authorization: string, clientId: string, createPositionRequest: CreatePositionRequest, options?: any): AxiosPromise<void> {
            return localVarFp.createPosition(authorization, clientId, createPositionRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * クライアントを削除する。
         * @summary Delete a client
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteClient(authorization: string, clientId: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteClient(authorization, clientId, options).then((request) => request(axios, basePath));
        },
        /**
         * 対象クライアントの採用基準を削除する。
         * @summary Delete an HR criteria
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {string} hrCriterionId 人材基準ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteHrCriteria(authorization: string, clientId: string, hrCriterionId: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteHrCriteria(authorization, clientId, hrCriterionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 対象クライアントの役職を削除する。
         * @summary Delete a position
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {string} positionId 役職ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePosition(authorization: string, clientId: string, positionId: string, options?: any): AxiosPromise<void> {
            return localVarFp.deletePosition(authorization, clientId, positionId, options).then((request) => request(axios, basePath));
        },
        /**
         * クライアント一覧を取得する。
         * @summary Get client list
         * @param {string} authorization 認証情報
         * @param {string} [q] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClients(authorization: string, q?: string, options?: any): AxiosPromise<Array<Client>> {
            return localVarFp.getClients(authorization, q, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Read Email Template
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {EmailTemplateTypeEnum} emailTemplateType 
         * @param {string} emailTemplateId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmailTemplateById(authorization: string, clientId: string, emailTemplateType: EmailTemplateTypeEnum, emailTemplateId: string, options?: any): AxiosPromise<GetEmailTemplate> {
            return localVarFp.getEmailTemplateById(authorization, clientId, emailTemplateType, emailTemplateId, options).then((request) => request(axios, basePath));
        },
        /**
         * 対象クライアントのメールテンプレートを取得する。
         * @summary Read Email Template List
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {EmailTemplateTypeEnum} emailTemplateType 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmailTemplatesByType(authorization: string, clientId: string, emailTemplateType: EmailTemplateTypeEnum, options?: any): AxiosPromise<Array<GetEmailTemplate>> {
            return localVarFp.getEmailTemplatesByType(authorization, clientId, emailTemplateType, options).then((request) => request(axios, basePath));
        },
        /**
         * 対象クライアントの採用基準を取得する。
         * @summary Get human resource criteria list
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {string} [q] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHrCriteria(authorization: string, clientId: string, q?: string, options?: any): AxiosPromise<Array<GetHrCriterion>> {
            return localVarFp.getHrCriteria(authorization, clientId, q, options).then((request) => request(axios, basePath));
        },
        /**
         * 対象クライアントの役職一覧を取得する。
         * @summary Get position list
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPositions(authorization: string, clientId: string, options?: any): AxiosPromise<Array<IdName>> {
            return localVarFp.getPositions(authorization, clientId, options).then((request) => request(axios, basePath));
        },
        /**
         * 対象クライアントのバックグラウンド処理状況を取得する。
         * @summary Get a queueManage
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {string} [q] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getQueueManage(authorization: string, clientId: string, q?: string, options?: any): AxiosPromise<Array<GetQueueManageItem>> {
            return localVarFp.getQueueManage(authorization, clientId, q, options).then((request) => request(axios, basePath));
        },
        /**
         * 対象クライアントのワークシートをダウンロードする。
         * @summary Get personal details in excel file (.xlsx)
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {string} personId e.g. employee or applicant SK
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getXlsPersonalWorksheet(authorization: string, clientId: string, personId: string, options?: any): AxiosPromise<any> {
            return localVarFp.getXlsPersonalWorksheet(authorization, clientId, personId, options).then((request) => request(axios, basePath));
        },
        /**
         * 対象クライアントのテンプレートをダウンロードする。
         * @summary Get excel file (.xlsm) template to import employee/applicant
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {string} peopleType e.g. employee or applicant
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getXlsTemplate(authorization: string, clientId: string, peopleType: string, options?: any): AxiosPromise<any> {
            return localVarFp.getXlsTemplate(authorization, clientId, peopleType, options).then((request) => request(axios, basePath));
        },
        /**
         * クライアントを更新する。
         * @summary Update a client
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {UpdateClientRequest} updateClientRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateClient(authorization: string, clientId: string, updateClientRequest: UpdateClientRequest, options?: any): AxiosPromise<void> {
            return localVarFp.updateClient(authorization, clientId, updateClientRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 対象クライアントの採用基準を更新する。
         * @summary Update an HR criteria
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {string} hrCriterionId 人材基準ID
         * @param {CreateHrCriteriaRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateHrCriteria(authorization: string, clientId: string, hrCriterionId: string, body: CreateHrCriteriaRequest, options?: any): AxiosPromise<void> {
            return localVarFp.updateHrCriteria(authorization, clientId, hrCriterionId, body, options).then((request) => request(axios, basePath));
        },
        /**
         * 対象クライアントの役職を更新する。
         * @summary Update a position
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {string} positionId 役職ID
         * @param {CreatePositionRequest} createPositionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePosition(authorization: string, clientId: string, positionId: string, createPositionRequest: CreatePositionRequest, options?: any): AxiosPromise<void> {
            return localVarFp.updatePosition(authorization, clientId, positionId, createPositionRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ClientApi - object-oriented interface
 * @export
 * @class ClientApi
 * @extends {BaseAPI}
 */
export class ClientApi extends BaseAPI {
    /**
     * クライアントを作成する。
     * @summary Create a client
     * @param {string} authorization 認証情報
     * @param {CreateClientRequest} createClientRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientApi
     */
    public createClient(params: { authorization?: string, createClientRequest: CreateClientRequest,  }, options?: any) {
				const _params = {} as any;
				_params['authorization'] = params['authorization']
				_params['createClientRequest'] = params['createClientRequest']
				// @ts-ignore
				_params.authorization = 'Bearer ' + ( params.authorization || Store.getInstance().getAccessToken())!
				_params.clientId = ((params as any).clientId || (Store.getInstance().getAuth() || {}).clientId)!;
        return ClientApiFp(this.configuration).createClient(_params.authorization, _params.createClientRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 対象クライアントに採用基準を作成する。
     * @summary Create an HR criteria
     * @param {string} authorization 認証情報
     * @param {string} clientId クライアントID
     * @param {CreateHrCriteriaRequest} createHrCriteriaRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientApi
     */
    public createHrCriteria(params: { authorization?: string, clientId?: string, createHrCriteriaRequest: CreateHrCriteriaRequest,  }, options?: any) {
				const _params = {} as any;
				_params['authorization'] = params['authorization']
				_params['clientId'] = params['clientId']
				_params['createHrCriteriaRequest'] = params['createHrCriteriaRequest']
				// @ts-ignore
				_params.authorization = 'Bearer ' + ( params.authorization || Store.getInstance().getAccessToken())!
				_params.clientId = ((params as any).clientId || (Store.getInstance().getAuth() || {}).clientId)!;
        return ClientApiFp(this.configuration).createHrCriteria(_params.authorization, _params.clientId, _params.createHrCriteriaRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 対象クライアントに役職を作成する。
     * @summary Create a position
     * @param {string} authorization 認証情報
     * @param {string} clientId クライアントID
     * @param {CreatePositionRequest} createPositionRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientApi
     */
    public createPosition(params: { authorization?: string, clientId?: string, createPositionRequest: CreatePositionRequest,  }, options?: any) {
				const _params = {} as any;
				_params['authorization'] = params['authorization']
				_params['clientId'] = params['clientId']
				_params['createPositionRequest'] = params['createPositionRequest']
				// @ts-ignore
				_params.authorization = 'Bearer ' + ( params.authorization || Store.getInstance().getAccessToken())!
				_params.clientId = ((params as any).clientId || (Store.getInstance().getAuth() || {}).clientId)!;
        return ClientApiFp(this.configuration).createPosition(_params.authorization, _params.clientId, _params.createPositionRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * クライアントを削除する。
     * @summary Delete a client
     * @param {string} authorization 認証情報
     * @param {string} clientId クライアントID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientApi
     */
    public deleteClient(params: { authorization?: string, clientId?: string,  }, options?: any) {
				const _params = {} as any;
				_params['authorization'] = params['authorization']
				_params['clientId'] = params['clientId']
				// @ts-ignore
				_params.authorization = 'Bearer ' + ( params.authorization || Store.getInstance().getAccessToken())!
				_params.clientId = ((params as any).clientId || (Store.getInstance().getAuth() || {}).clientId)!;
        return ClientApiFp(this.configuration).deleteClient(_params.authorization, _params.clientId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 対象クライアントの採用基準を削除する。
     * @summary Delete an HR criteria
     * @param {string} authorization 認証情報
     * @param {string} clientId クライアントID
     * @param {string} hrCriterionId 人材基準ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientApi
     */
    public deleteHrCriteria(params: { authorization?: string, clientId?: string, hrCriterionId: string,  }, options?: any) {
				const _params = {} as any;
				_params['authorization'] = params['authorization']
				_params['clientId'] = params['clientId']
				_params['hrCriterionId'] = params['hrCriterionId']
				// @ts-ignore
				_params.authorization = 'Bearer ' + ( params.authorization || Store.getInstance().getAccessToken())!
				_params.clientId = ((params as any).clientId || (Store.getInstance().getAuth() || {}).clientId)!;
        return ClientApiFp(this.configuration).deleteHrCriteria(_params.authorization, _params.clientId, _params.hrCriterionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 対象クライアントの役職を削除する。
     * @summary Delete a position
     * @param {string} authorization 認証情報
     * @param {string} clientId クライアントID
     * @param {string} positionId 役職ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientApi
     */
    public deletePosition(params: { authorization?: string, clientId?: string, positionId: string,  }, options?: any) {
				const _params = {} as any;
				_params['authorization'] = params['authorization']
				_params['clientId'] = params['clientId']
				_params['positionId'] = params['positionId']
				// @ts-ignore
				_params.authorization = 'Bearer ' + ( params.authorization || Store.getInstance().getAccessToken())!
				_params.clientId = ((params as any).clientId || (Store.getInstance().getAuth() || {}).clientId)!;
        return ClientApiFp(this.configuration).deletePosition(_params.authorization, _params.clientId, _params.positionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * クライアント一覧を取得する。
     * @summary Get client list
     * @param {string} authorization 認証情報
     * @param {string} [q] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientApi
     */
    public getClients(params: { authorization?: string, q?: string,  }, options?: any) {
				const _params = {} as any;
				_params['authorization'] = params['authorization']
				_params['q'] = params['q']
				// @ts-ignore
				_params.authorization = 'Bearer ' + ( params.authorization || Store.getInstance().getAccessToken())!
				_params.clientId = ((params as any).clientId || (Store.getInstance().getAuth() || {}).clientId)!;
        return ClientApiFp(this.configuration).getClients(_params.authorization, _params.q, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Read Email Template
     * @param {string} authorization 認証情報
     * @param {string} clientId クライアントID
     * @param {EmailTemplateTypeEnum} emailTemplateType 
     * @param {string} emailTemplateId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientApi
     */
    public getEmailTemplateById(params: { authorization?: string, clientId?: string, emailTemplateType: EmailTemplateTypeEnum, emailTemplateId: string,  }, options?: any) {
				const _params = {} as any;
				_params['authorization'] = params['authorization']
				_params['clientId'] = params['clientId']
				_params['emailTemplateType'] = params['emailTemplateType']
				_params['emailTemplateId'] = params['emailTemplateId']
				// @ts-ignore
				_params.authorization = 'Bearer ' + ( params.authorization || Store.getInstance().getAccessToken())!
				_params.clientId = ((params as any).clientId || (Store.getInstance().getAuth() || {}).clientId)!;
        return ClientApiFp(this.configuration).getEmailTemplateById(_params.authorization, _params.clientId, _params.emailTemplateType, _params.emailTemplateId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 対象クライアントのメールテンプレートを取得する。
     * @summary Read Email Template List
     * @param {string} authorization 認証情報
     * @param {string} clientId クライアントID
     * @param {EmailTemplateTypeEnum} emailTemplateType 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientApi
     */
    public getEmailTemplatesByType(params: { authorization?: string, clientId?: string, emailTemplateType: EmailTemplateTypeEnum,  }, options?: any) {
				const _params = {} as any;
				_params['authorization'] = params['authorization']
				_params['clientId'] = params['clientId']
				_params['emailTemplateType'] = params['emailTemplateType']
				// @ts-ignore
				_params.authorization = 'Bearer ' + ( params.authorization || Store.getInstance().getAccessToken())!
				_params.clientId = ((params as any).clientId || (Store.getInstance().getAuth() || {}).clientId)!;
        return ClientApiFp(this.configuration).getEmailTemplatesByType(_params.authorization, _params.clientId, _params.emailTemplateType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 対象クライアントの採用基準を取得する。
     * @summary Get human resource criteria list
     * @param {string} authorization 認証情報
     * @param {string} clientId クライアントID
     * @param {string} [q] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientApi
     */
    public getHrCriteria(params: { authorization?: string, clientId?: string, q?: string,  }, options?: any) {
				const _params = {} as any;
				_params['authorization'] = params['authorization']
				_params['clientId'] = params['clientId']
				_params['q'] = params['q']
				// @ts-ignore
				_params.authorization = 'Bearer ' + ( params.authorization || Store.getInstance().getAccessToken())!
				_params.clientId = ((params as any).clientId || (Store.getInstance().getAuth() || {}).clientId)!;
        return ClientApiFp(this.configuration).getHrCriteria(_params.authorization, _params.clientId, _params.q, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 対象クライアントの役職一覧を取得する。
     * @summary Get position list
     * @param {string} authorization 認証情報
     * @param {string} clientId クライアントID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientApi
     */
    public getPositions(params: { authorization?: string, clientId?: string,  }, options?: any) {
				const _params = {} as any;
				_params['authorization'] = params['authorization']
				_params['clientId'] = params['clientId']
				// @ts-ignore
				_params.authorization = 'Bearer ' + ( params.authorization || Store.getInstance().getAccessToken())!
				_params.clientId = ((params as any).clientId || (Store.getInstance().getAuth() || {}).clientId)!;
        return ClientApiFp(this.configuration).getPositions(_params.authorization, _params.clientId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 対象クライアントのバックグラウンド処理状況を取得する。
     * @summary Get a queueManage
     * @param {string} authorization 認証情報
     * @param {string} clientId クライアントID
     * @param {string} [q] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientApi
     */
    public getQueueManage(params: { authorization?: string, clientId?: string, q?: string,  }, options?: any) {
				const _params = {} as any;
				_params['authorization'] = params['authorization']
				_params['clientId'] = params['clientId']
				_params['q'] = params['q']
				// @ts-ignore
				_params.authorization = 'Bearer ' + ( params.authorization || Store.getInstance().getAccessToken())!
				_params.clientId = ((params as any).clientId || (Store.getInstance().getAuth() || {}).clientId)!;
        return ClientApiFp(this.configuration).getQueueManage(_params.authorization, _params.clientId, _params.q, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 対象クライアントのワークシートをダウンロードする。
     * @summary Get personal details in excel file (.xlsx)
     * @param {string} authorization 認証情報
     * @param {string} clientId クライアントID
     * @param {string} personId e.g. employee or applicant SK
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientApi
     */
    public getXlsPersonalWorksheet(params: { authorization?: string, clientId?: string, personId: string,  }, options?: any) {
				const _params = {} as any;
				_params['authorization'] = params['authorization']
				_params['clientId'] = params['clientId']
				_params['personId'] = params['personId']
				// @ts-ignore
				_params.authorization = 'Bearer ' + ( params.authorization || Store.getInstance().getAccessToken())!
				_params.clientId = ((params as any).clientId || (Store.getInstance().getAuth() || {}).clientId)!;
        return ClientApiFp(this.configuration).getXlsPersonalWorksheet(_params.authorization, _params.clientId, _params.personId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 対象クライアントのテンプレートをダウンロードする。
     * @summary Get excel file (.xlsm) template to import employee/applicant
     * @param {string} authorization 認証情報
     * @param {string} clientId クライアントID
     * @param {string} peopleType e.g. employee or applicant
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientApi
     */
    public getXlsTemplate(params: { authorization?: string, clientId?: string, peopleType: string,  }, options?: any) {
				const _params = {} as any;
				_params['authorization'] = params['authorization']
				_params['clientId'] = params['clientId']
				_params['peopleType'] = params['peopleType']
				// @ts-ignore
				_params.authorization = 'Bearer ' + ( params.authorization || Store.getInstance().getAccessToken())!
				_params.clientId = ((params as any).clientId || (Store.getInstance().getAuth() || {}).clientId)!;
        return ClientApiFp(this.configuration).getXlsTemplate(_params.authorization, _params.clientId, _params.peopleType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * クライアントを更新する。
     * @summary Update a client
     * @param {string} authorization 認証情報
     * @param {string} clientId クライアントID
     * @param {UpdateClientRequest} updateClientRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientApi
     */
    public updateClient(params: { authorization?: string, clientId?: string, updateClientRequest: UpdateClientRequest,  }, options?: any) {
				const _params = {} as any;
				_params['authorization'] = params['authorization']
				_params['clientId'] = params['clientId']
				_params['updateClientRequest'] = params['updateClientRequest']
				// @ts-ignore
				_params.authorization = 'Bearer ' + ( params.authorization || Store.getInstance().getAccessToken())!
				_params.clientId = ((params as any).clientId || (Store.getInstance().getAuth() || {}).clientId)!;
        return ClientApiFp(this.configuration).updateClient(_params.authorization, _params.clientId, _params.updateClientRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 対象クライアントの採用基準を更新する。
     * @summary Update an HR criteria
     * @param {string} authorization 認証情報
     * @param {string} clientId クライアントID
     * @param {string} hrCriterionId 人材基準ID
     * @param {CreateHrCriteriaRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientApi
     */
    public updateHrCriteria(params: { authorization?: string, clientId?: string, hrCriterionId: string, body: CreateHrCriteriaRequest,  }, options?: any) {
				const _params = {} as any;
				_params['authorization'] = params['authorization']
				_params['clientId'] = params['clientId']
				_params['hrCriterionId'] = params['hrCriterionId']
				_params['body'] = params['body']
				// @ts-ignore
				_params.authorization = 'Bearer ' + ( params.authorization || Store.getInstance().getAccessToken())!
				_params.clientId = ((params as any).clientId || (Store.getInstance().getAuth() || {}).clientId)!;
        return ClientApiFp(this.configuration).updateHrCriteria(_params.authorization, _params.clientId, _params.hrCriterionId, _params.body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 対象クライアントの役職を更新する。
     * @summary Update a position
     * @param {string} authorization 認証情報
     * @param {string} clientId クライアントID
     * @param {string} positionId 役職ID
     * @param {CreatePositionRequest} createPositionRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientApi
     */
    public updatePosition(params: { authorization?: string, clientId?: string, positionId: string, createPositionRequest: CreatePositionRequest,  }, options?: any) {
				const _params = {} as any;
				_params['authorization'] = params['authorization']
				_params['clientId'] = params['clientId']
				_params['positionId'] = params['positionId']
				_params['createPositionRequest'] = params['createPositionRequest']
				// @ts-ignore
				_params.authorization = 'Bearer ' + ( params.authorization || Store.getInstance().getAccessToken())!
				_params.clientId = ((params as any).clientId || (Store.getInstance().getAuth() || {}).clientId)!;
        return ClientApiFp(this.configuration).updatePosition(_params.authorization, _params.clientId, _params.positionId, _params.createPositionRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * DepartmentApi - axios parameter creator
 * @export
 */
export const DepartmentApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 対象クライアントに部署を作成する。
         * @summary Create a department
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {CreateDepartmentRequest} createDepartmentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDepartment: async (authorization: string, clientId: string, createDepartmentRequest: CreateDepartmentRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('createDepartment', 'authorization', authorization)
            // verify required parameter 'clientId' is not null or undefined
            assertParamExists('createDepartment', 'clientId', clientId)
            // verify required parameter 'createDepartmentRequest' is not null or undefined
            assertParamExists('createDepartment', 'createDepartmentRequest', createDepartmentRequest)
            const localVarPath = `/clients/{clientId}/departments`
                .replace(`{${"clientId"}}`, encodeURIComponent(String(clientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createDepartmentRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete a department
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {string} departmentId 部署ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDepartment: async (authorization: string, clientId: string, departmentId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('deleteDepartment', 'authorization', authorization)
            // verify required parameter 'clientId' is not null or undefined
            assertParamExists('deleteDepartment', 'clientId', clientId)
            // verify required parameter 'departmentId' is not null or undefined
            assertParamExists('deleteDepartment', 'departmentId', departmentId)
            const localVarPath = `/clients/{clientId}/departments/{departmentId}`
                .replace(`{${"clientId"}}`, encodeURIComponent(String(clientId)))
                .replace(`{${"departmentId"}}`, encodeURIComponent(String(departmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a department information
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {string} departmentId 部署ID
         * @param {boolean} [selectableParents] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDepartment: async (authorization: string, clientId: string, departmentId: string, selectableParents?: boolean, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('getDepartment', 'authorization', authorization)
            // verify required parameter 'clientId' is not null or undefined
            assertParamExists('getDepartment', 'clientId', clientId)
            // verify required parameter 'departmentId' is not null or undefined
            assertParamExists('getDepartment', 'departmentId', departmentId)
            const localVarPath = `/clients/{clientId}/departments/{departmentId}`
                .replace(`{${"clientId"}}`, encodeURIComponent(String(clientId)))
                .replace(`{${"departmentId"}}`, encodeURIComponent(String(departmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (selectableParents !== undefined) {
                localVarQueryParameter['selectableParents'] = selectableParents;
            }

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 対象クライアントの部署を返す。
         * @summary Get department list
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {string} [q] 
         * @param {string} [aim] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDepartments: async (authorization: string, clientId: string, q?: string, aim?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('getDepartments', 'authorization', authorization)
            // verify required parameter 'clientId' is not null or undefined
            assertParamExists('getDepartments', 'clientId', clientId)
            const localVarPath = `/clients/{clientId}/departments`
                .replace(`{${"clientId"}}`, encodeURIComponent(String(clientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }

            if (aim !== undefined) {
                localVarQueryParameter['aim'] = aim;
            }

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 対象クライアントの従業員一覧を取得する。
         * @summary Get employee list
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {string} departmentId 部署ID
         * @param {string} [limit] レスポンスのデータ制限
         * @param {string} [offset] 
         * @param {string} [name] 
         * @param {Array<string>} [occupations] 
         * @param {Array<string>} [positions] 
         * @param {string} [examStartDate] 
         * @param {string} [examEndDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmployees: async (authorization: string, clientId: string, departmentId: string, limit?: string, offset?: string, name?: string, occupations?: Array<string>, positions?: Array<string>, examStartDate?: string, examEndDate?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('getEmployees', 'authorization', authorization)
            // verify required parameter 'clientId' is not null or undefined
            assertParamExists('getEmployees', 'clientId', clientId)
            // verify required parameter 'departmentId' is not null or undefined
            assertParamExists('getEmployees', 'departmentId', departmentId)
            const localVarPath = `/clients/{clientId}/departments/{departmentId}/employees`
                .replace(`{${"clientId"}}`, encodeURIComponent(String(clientId)))
                .replace(`{${"departmentId"}}`, encodeURIComponent(String(departmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (occupations) {
                localVarQueryParameter['occupations'] = occupations;
            }

            if (positions) {
                localVarQueryParameter['positions'] = positions;
            }

            if (examStartDate !== undefined) {
                localVarQueryParameter['examStartDate'] = examStartDate;
            }

            if (examEndDate !== undefined) {
                localVarQueryParameter['examEndDate'] = examEndDate;
            }

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 対象クライアントの部署を更新する。
         * @summary Update a department
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {string} departmentId 部署ID
         * @param {UpdateDepartmentRequest} updateDepartmentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDepartment: async (authorization: string, clientId: string, departmentId: string, updateDepartmentRequest: UpdateDepartmentRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('updateDepartment', 'authorization', authorization)
            // verify required parameter 'clientId' is not null or undefined
            assertParamExists('updateDepartment', 'clientId', clientId)
            // verify required parameter 'departmentId' is not null or undefined
            assertParamExists('updateDepartment', 'departmentId', departmentId)
            // verify required parameter 'updateDepartmentRequest' is not null or undefined
            assertParamExists('updateDepartment', 'updateDepartmentRequest', updateDepartmentRequest)
            const localVarPath = `/clients/{clientId}/departments/{departmentId}`
                .replace(`{${"clientId"}}`, encodeURIComponent(String(clientId)))
                .replace(`{${"departmentId"}}`, encodeURIComponent(String(departmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateDepartmentRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DepartmentApi - functional programming interface
 * @export
 */
export const DepartmentApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DepartmentApiAxiosParamCreator(configuration)
    return {
        /**
         * 対象クライアントに部署を作成する。
         * @summary Create a department
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {CreateDepartmentRequest} createDepartmentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createDepartment(authorization: string, clientId: string, createDepartmentRequest: CreateDepartmentRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createDepartment(authorization, clientId, createDepartmentRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Delete a department
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {string} departmentId 部署ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteDepartment(authorization: string, clientId: string, departmentId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteDepartment(authorization, clientId, departmentId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get a department information
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {string} departmentId 部署ID
         * @param {boolean} [selectableParents] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDepartment(authorization: string, clientId: string, departmentId: string, selectableParents?: boolean, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetDepartmentResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDepartment(authorization, clientId, departmentId, selectableParents, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 対象クライアントの部署を返す。
         * @summary Get department list
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {string} [q] 
         * @param {string} [aim] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDepartments(authorization: string, clientId: string, q?: string, aim?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DepartmentHierarchy>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDepartments(authorization, clientId, q, aim, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 対象クライアントの従業員一覧を取得する。
         * @summary Get employee list
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {string} departmentId 部署ID
         * @param {string} [limit] レスポンスのデータ制限
         * @param {string} [offset] 
         * @param {string} [name] 
         * @param {Array<string>} [occupations] 
         * @param {Array<string>} [positions] 
         * @param {string} [examStartDate] 
         * @param {string} [examEndDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEmployees(authorization: string, clientId: string, departmentId: string, limit?: string, offset?: string, name?: string, occupations?: Array<string>, positions?: Array<string>, examStartDate?: string, examEndDate?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetEmployees200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEmployees(authorization, clientId, departmentId, limit, offset, name, occupations, positions, examStartDate, examEndDate, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 対象クライアントの部署を更新する。
         * @summary Update a department
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {string} departmentId 部署ID
         * @param {UpdateDepartmentRequest} updateDepartmentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateDepartment(authorization: string, clientId: string, departmentId: string, updateDepartmentRequest: UpdateDepartmentRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateDepartment(authorization, clientId, departmentId, updateDepartmentRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * DepartmentApi - factory interface
 * @export
 */
export const DepartmentApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DepartmentApiFp(configuration)
    return {
        /**
         * 対象クライアントに部署を作成する。
         * @summary Create a department
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {CreateDepartmentRequest} createDepartmentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDepartment(authorization: string, clientId: string, createDepartmentRequest: CreateDepartmentRequest, options?: any): AxiosPromise<void> {
            return localVarFp.createDepartment(authorization, clientId, createDepartmentRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete a department
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {string} departmentId 部署ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDepartment(authorization: string, clientId: string, departmentId: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteDepartment(authorization, clientId, departmentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a department information
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {string} departmentId 部署ID
         * @param {boolean} [selectableParents] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDepartment(authorization: string, clientId: string, departmentId: string, selectableParents?: boolean, options?: any): AxiosPromise<GetDepartmentResponse> {
            return localVarFp.getDepartment(authorization, clientId, departmentId, selectableParents, options).then((request) => request(axios, basePath));
        },
        /**
         * 対象クライアントの部署を返す。
         * @summary Get department list
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {string} [q] 
         * @param {string} [aim] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDepartments(authorization: string, clientId: string, q?: string, aim?: string, options?: any): AxiosPromise<Array<DepartmentHierarchy>> {
            return localVarFp.getDepartments(authorization, clientId, q, aim, options).then((request) => request(axios, basePath));
        },
        /**
         * 対象クライアントの従業員一覧を取得する。
         * @summary Get employee list
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {string} departmentId 部署ID
         * @param {string} [limit] レスポンスのデータ制限
         * @param {string} [offset] 
         * @param {string} [name] 
         * @param {Array<string>} [occupations] 
         * @param {Array<string>} [positions] 
         * @param {string} [examStartDate] 
         * @param {string} [examEndDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmployees(authorization: string, clientId: string, departmentId: string, limit?: string, offset?: string, name?: string, occupations?: Array<string>, positions?: Array<string>, examStartDate?: string, examEndDate?: string, options?: any): AxiosPromise<GetEmployees200Response> {
            return localVarFp.getEmployees(authorization, clientId, departmentId, limit, offset, name, occupations, positions, examStartDate, examEndDate, options).then((request) => request(axios, basePath));
        },
        /**
         * 対象クライアントの部署を更新する。
         * @summary Update a department
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {string} departmentId 部署ID
         * @param {UpdateDepartmentRequest} updateDepartmentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDepartment(authorization: string, clientId: string, departmentId: string, updateDepartmentRequest: UpdateDepartmentRequest, options?: any): AxiosPromise<void> {
            return localVarFp.updateDepartment(authorization, clientId, departmentId, updateDepartmentRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DepartmentApi - object-oriented interface
 * @export
 * @class DepartmentApi
 * @extends {BaseAPI}
 */
export class DepartmentApi extends BaseAPI {
    /**
     * 対象クライアントに部署を作成する。
     * @summary Create a department
     * @param {string} authorization 認証情報
     * @param {string} clientId クライアントID
     * @param {CreateDepartmentRequest} createDepartmentRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DepartmentApi
     */
    public createDepartment(params: { authorization?: string, clientId?: string, createDepartmentRequest: CreateDepartmentRequest,  }, options?: any) {
				const _params = {} as any;
				_params['authorization'] = params['authorization']
				_params['clientId'] = params['clientId']
				_params['createDepartmentRequest'] = params['createDepartmentRequest']
				// @ts-ignore
				_params.authorization = 'Bearer ' + ( params.authorization || Store.getInstance().getAccessToken())!
				_params.clientId = ((params as any).clientId || (Store.getInstance().getAuth() || {}).clientId)!;
        return DepartmentApiFp(this.configuration).createDepartment(_params.authorization, _params.clientId, _params.createDepartmentRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete a department
     * @param {string} authorization 認証情報
     * @param {string} clientId クライアントID
     * @param {string} departmentId 部署ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DepartmentApi
     */
    public deleteDepartment(params: { authorization?: string, clientId?: string, departmentId?: string,  }, options?: any) {
				const _params = {} as any;
				_params['authorization'] = params['authorization']
				_params['clientId'] = params['clientId']
				_params['departmentId'] = params['departmentId']
				// @ts-ignore
				_params.authorization = 'Bearer ' + ( params.authorization || Store.getInstance().getAccessToken())!
				_params.clientId = ((params as any).clientId || (Store.getInstance().getAuth() || {}).clientId)!;
        return DepartmentApiFp(this.configuration).deleteDepartment(_params.authorization, _params.clientId, _params.departmentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a department information
     * @param {string} authorization 認証情報
     * @param {string} clientId クライアントID
     * @param {string} departmentId 部署ID
     * @param {boolean} [selectableParents] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DepartmentApi
     */
    public getDepartment(params: { authorization?: string, clientId?: string, departmentId?: string, selectableParents?: boolean,  }, options?: any) {
				const _params = {} as any;
				_params['authorization'] = params['authorization']
				_params['clientId'] = params['clientId']
				_params['departmentId'] = params['departmentId']
				_params['selectableParents'] = params['selectableParents']
				// @ts-ignore
				_params.authorization = 'Bearer ' + ( params.authorization || Store.getInstance().getAccessToken())!
				_params.clientId = ((params as any).clientId || (Store.getInstance().getAuth() || {}).clientId)!;
        return DepartmentApiFp(this.configuration).getDepartment(_params.authorization, _params.clientId, _params.departmentId, _params.selectableParents, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 対象クライアントの部署を返す。
     * @summary Get department list
     * @param {string} authorization 認証情報
     * @param {string} clientId クライアントID
     * @param {string} [q] 
     * @param {string} [aim] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DepartmentApi
     */
    public getDepartments(params: { authorization?: string, clientId?: string, q?: string, aim?: string,  }, options?: any) {
				const _params = {} as any;
				_params['authorization'] = params['authorization']
				_params['clientId'] = params['clientId']
				_params['q'] = params['q']
				_params['aim'] = params['aim']
				// @ts-ignore
				_params.authorization = 'Bearer ' + ( params.authorization || Store.getInstance().getAccessToken())!
				_params.clientId = ((params as any).clientId || (Store.getInstance().getAuth() || {}).clientId)!;
        return DepartmentApiFp(this.configuration).getDepartments(_params.authorization, _params.clientId, _params.q, _params.aim, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 対象クライアントの従業員一覧を取得する。
     * @summary Get employee list
     * @param {string} authorization 認証情報
     * @param {string} clientId クライアントID
     * @param {string} departmentId 部署ID
     * @param {string} [limit] レスポンスのデータ制限
     * @param {string} [offset] 
     * @param {string} [name] 
     * @param {Array<string>} [occupations] 
     * @param {Array<string>} [positions] 
     * @param {string} [examStartDate] 
     * @param {string} [examEndDate] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DepartmentApi
     */
    public getEmployees(params: { authorization?: string, clientId?: string, departmentId?: string, limit?: string, offset?: string, name?: string, occupations?: Array<string>, positions?: Array<string>, examStartDate?: string, examEndDate?: string,  }, options?: any) {
				const _params = {} as any;
				_params['authorization'] = params['authorization']
				_params['clientId'] = params['clientId']
				_params['departmentId'] = params['departmentId']
				_params['limit'] = params['limit']
				_params['offset'] = params['offset']
				_params['name'] = params['name']
				_params['occupations'] = params['occupations']
				_params['positions'] = params['positions']
				_params['examStartDate'] = params['examStartDate']
				_params['examEndDate'] = params['examEndDate']
				// @ts-ignore
				_params.authorization = 'Bearer ' + ( params.authorization || Store.getInstance().getAccessToken())!
				_params.clientId = ((params as any).clientId || (Store.getInstance().getAuth() || {}).clientId)!;
        return DepartmentApiFp(this.configuration).getEmployees(_params.authorization, _params.clientId, _params.departmentId, _params.limit, _params.offset, _params.name, _params.occupations, _params.positions, _params.examStartDate, _params.examEndDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 対象クライアントの部署を更新する。
     * @summary Update a department
     * @param {string} authorization 認証情報
     * @param {string} clientId クライアントID
     * @param {string} departmentId 部署ID
     * @param {UpdateDepartmentRequest} updateDepartmentRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DepartmentApi
     */
    public updateDepartment(params: { authorization?: string, clientId?: string, departmentId?: string, updateDepartmentRequest: UpdateDepartmentRequest,  }, options?: any) {
				const _params = {} as any;
				_params['authorization'] = params['authorization']
				_params['clientId'] = params['clientId']
				_params['departmentId'] = params['departmentId']
				_params['updateDepartmentRequest'] = params['updateDepartmentRequest']
				// @ts-ignore
				_params.authorization = 'Bearer ' + ( params.authorization || Store.getInstance().getAccessToken())!
				_params.clientId = ((params as any).clientId || (Store.getInstance().getAuth() || {}).clientId)!;
        return DepartmentApiFp(this.configuration).updateDepartment(_params.authorization, _params.clientId, _params.departmentId, _params.updateDepartmentRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * EmployeeApi - axios parameter creator
 * @export
 */
export const EmployeeApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 対象クライアントに従業員を作成する。
         * @summary Create an employee
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {string} departmentId 部署ID
         * @param {CreateEmployee} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEmployee: async (authorization: string, clientId: string, departmentId: string, body: CreateEmployee, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('createEmployee', 'authorization', authorization)
            // verify required parameter 'clientId' is not null or undefined
            assertParamExists('createEmployee', 'clientId', clientId)
            // verify required parameter 'departmentId' is not null or undefined
            assertParamExists('createEmployee', 'departmentId', departmentId)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('createEmployee', 'body', body)
            const localVarPath = `/clients/{clientId}/departments/{departmentId}/employees`
                .replace(`{${"clientId"}}`, encodeURIComponent(String(clientId)))
                .replace(`{${"departmentId"}}`, encodeURIComponent(String(departmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 対象クライアントの従業員を削除する。
         * @summary Delete an employee
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {string} departmentId 部署ID
         * @param {string} employeeId 従業員ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEmployee: async (authorization: string, clientId: string, departmentId: string, employeeId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('deleteEmployee', 'authorization', authorization)
            // verify required parameter 'clientId' is not null or undefined
            assertParamExists('deleteEmployee', 'clientId', clientId)
            // verify required parameter 'departmentId' is not null or undefined
            assertParamExists('deleteEmployee', 'departmentId', departmentId)
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('deleteEmployee', 'employeeId', employeeId)
            const localVarPath = `/clients/{clientId}/departments/{departmentId}/employees/{employeeId}`
                .replace(`{${"clientId"}}`, encodeURIComponent(String(clientId)))
                .replace(`{${"departmentId"}}`, encodeURIComponent(String(departmentId)))
                .replace(`{${"employeeId"}}`, encodeURIComponent(String(employeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 対象クライアントの従業員を取得する。
         * @summary Get an employee
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {string} departmentId 部署ID
         * @param {string} employeeId 従業員ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmployee: async (authorization: string, clientId: string, departmentId: string, employeeId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('getEmployee', 'authorization', authorization)
            // verify required parameter 'clientId' is not null or undefined
            assertParamExists('getEmployee', 'clientId', clientId)
            // verify required parameter 'departmentId' is not null or undefined
            assertParamExists('getEmployee', 'departmentId', departmentId)
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('getEmployee', 'employeeId', employeeId)
            const localVarPath = `/clients/{clientId}/departments/{departmentId}/employees/{employeeId}`
                .replace(`{${"clientId"}}`, encodeURIComponent(String(clientId)))
                .replace(`{${"departmentId"}}`, encodeURIComponent(String(departmentId)))
                .replace(`{${"employeeId"}}`, encodeURIComponent(String(employeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 対象クライアントの退職者を取得する。
         * @summary Get retired list
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {string} [limit] レスポンスのデータ制限
         * @param {string} [offset] 
         * @param {boolean} [analysisFlg] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRetired: async (authorization: string, clientId: string, limit?: string, offset?: string, analysisFlg?: boolean, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('getRetired', 'authorization', authorization)
            // verify required parameter 'clientId' is not null or undefined
            assertParamExists('getRetired', 'clientId', clientId)
            const localVarPath = `/clients/{clientId}/retired`
                .replace(`{${"clientId"}}`, encodeURIComponent(String(clientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (analysisFlg !== undefined) {
                localVarQueryParameter['analysisFlg'] = analysisFlg;
            }

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 対象クライアントの従業員を取得する。
         * @summary Get empolyees list
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {string} [q] 
         * @param {string} [limit] レスポンスのデータ制限
         * @param {string} [occupationId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchEmployees: async (authorization: string, clientId: string, q?: string, limit?: string, occupationId?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('searchEmployees', 'authorization', authorization)
            // verify required parameter 'clientId' is not null or undefined
            assertParamExists('searchEmployees', 'clientId', clientId)
            const localVarPath = `/clients/{clientId}/employees`
                .replace(`{${"clientId"}}`, encodeURIComponent(String(clientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (occupationId !== undefined) {
                localVarQueryParameter['occupationId'] = occupationId;
            }

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 対象クライアントの従業員のプロフィール画像を更新する。
         * @summary Update an employee\'s avatar
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {string} employeeId 従業員ID
         * @param {UpdateAvatar} updateAvatar 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAvatar: async (authorization: string, clientId: string, employeeId: string, updateAvatar: UpdateAvatar, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('updateAvatar', 'authorization', authorization)
            // verify required parameter 'clientId' is not null or undefined
            assertParamExists('updateAvatar', 'clientId', clientId)
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('updateAvatar', 'employeeId', employeeId)
            // verify required parameter 'updateAvatar' is not null or undefined
            assertParamExists('updateAvatar', 'updateAvatar', updateAvatar)
            const localVarPath = `/clients/{clientId}/employees/{employeeId}/avatar`
                .replace(`{${"clientId"}}`, encodeURIComponent(String(clientId)))
                .replace(`{${"employeeId"}}`, encodeURIComponent(String(employeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateAvatar, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 対象クライアントの従業員を更新する。
         * @summary Update an employee
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {string} departmentId 部署ID
         * @param {string} employeeId 従業員ID
         * @param {UpdateEmployee} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEmployee: async (authorization: string, clientId: string, departmentId: string, employeeId: string, body: UpdateEmployee, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('updateEmployee', 'authorization', authorization)
            // verify required parameter 'clientId' is not null or undefined
            assertParamExists('updateEmployee', 'clientId', clientId)
            // verify required parameter 'departmentId' is not null or undefined
            assertParamExists('updateEmployee', 'departmentId', departmentId)
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('updateEmployee', 'employeeId', employeeId)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('updateEmployee', 'body', body)
            const localVarPath = `/clients/{clientId}/departments/{departmentId}/employees/{employeeId}`
                .replace(`{${"clientId"}}`, encodeURIComponent(String(clientId)))
                .replace(`{${"departmentId"}}`, encodeURIComponent(String(departmentId)))
                .replace(`{${"employeeId"}}`, encodeURIComponent(String(employeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EmployeeApi - functional programming interface
 * @export
 */
export const EmployeeApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = EmployeeApiAxiosParamCreator(configuration)
    return {
        /**
         * 対象クライアントに従業員を作成する。
         * @summary Create an employee
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {string} departmentId 部署ID
         * @param {CreateEmployee} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createEmployee(authorization: string, clientId: string, departmentId: string, body: CreateEmployee, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateEmployeeResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createEmployee(authorization, clientId, departmentId, body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 対象クライアントの従業員を削除する。
         * @summary Delete an employee
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {string} departmentId 部署ID
         * @param {string} employeeId 従業員ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteEmployee(authorization: string, clientId: string, departmentId: string, employeeId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteEmployee(authorization, clientId, departmentId, employeeId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 対象クライアントの従業員を取得する。
         * @summary Get an employee
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {string} departmentId 部署ID
         * @param {string} employeeId 従業員ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEmployee(authorization: string, clientId: string, departmentId: string, employeeId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetEmployeeProfile>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEmployee(authorization, clientId, departmentId, employeeId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 対象クライアントの退職者を取得する。
         * @summary Get retired list
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {string} [limit] レスポンスのデータ制限
         * @param {string} [offset] 
         * @param {boolean} [analysisFlg] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRetired(authorization: string, clientId: string, limit?: string, offset?: string, analysisFlg?: boolean, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetRetired200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRetired(authorization, clientId, limit, offset, analysisFlg, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 対象クライアントの従業員を取得する。
         * @summary Get empolyees list
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {string} [q] 
         * @param {string} [limit] レスポンスのデータ制限
         * @param {string} [occupationId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchEmployees(authorization: string, clientId: string, q?: string, limit?: string, occupationId?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SearchEmployees200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchEmployees(authorization, clientId, q, limit, occupationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 対象クライアントの従業員のプロフィール画像を更新する。
         * @summary Update an employee\'s avatar
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {string} employeeId 従業員ID
         * @param {UpdateAvatar} updateAvatar 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateAvatar(authorization: string, clientId: string, employeeId: string, updateAvatar: UpdateAvatar, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateAvatar(authorization, clientId, employeeId, updateAvatar, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 対象クライアントの従業員を更新する。
         * @summary Update an employee
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {string} departmentId 部署ID
         * @param {string} employeeId 従業員ID
         * @param {UpdateEmployee} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateEmployee(authorization: string, clientId: string, departmentId: string, employeeId: string, body: UpdateEmployee, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateEmployee(authorization, clientId, departmentId, employeeId, body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * EmployeeApi - factory interface
 * @export
 */
export const EmployeeApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = EmployeeApiFp(configuration)
    return {
        /**
         * 対象クライアントに従業員を作成する。
         * @summary Create an employee
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {string} departmentId 部署ID
         * @param {CreateEmployee} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEmployee(authorization: string, clientId: string, departmentId: string, body: CreateEmployee, options?: any): AxiosPromise<CreateEmployeeResponse> {
            return localVarFp.createEmployee(authorization, clientId, departmentId, body, options).then((request) => request(axios, basePath));
        },
        /**
         * 対象クライアントの従業員を削除する。
         * @summary Delete an employee
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {string} departmentId 部署ID
         * @param {string} employeeId 従業員ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEmployee(authorization: string, clientId: string, departmentId: string, employeeId: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteEmployee(authorization, clientId, departmentId, employeeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 対象クライアントの従業員を取得する。
         * @summary Get an employee
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {string} departmentId 部署ID
         * @param {string} employeeId 従業員ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmployee(authorization: string, clientId: string, departmentId: string, employeeId: string, options?: any): AxiosPromise<GetEmployeeProfile> {
            return localVarFp.getEmployee(authorization, clientId, departmentId, employeeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 対象クライアントの退職者を取得する。
         * @summary Get retired list
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {string} [limit] レスポンスのデータ制限
         * @param {string} [offset] 
         * @param {boolean} [analysisFlg] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRetired(authorization: string, clientId: string, limit?: string, offset?: string, analysisFlg?: boolean, options?: any): AxiosPromise<GetRetired200Response> {
            return localVarFp.getRetired(authorization, clientId, limit, offset, analysisFlg, options).then((request) => request(axios, basePath));
        },
        /**
         * 対象クライアントの従業員を取得する。
         * @summary Get empolyees list
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {string} [q] 
         * @param {string} [limit] レスポンスのデータ制限
         * @param {string} [occupationId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchEmployees(authorization: string, clientId: string, q?: string, limit?: string, occupationId?: string, options?: any): AxiosPromise<SearchEmployees200Response> {
            return localVarFp.searchEmployees(authorization, clientId, q, limit, occupationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 対象クライアントの従業員のプロフィール画像を更新する。
         * @summary Update an employee\'s avatar
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {string} employeeId 従業員ID
         * @param {UpdateAvatar} updateAvatar 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAvatar(authorization: string, clientId: string, employeeId: string, updateAvatar: UpdateAvatar, options?: any): AxiosPromise<void> {
            return localVarFp.updateAvatar(authorization, clientId, employeeId, updateAvatar, options).then((request) => request(axios, basePath));
        },
        /**
         * 対象クライアントの従業員を更新する。
         * @summary Update an employee
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {string} departmentId 部署ID
         * @param {string} employeeId 従業員ID
         * @param {UpdateEmployee} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEmployee(authorization: string, clientId: string, departmentId: string, employeeId: string, body: UpdateEmployee, options?: any): AxiosPromise<void> {
            return localVarFp.updateEmployee(authorization, clientId, departmentId, employeeId, body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * EmployeeApi - object-oriented interface
 * @export
 * @class EmployeeApi
 * @extends {BaseAPI}
 */
export class EmployeeApi extends BaseAPI {
    /**
     * 対象クライアントに従業員を作成する。
     * @summary Create an employee
     * @param {string} authorization 認証情報
     * @param {string} clientId クライアントID
     * @param {string} departmentId 部署ID
     * @param {CreateEmployee} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeApi
     */
    public createEmployee(params: { authorization?: string, clientId?: string, departmentId?: string, body: CreateEmployee,  }, options?: any) {
				const _params = {} as any;
				_params['authorization'] = params['authorization']
				_params['clientId'] = params['clientId']
				_params['departmentId'] = params['departmentId']
				_params['body'] = params['body']
				// @ts-ignore
				_params.authorization = 'Bearer ' + ( params.authorization || Store.getInstance().getAccessToken())!
				_params.clientId = ((params as any).clientId || (Store.getInstance().getAuth() || {}).clientId)!;
        return EmployeeApiFp(this.configuration).createEmployee(_params.authorization, _params.clientId, _params.departmentId, _params.body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 対象クライアントの従業員を削除する。
     * @summary Delete an employee
     * @param {string} authorization 認証情報
     * @param {string} clientId クライアントID
     * @param {string} departmentId 部署ID
     * @param {string} employeeId 従業員ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeApi
     */
    public deleteEmployee(params: { authorization?: string, clientId?: string, departmentId?: string, employeeId: string,  }, options?: any) {
				const _params = {} as any;
				_params['authorization'] = params['authorization']
				_params['clientId'] = params['clientId']
				_params['departmentId'] = params['departmentId']
				_params['employeeId'] = params['employeeId']
				// @ts-ignore
				_params.authorization = 'Bearer ' + ( params.authorization || Store.getInstance().getAccessToken())!
				_params.clientId = ((params as any).clientId || (Store.getInstance().getAuth() || {}).clientId)!;
        return EmployeeApiFp(this.configuration).deleteEmployee(_params.authorization, _params.clientId, _params.departmentId, _params.employeeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 対象クライアントの従業員を取得する。
     * @summary Get an employee
     * @param {string} authorization 認証情報
     * @param {string} clientId クライアントID
     * @param {string} departmentId 部署ID
     * @param {string} employeeId 従業員ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeApi
     */
    public getEmployee(params: { authorization?: string, clientId?: string, departmentId?: string, employeeId: string,  }, options?: any) {
				const _params = {} as any;
				_params['authorization'] = params['authorization']
				_params['clientId'] = params['clientId']
				_params['departmentId'] = params['departmentId']
				_params['employeeId'] = params['employeeId']
				// @ts-ignore
				_params.authorization = 'Bearer ' + ( params.authorization || Store.getInstance().getAccessToken())!
				_params.clientId = ((params as any).clientId || (Store.getInstance().getAuth() || {}).clientId)!;
        return EmployeeApiFp(this.configuration).getEmployee(_params.authorization, _params.clientId, _params.departmentId, _params.employeeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 対象クライアントの退職者を取得する。
     * @summary Get retired list
     * @param {string} authorization 認証情報
     * @param {string} clientId クライアントID
     * @param {string} [limit] レスポンスのデータ制限
     * @param {string} [offset] 
     * @param {boolean} [analysisFlg] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeApi
     */
    public getRetired(params: { authorization?: string, clientId?: string, limit?: string, offset?: string, analysisFlg?: boolean,  }, options?: any) {
				const _params = {} as any;
				_params['authorization'] = params['authorization']
				_params['clientId'] = params['clientId']
				_params['limit'] = params['limit']
				_params['offset'] = params['offset']
				_params['analysisFlg'] = params['analysisFlg']
				// @ts-ignore
				_params.authorization = 'Bearer ' + ( params.authorization || Store.getInstance().getAccessToken())!
				_params.clientId = ((params as any).clientId || (Store.getInstance().getAuth() || {}).clientId)!;
        return EmployeeApiFp(this.configuration).getRetired(_params.authorization, _params.clientId, _params.limit, _params.offset, _params.analysisFlg, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 対象クライアントの従業員を取得する。
     * @summary Get empolyees list
     * @param {string} authorization 認証情報
     * @param {string} clientId クライアントID
     * @param {string} [q] 
     * @param {string} [limit] レスポンスのデータ制限
     * @param {string} [occupationId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeApi
     */
    public searchEmployees(params: { authorization?: string, clientId?: string, q?: string, limit?: string, occupationId?: string,  }, options?: any) {
				const _params = {} as any;
				_params['authorization'] = params['authorization']
				_params['clientId'] = params['clientId']
				_params['q'] = params['q']
				_params['limit'] = params['limit']
				_params['occupationId'] = params['occupationId']
				// @ts-ignore
				_params.authorization = 'Bearer ' + ( params.authorization || Store.getInstance().getAccessToken())!
				_params.clientId = ((params as any).clientId || (Store.getInstance().getAuth() || {}).clientId)!;
        return EmployeeApiFp(this.configuration).searchEmployees(_params.authorization, _params.clientId, _params.q, _params.limit, _params.occupationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 対象クライアントの従業員のプロフィール画像を更新する。
     * @summary Update an employee\'s avatar
     * @param {string} authorization 認証情報
     * @param {string} clientId クライアントID
     * @param {string} employeeId 従業員ID
     * @param {UpdateAvatar} updateAvatar 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeApi
     */
    public updateAvatar(params: { authorization?: string, clientId?: string, employeeId: string, updateAvatar: UpdateAvatar,  }, options?: any) {
				const _params = {} as any;
				_params['authorization'] = params['authorization']
				_params['clientId'] = params['clientId']
				_params['employeeId'] = params['employeeId']
				_params['updateAvatar'] = params['updateAvatar']
				// @ts-ignore
				_params.authorization = 'Bearer ' + ( params.authorization || Store.getInstance().getAccessToken())!
				_params.clientId = ((params as any).clientId || (Store.getInstance().getAuth() || {}).clientId)!;
        return EmployeeApiFp(this.configuration).updateAvatar(_params.authorization, _params.clientId, _params.employeeId, _params.updateAvatar, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 対象クライアントの従業員を更新する。
     * @summary Update an employee
     * @param {string} authorization 認証情報
     * @param {string} clientId クライアントID
     * @param {string} departmentId 部署ID
     * @param {string} employeeId 従業員ID
     * @param {UpdateEmployee} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeApi
     */
    public updateEmployee(params: { authorization?: string, clientId?: string, departmentId?: string, employeeId: string, body: UpdateEmployee,  }, options?: any) {
				const _params = {} as any;
				_params['authorization'] = params['authorization']
				_params['clientId'] = params['clientId']
				_params['departmentId'] = params['departmentId']
				_params['employeeId'] = params['employeeId']
				_params['body'] = params['body']
				// @ts-ignore
				_params.authorization = 'Bearer ' + ( params.authorization || Store.getInstance().getAccessToken())!
				_params.clientId = ((params as any).clientId || (Store.getInstance().getAuth() || {}).clientId)!;
        return EmployeeApiFp(this.configuration).updateEmployee(_params.authorization, _params.clientId, _params.departmentId, _params.employeeId, _params.body, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * NotificationsApi - axios parameter creator
 * @export
 */
export const NotificationsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 対象クライアントのお知らせを作成する。
         * @summary Create a new notification
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {NotificationRequest} notificationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createNotification: async (authorization: string, clientId: string, notificationRequest: NotificationRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('createNotification', 'authorization', authorization)
            // verify required parameter 'clientId' is not null or undefined
            assertParamExists('createNotification', 'clientId', clientId)
            // verify required parameter 'notificationRequest' is not null or undefined
            assertParamExists('createNotification', 'notificationRequest', notificationRequest)
            const localVarPath = `/clients/{clientId}/notifications`
                .replace(`{${"clientId"}}`, encodeURIComponent(String(clientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(notificationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 対象クライアントのお知らせを既読状態にする。
         * @summary Create notification receipt/s
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {PostNotificationReceipt} postNotificationReceipt 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createNotificationReceipt: async (authorization: string, clientId: string, postNotificationReceipt: PostNotificationReceipt, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('createNotificationReceipt', 'authorization', authorization)
            // verify required parameter 'clientId' is not null or undefined
            assertParamExists('createNotificationReceipt', 'clientId', clientId)
            // verify required parameter 'postNotificationReceipt' is not null or undefined
            assertParamExists('createNotificationReceipt', 'postNotificationReceipt', postNotificationReceipt)
            const localVarPath = `/clients/{clientId}/notificationReceipts`
                .replace(`{${"clientId"}}`, encodeURIComponent(String(clientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postNotificationReceipt, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 対象クライアントのお知らせを削除する。
         * @summary Delete notification
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteNotification: async (authorization: string, clientId: string, id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('deleteNotification', 'authorization', authorization)
            // verify required parameter 'clientId' is not null or undefined
            assertParamExists('deleteNotification', 'clientId', clientId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteNotification', 'id', id)
            const localVarPath = `/clients/{clientId}/notifications/{id}`
                .replace(`{${"clientId"}}`, encodeURIComponent(String(clientId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 対象クライアントのお知らせ一覧を取得する。
         * @summary Get notifications specific to the signed in user
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {NotificationLanguageEnum} [language] 
         * @param {NotificationCategoryEnum} [category] 
         * @param {NotificationContextEnum} [context] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNotifications: async (authorization: string, clientId: string, language?: NotificationLanguageEnum, category?: NotificationCategoryEnum, context?: NotificationContextEnum, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('getNotifications', 'authorization', authorization)
            // verify required parameter 'clientId' is not null or undefined
            assertParamExists('getNotifications', 'clientId', clientId)
            const localVarPath = `/clients/{clientId}/notifications`
                .replace(`{${"clientId"}}`, encodeURIComponent(String(clientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (language !== undefined) {
                localVarQueryParameter['language'] = language;
            }

            if (category !== undefined) {
                localVarQueryParameter['category'] = category;
            }

            if (context !== undefined) {
                localVarQueryParameter['context'] = context;
            }

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 対象クライアントのお知らせを更新する。
         * @summary Update notification
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {string} id 
         * @param {NotificationRequest} notificationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateNotification: async (authorization: string, clientId: string, id: string, notificationRequest: NotificationRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('updateNotification', 'authorization', authorization)
            // verify required parameter 'clientId' is not null or undefined
            assertParamExists('updateNotification', 'clientId', clientId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateNotification', 'id', id)
            // verify required parameter 'notificationRequest' is not null or undefined
            assertParamExists('updateNotification', 'notificationRequest', notificationRequest)
            const localVarPath = `/clients/{clientId}/notifications/{id}`
                .replace(`{${"clientId"}}`, encodeURIComponent(String(clientId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(notificationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * NotificationsApi - functional programming interface
 * @export
 */
export const NotificationsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = NotificationsApiAxiosParamCreator(configuration)
    return {
        /**
         * 対象クライアントのお知らせを作成する。
         * @summary Create a new notification
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {NotificationRequest} notificationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createNotification(authorization: string, clientId: string, notificationRequest: NotificationRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createNotification(authorization, clientId, notificationRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 対象クライアントのお知らせを既読状態にする。
         * @summary Create notification receipt/s
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {PostNotificationReceipt} postNotificationReceipt 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createNotificationReceipt(authorization: string, clientId: string, postNotificationReceipt: PostNotificationReceipt, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createNotificationReceipt(authorization, clientId, postNotificationReceipt, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 対象クライアントのお知らせを削除する。
         * @summary Delete notification
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteNotification(authorization: string, clientId: string, id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteNotification(authorization, clientId, id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 対象クライアントのお知らせ一覧を取得する。
         * @summary Get notifications specific to the signed in user
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {NotificationLanguageEnum} [language] 
         * @param {NotificationCategoryEnum} [category] 
         * @param {NotificationContextEnum} [context] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getNotifications(authorization: string, clientId: string, language?: NotificationLanguageEnum, category?: NotificationCategoryEnum, context?: NotificationContextEnum, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Notification>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getNotifications(authorization, clientId, language, category, context, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 対象クライアントのお知らせを更新する。
         * @summary Update notification
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {string} id 
         * @param {NotificationRequest} notificationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateNotification(authorization: string, clientId: string, id: string, notificationRequest: NotificationRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateNotification(authorization, clientId, id, notificationRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * NotificationsApi - factory interface
 * @export
 */
export const NotificationsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = NotificationsApiFp(configuration)
    return {
        /**
         * 対象クライアントのお知らせを作成する。
         * @summary Create a new notification
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {NotificationRequest} notificationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createNotification(authorization: string, clientId: string, notificationRequest: NotificationRequest, options?: any): AxiosPromise<void> {
            return localVarFp.createNotification(authorization, clientId, notificationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 対象クライアントのお知らせを既読状態にする。
         * @summary Create notification receipt/s
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {PostNotificationReceipt} postNotificationReceipt 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createNotificationReceipt(authorization: string, clientId: string, postNotificationReceipt: PostNotificationReceipt, options?: any): AxiosPromise<void> {
            return localVarFp.createNotificationReceipt(authorization, clientId, postNotificationReceipt, options).then((request) => request(axios, basePath));
        },
        /**
         * 対象クライアントのお知らせを削除する。
         * @summary Delete notification
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteNotification(authorization: string, clientId: string, id: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteNotification(authorization, clientId, id, options).then((request) => request(axios, basePath));
        },
        /**
         * 対象クライアントのお知らせ一覧を取得する。
         * @summary Get notifications specific to the signed in user
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {NotificationLanguageEnum} [language] 
         * @param {NotificationCategoryEnum} [category] 
         * @param {NotificationContextEnum} [context] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNotifications(authorization: string, clientId: string, language?: NotificationLanguageEnum, category?: NotificationCategoryEnum, context?: NotificationContextEnum, options?: any): AxiosPromise<Array<Notification>> {
            return localVarFp.getNotifications(authorization, clientId, language, category, context, options).then((request) => request(axios, basePath));
        },
        /**
         * 対象クライアントのお知らせを更新する。
         * @summary Update notification
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {string} id 
         * @param {NotificationRequest} notificationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateNotification(authorization: string, clientId: string, id: string, notificationRequest: NotificationRequest, options?: any): AxiosPromise<void> {
            return localVarFp.updateNotification(authorization, clientId, id, notificationRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * NotificationsApi - object-oriented interface
 * @export
 * @class NotificationsApi
 * @extends {BaseAPI}
 */
export class NotificationsApi extends BaseAPI {
    /**
     * 対象クライアントのお知らせを作成する。
     * @summary Create a new notification
     * @param {string} authorization 認証情報
     * @param {string} clientId クライアントID
     * @param {NotificationRequest} notificationRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsApi
     */
    public createNotification(params: { authorization?: string, clientId?: string, notificationRequest: NotificationRequest,  }, options?: any) {
				const _params = {} as any;
				_params['authorization'] = params['authorization']
				_params['clientId'] = params['clientId']
				_params['notificationRequest'] = params['notificationRequest']
				// @ts-ignore
				_params.authorization = 'Bearer ' + ( params.authorization || Store.getInstance().getAccessToken())!
				_params.clientId = ((params as any).clientId || (Store.getInstance().getAuth() || {}).clientId)!;
        return NotificationsApiFp(this.configuration).createNotification(_params.authorization, _params.clientId, _params.notificationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 対象クライアントのお知らせを既読状態にする。
     * @summary Create notification receipt/s
     * @param {string} authorization 認証情報
     * @param {string} clientId クライアントID
     * @param {PostNotificationReceipt} postNotificationReceipt 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsApi
     */
    public createNotificationReceipt(params: { authorization?: string, clientId?: string, postNotificationReceipt: PostNotificationReceipt,  }, options?: any) {
				const _params = {} as any;
				_params['authorization'] = params['authorization']
				_params['clientId'] = params['clientId']
				_params['postNotificationReceipt'] = params['postNotificationReceipt']
				// @ts-ignore
				_params.authorization = 'Bearer ' + ( params.authorization || Store.getInstance().getAccessToken())!
				_params.clientId = ((params as any).clientId || (Store.getInstance().getAuth() || {}).clientId)!;
        return NotificationsApiFp(this.configuration).createNotificationReceipt(_params.authorization, _params.clientId, _params.postNotificationReceipt, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 対象クライアントのお知らせを削除する。
     * @summary Delete notification
     * @param {string} authorization 認証情報
     * @param {string} clientId クライアントID
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsApi
     */
    public deleteNotification(params: { authorization?: string, clientId?: string, id: string,  }, options?: any) {
				const _params = {} as any;
				_params['authorization'] = params['authorization']
				_params['clientId'] = params['clientId']
				_params['id'] = params['id']
				// @ts-ignore
				_params.authorization = 'Bearer ' + ( params.authorization || Store.getInstance().getAccessToken())!
				_params.clientId = ((params as any).clientId || (Store.getInstance().getAuth() || {}).clientId)!;
        return NotificationsApiFp(this.configuration).deleteNotification(_params.authorization, _params.clientId, _params.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 対象クライアントのお知らせ一覧を取得する。
     * @summary Get notifications specific to the signed in user
     * @param {string} authorization 認証情報
     * @param {string} clientId クライアントID
     * @param {NotificationLanguageEnum} [language] 
     * @param {NotificationCategoryEnum} [category] 
     * @param {NotificationContextEnum} [context] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsApi
     */
    public getNotifications(params: { authorization?: string, clientId?: string, language?: NotificationLanguageEnum, category?: NotificationCategoryEnum, context?: NotificationContextEnum,  }, options?: any) {
				const _params = {} as any;
				_params['authorization'] = params['authorization']
				_params['clientId'] = params['clientId']
				_params['language'] = params['language']
				_params['category'] = params['category']
				_params['context'] = params['context']
				// @ts-ignore
				_params.authorization = 'Bearer ' + ( params.authorization || Store.getInstance().getAccessToken())!
				_params.clientId = ((params as any).clientId || (Store.getInstance().getAuth() || {}).clientId)!;
        return NotificationsApiFp(this.configuration).getNotifications(_params.authorization, _params.clientId, _params.language, _params.category, _params.context, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 対象クライアントのお知らせを更新する。
     * @summary Update notification
     * @param {string} authorization 認証情報
     * @param {string} clientId クライアントID
     * @param {string} id 
     * @param {NotificationRequest} notificationRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsApi
     */
    public updateNotification(params: { authorization?: string, clientId?: string, id: string, notificationRequest: NotificationRequest,  }, options?: any) {
				const _params = {} as any;
				_params['authorization'] = params['authorization']
				_params['clientId'] = params['clientId']
				_params['id'] = params['id']
				_params['notificationRequest'] = params['notificationRequest']
				// @ts-ignore
				_params.authorization = 'Bearer ' + ( params.authorization || Store.getInstance().getAccessToken())!
				_params.clientId = ((params as any).clientId || (Store.getInstance().getAuth() || {}).clientId)!;
        return NotificationsApiFp(this.configuration).updateNotification(_params.authorization, _params.clientId, _params.id, _params.notificationRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * StatsApi - axios parameter creator
 * @export
 */
export const StatsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 対象クライアントの人材基準判定に基いて結果をダウンロードする。
         * @summary Get people\'s criteria judgment result
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {string} peopleId 
         * @param {Array<string>} [criteriaList] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCriteriaJudgmentResult: async (authorization: string, clientId: string, peopleId: string, criteriaList?: Array<string>, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('getCriteriaJudgmentResult', 'authorization', authorization)
            // verify required parameter 'clientId' is not null or undefined
            assertParamExists('getCriteriaJudgmentResult', 'clientId', clientId)
            // verify required parameter 'peopleId' is not null or undefined
            assertParamExists('getCriteriaJudgmentResult', 'peopleId', peopleId)
            const localVarPath = `/clients/{clientId}/people/criteriaJudgmentResult`
                .replace(`{${"clientId"}}`, encodeURIComponent(String(clientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (peopleId !== undefined) {
                localVarQueryParameter['peopleId'] = peopleId;
            }

            if (criteriaList) {
                localVarQueryParameter['criteriaList'] = criteriaList;
            }

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 対象クライアントの人材基準判定に基いて結果をダウンロードする。
         * @summary Get excel file (.xlsx) of criteria judgment result
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {string} peopleIds 
         * @param {string} criteriaList 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCriteriaJudgmentResults: async (authorization: string, clientId: string, peopleIds: string, criteriaList: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('getCriteriaJudgmentResults', 'authorization', authorization)
            // verify required parameter 'clientId' is not null or undefined
            assertParamExists('getCriteriaJudgmentResults', 'clientId', clientId)
            // verify required parameter 'peopleIds' is not null or undefined
            assertParamExists('getCriteriaJudgmentResults', 'peopleIds', peopleIds)
            // verify required parameter 'criteriaList' is not null or undefined
            assertParamExists('getCriteriaJudgmentResults', 'criteriaList', criteriaList)
            const localVarPath = `/clients/{clientId}/criteriaJudgmentResults`
                .replace(`{${"clientId"}}`, encodeURIComponent(String(clientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (peopleIds !== undefined) {
                localVarQueryParameter['peopleIds'] = peopleIds;
            }

            if (criteriaList !== undefined) {
                localVarQueryParameter['criteriaList'] = criteriaList;
            }

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 対象クライアントのサマリーを取得する。
         * @summary Get stats summary of the department
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {string} departmentId 部署ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDepartmentSummary: async (authorization: string, clientId: string, departmentId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('getDepartmentSummary', 'authorization', authorization)
            // verify required parameter 'clientId' is not null or undefined
            assertParamExists('getDepartmentSummary', 'clientId', clientId)
            // verify required parameter 'departmentId' is not null or undefined
            assertParamExists('getDepartmentSummary', 'departmentId', departmentId)
            const localVarPath = `/clients/{clientId}/departments/{departmentId}/summary`
                .replace(`{${"clientId"}}`, encodeURIComponent(String(clientId)))
                .replace(`{${"departmentId"}}`, encodeURIComponent(String(departmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 対象クライアントに属するユーザーの受検結果を取得する。
         * @summary Get people\'s stats
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {Array<string>} peopleIds 
         * @param {Array<StatsItemEnum>} statsItems 
         * @param {Array<string>} [examDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPeopleStats: async (authorization: string, clientId: string, peopleIds: Array<string>, statsItems: Array<StatsItemEnum>, examDate?: Array<string>, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('getPeopleStats', 'authorization', authorization)
            // verify required parameter 'clientId' is not null or undefined
            assertParamExists('getPeopleStats', 'clientId', clientId)
            // verify required parameter 'peopleIds' is not null or undefined
            assertParamExists('getPeopleStats', 'peopleIds', peopleIds)
            // verify required parameter 'statsItems' is not null or undefined
            assertParamExists('getPeopleStats', 'statsItems', statsItems)
            const localVarPath = `/clients/{clientId}/stats`
                .replace(`{${"clientId"}}`, encodeURIComponent(String(clientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (peopleIds) {
                localVarQueryParameter['peopleIds'] = peopleIds;
            }

            if (statsItems) {
                localVarQueryParameter['statsItems'] = statsItems;
            }

            if (examDate) {
                localVarQueryParameter['examDate'] = examDate;
            }

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * StatsApi - functional programming interface
 * @export
 */
export const StatsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = StatsApiAxiosParamCreator(configuration)
    return {
        /**
         * 対象クライアントの人材基準判定に基いて結果をダウンロードする。
         * @summary Get people\'s criteria judgment result
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {string} peopleId 
         * @param {Array<string>} [criteriaList] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCriteriaJudgmentResult(authorization: string, clientId: string, peopleId: string, criteriaList?: Array<string>, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: Array<CriteriaJudgmentResultItem>; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCriteriaJudgmentResult(authorization, clientId, peopleId, criteriaList, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 対象クライアントの人材基準判定に基いて結果をダウンロードする。
         * @summary Get excel file (.xlsx) of criteria judgment result
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {string} peopleIds 
         * @param {string} criteriaList 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCriteriaJudgmentResults(authorization: string, clientId: string, peopleIds: string, criteriaList: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCriteriaJudgmentResults(authorization, clientId, peopleIds, criteriaList, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 対象クライアントのサマリーを取得する。
         * @summary Get stats summary of the department
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {string} departmentId 部署ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDepartmentSummary(authorization: string, clientId: string, departmentId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetSummaryResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDepartmentSummary(authorization, clientId, departmentId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 対象クライアントに属するユーザーの受検結果を取得する。
         * @summary Get people\'s stats
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {Array<string>} peopleIds 
         * @param {Array<StatsItemEnum>} statsItems 
         * @param {Array<string>} [examDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPeopleStats(authorization: string, clientId: string, peopleIds: Array<string>, statsItems: Array<StatsItemEnum>, examDate?: Array<string>, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetStats>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPeopleStats(authorization, clientId, peopleIds, statsItems, examDate, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * StatsApi - factory interface
 * @export
 */
export const StatsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = StatsApiFp(configuration)
    return {
        /**
         * 対象クライアントの人材基準判定に基いて結果をダウンロードする。
         * @summary Get people\'s criteria judgment result
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {string} peopleId 
         * @param {Array<string>} [criteriaList] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCriteriaJudgmentResult(authorization: string, clientId: string, peopleId: string, criteriaList?: Array<string>, options?: any): AxiosPromise<{ [key: string]: Array<CriteriaJudgmentResultItem>; }> {
            return localVarFp.getCriteriaJudgmentResult(authorization, clientId, peopleId, criteriaList, options).then((request) => request(axios, basePath));
        },
        /**
         * 対象クライアントの人材基準判定に基いて結果をダウンロードする。
         * @summary Get excel file (.xlsx) of criteria judgment result
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {string} peopleIds 
         * @param {string} criteriaList 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCriteriaJudgmentResults(authorization: string, clientId: string, peopleIds: string, criteriaList: string, options?: any): AxiosPromise<any> {
            return localVarFp.getCriteriaJudgmentResults(authorization, clientId, peopleIds, criteriaList, options).then((request) => request(axios, basePath));
        },
        /**
         * 対象クライアントのサマリーを取得する。
         * @summary Get stats summary of the department
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {string} departmentId 部署ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDepartmentSummary(authorization: string, clientId: string, departmentId: string, options?: any): AxiosPromise<GetSummaryResponse> {
            return localVarFp.getDepartmentSummary(authorization, clientId, departmentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 対象クライアントに属するユーザーの受検結果を取得する。
         * @summary Get people\'s stats
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {Array<string>} peopleIds 
         * @param {Array<StatsItemEnum>} statsItems 
         * @param {Array<string>} [examDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPeopleStats(authorization: string, clientId: string, peopleIds: Array<string>, statsItems: Array<StatsItemEnum>, examDate?: Array<string>, options?: any): AxiosPromise<GetStats> {
            return localVarFp.getPeopleStats(authorization, clientId, peopleIds, statsItems, examDate, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * StatsApi - object-oriented interface
 * @export
 * @class StatsApi
 * @extends {BaseAPI}
 */
export class StatsApi extends BaseAPI {
    /**
     * 対象クライアントの人材基準判定に基いて結果をダウンロードする。
     * @summary Get people\'s criteria judgment result
     * @param {string} authorization 認証情報
     * @param {string} clientId クライアントID
     * @param {string} peopleId 
     * @param {Array<string>} [criteriaList] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StatsApi
     */
    public getCriteriaJudgmentResult(params: { authorization?: string, clientId?: string, peopleId: string, criteriaList?: Array<string>,  }, options?: any) {
				const _params = {} as any;
				_params['authorization'] = params['authorization']
				_params['clientId'] = params['clientId']
				_params['peopleId'] = params['peopleId']
				_params['criteriaList'] = params['criteriaList']
				// @ts-ignore
				_params.authorization = 'Bearer ' + ( params.authorization || Store.getInstance().getAccessToken())!
				_params.clientId = ((params as any).clientId || (Store.getInstance().getAuth() || {}).clientId)!;
        return StatsApiFp(this.configuration).getCriteriaJudgmentResult(_params.authorization, _params.clientId, _params.peopleId, _params.criteriaList, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 対象クライアントの人材基準判定に基いて結果をダウンロードする。
     * @summary Get excel file (.xlsx) of criteria judgment result
     * @param {string} authorization 認証情報
     * @param {string} clientId クライアントID
     * @param {string} peopleIds 
     * @param {string} criteriaList 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StatsApi
     */
    public getCriteriaJudgmentResults(params: { authorization?: string, clientId?: string, peopleIds: string, criteriaList: string,  }, options?: any) {
				const _params = {} as any;
				_params['authorization'] = params['authorization']
				_params['clientId'] = params['clientId']
				_params['peopleIds'] = params['peopleIds']
				_params['criteriaList'] = params['criteriaList']
				// @ts-ignore
				_params.authorization = 'Bearer ' + ( params.authorization || Store.getInstance().getAccessToken())!
				_params.clientId = ((params as any).clientId || (Store.getInstance().getAuth() || {}).clientId)!;
        return StatsApiFp(this.configuration).getCriteriaJudgmentResults(_params.authorization, _params.clientId, _params.peopleIds, _params.criteriaList, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 対象クライアントのサマリーを取得する。
     * @summary Get stats summary of the department
     * @param {string} authorization 認証情報
     * @param {string} clientId クライアントID
     * @param {string} departmentId 部署ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StatsApi
     */
    public getDepartmentSummary(params: { authorization?: string, clientId?: string, departmentId?: string,  }, options?: any) {
				const _params = {} as any;
				_params['authorization'] = params['authorization']
				_params['clientId'] = params['clientId']
				_params['departmentId'] = params['departmentId']
				// @ts-ignore
				_params.authorization = 'Bearer ' + ( params.authorization || Store.getInstance().getAccessToken())!
				_params.clientId = ((params as any).clientId || (Store.getInstance().getAuth() || {}).clientId)!;
        return StatsApiFp(this.configuration).getDepartmentSummary(_params.authorization, _params.clientId, _params.departmentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 対象クライアントに属するユーザーの受検結果を取得する。
     * @summary Get people\'s stats
     * @param {string} authorization 認証情報
     * @param {string} clientId クライアントID
     * @param {Array<string>} peopleIds 
     * @param {Array<StatsItemEnum>} statsItems 
     * @param {Array<string>} [examDate] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StatsApi
     */
    public getPeopleStats(params: { authorization?: string, clientId?: string, peopleIds: Array<string>, statsItems: Array<StatsItemEnum>, examDate?: Array<string>,  }, options?: any) {
				const _params = {} as any;
				_params['authorization'] = params['authorization']
				_params['clientId'] = params['clientId']
				_params['peopleIds'] = params['peopleIds']
				_params['statsItems'] = params['statsItems']
				_params['examDate'] = params['examDate']
				// @ts-ignore
				_params.authorization = 'Bearer ' + ( params.authorization || Store.getInstance().getAccessToken())!
				_params.clientId = ((params as any).clientId || (Store.getInstance().getAuth() || {}).clientId)!;
        return StatsApiFp(this.configuration).getPeopleStats(_params.authorization, _params.clientId, _params.peopleIds, _params.statsItems, _params.examDate, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * SystemApi - axios parameter creator
 * @export
 */
export const SystemApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 従業員、応募者の受検結果をCSVでダウンロードする。
         * @summary Output CSV file of assessment survey scores for employees and applicants
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {AsExportTypeEnum} type 
         * @param {string} [departmentId] 
         * @param {ApplicantStatsEnum} [applicantStatus] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        asexport: async (authorization: string, clientId: string, type: AsExportTypeEnum, departmentId?: string, applicantStatus?: ApplicantStatsEnum, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('asexport', 'authorization', authorization)
            // verify required parameter 'clientId' is not null or undefined
            assertParamExists('asexport', 'clientId', clientId)
            // verify required parameter 'type' is not null or undefined
            assertParamExists('asexport', 'type', type)
            const localVarPath = `/clients/{clientId}/csv/asexport`
                .replace(`{${"clientId"}}`, encodeURIComponent(String(clientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }

            if (departmentId !== undefined) {
                localVarQueryParameter['departmentId'] = departmentId;
            }

            if (applicantStatus !== undefined) {
                localVarQueryParameter['applicantStatus'] = applicantStatus;
            }

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 対象クライアントのタグをユーザーに付与する。
         * @summary Attach tags
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {AttachTag} attachTag 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        attachTag: async (authorization: string, clientId: string, attachTag: AttachTag, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('attachTag', 'authorization', authorization)
            // verify required parameter 'clientId' is not null or undefined
            assertParamExists('attachTag', 'clientId', clientId)
            // verify required parameter 'attachTag' is not null or undefined
            assertParamExists('attachTag', 'attachTag', attachTag)
            const localVarPath = `/clients/{clientId}/person/tags`
                .replace(`{${"clientId"}}`, encodeURIComponent(String(clientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(attachTag, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 対象クライアントにメールテンプレートを作成する。
         * @summary Create Email Template
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {EmailTemplateCreate} emailTemplateCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEmailTemplate: async (authorization: string, clientId: string, emailTemplateCreate: EmailTemplateCreate, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('createEmailTemplate', 'authorization', authorization)
            // verify required parameter 'clientId' is not null or undefined
            assertParamExists('createEmailTemplate', 'clientId', clientId)
            // verify required parameter 'emailTemplateCreate' is not null or undefined
            assertParamExists('createEmailTemplate', 'emailTemplateCreate', emailTemplateCreate)
            const localVarPath = `/clients/{clientId}/EmailTemplates`
                .replace(`{${"clientId"}}`, encodeURIComponent(String(clientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2PasswordBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(emailTemplateCreate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 対象クライアントのタグを作成する。
         * @summary Post tags
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {CreateTag} createTag 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTag: async (authorization: string, clientId: string, createTag: CreateTag, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('createTag', 'authorization', authorization)
            // verify required parameter 'clientId' is not null or undefined
            assertParamExists('createTag', 'clientId', clientId)
            // verify required parameter 'createTag' is not null or undefined
            assertParamExists('createTag', 'createTag', createTag)
            const localVarPath = `/clients/{clientId}/tags`
                .replace(`{${"clientId"}}`, encodeURIComponent(String(clientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createTag, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 対象クライアントにトライアルアカウントを作成する。
         * @summary Create trial coount
         * @param {string} authorization 認証情報
         * @param {CreateTrialAccountRequest} createTrialAccountRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTrialAccount: async (authorization: string, createTrialAccountRequest: CreateTrialAccountRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('createTrialAccount', 'authorization', authorization)
            // verify required parameter 'createTrialAccountRequest' is not null or undefined
            assertParamExists('createTrialAccount', 'createTrialAccountRequest', createTrialAccountRequest)
            const localVarPath = `/clients/trialAccount`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createTrialAccountRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 対象クライアントのメールテンプレートを削除する。
         * @summary Delete Email Template
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {EmailTemplateTypeEnum} emailTemplateType 
         * @param {string} emailTemplateId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEmailTemplate: async (authorization: string, clientId: string, emailTemplateType: EmailTemplateTypeEnum, emailTemplateId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('deleteEmailTemplate', 'authorization', authorization)
            // verify required parameter 'clientId' is not null or undefined
            assertParamExists('deleteEmailTemplate', 'clientId', clientId)
            // verify required parameter 'emailTemplateType' is not null or undefined
            assertParamExists('deleteEmailTemplate', 'emailTemplateType', emailTemplateType)
            // verify required parameter 'emailTemplateId' is not null or undefined
            assertParamExists('deleteEmailTemplate', 'emailTemplateId', emailTemplateId)
            const localVarPath = `/clients/{clientId}/EmailTemplates/{emailTemplateType}/{emailTemplateId}`
                .replace(`{${"clientId"}}`, encodeURIComponent(String(clientId)))
                .replace(`{${"emailTemplateType"}}`, encodeURIComponent(String(emailTemplateType)))
                .replace(`{${"emailTemplateId"}}`, encodeURIComponent(String(emailTemplateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2PasswordBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 対象クライアントのタグを削除する。
         * @summary Delete tags
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {string} tagId タグID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTag: async (authorization: string, clientId: string, tagId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('deleteTag', 'authorization', authorization)
            // verify required parameter 'clientId' is not null or undefined
            assertParamExists('deleteTag', 'clientId', clientId)
            // verify required parameter 'tagId' is not null or undefined
            assertParamExists('deleteTag', 'tagId', tagId)
            const localVarPath = `/clients/{clientId}/tags/{tagId}`
                .replace(`{${"clientId"}}`, encodeURIComponent(String(clientId)))
                .replace(`{${"tagId"}}`, encodeURIComponent(String(tagId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 対象クライアントのタグをユーザーから除去する。
         * @summary Detach tags
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {string} tagId タグID
         * @param {DetachTag} detachTag 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        detachTag: async (authorization: string, clientId: string, tagId: string, detachTag: DetachTag, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('detachTag', 'authorization', authorization)
            // verify required parameter 'clientId' is not null or undefined
            assertParamExists('detachTag', 'clientId', clientId)
            // verify required parameter 'tagId' is not null or undefined
            assertParamExists('detachTag', 'tagId', tagId)
            // verify required parameter 'detachTag' is not null or undefined
            assertParamExists('detachTag', 'detachTag', detachTag)
            const localVarPath = `/clients/{clientId}/person/tags/{tagId}`
                .replace(`{${"clientId"}}`, encodeURIComponent(String(clientId)))
                .replace(`{${"tagId"}}`, encodeURIComponent(String(tagId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(detachTag, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 対象クライアントにアセスメントサーベイの受検URL一覧を取得する。
         * @summary Output URL CSV
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {string} asBroadcastId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportAsUrlCsv: async (authorization: string, clientId: string, asBroadcastId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('exportAsUrlCsv', 'authorization', authorization)
            // verify required parameter 'clientId' is not null or undefined
            assertParamExists('exportAsUrlCsv', 'clientId', clientId)
            // verify required parameter 'asBroadcastId' is not null or undefined
            assertParamExists('exportAsUrlCsv', 'asBroadcastId', asBroadcastId)
            const localVarPath = `/clients/{clientId}/asBroadcast/{asBroadcastId}/csv/url`
                .replace(`{${"clientId"}}`, encodeURIComponent(String(clientId)))
                .replace(`{${"asBroadcastId"}}`, encodeURIComponent(String(asBroadcastId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 対象クライアントの月次データをもとにCSVを出力する。
         * @summary Output CSV file for monthly billing info
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {string} period 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportBillintCsv: async (authorization: string, clientId: string, period: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('exportBillintCsv', 'authorization', authorization)
            // verify required parameter 'clientId' is not null or undefined
            assertParamExists('exportBillintCsv', 'clientId', clientId)
            // verify required parameter 'period' is not null or undefined
            assertParamExists('exportBillintCsv', 'period', period)
            const localVarPath = `/clients/{clientId}/csv/billing`
                .replace(`{${"clientId"}}`, encodeURIComponent(String(clientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (period !== undefined) {
                localVarQueryParameter['period'] = period;
            }

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 対象クライアントのメールテンプレート一覧を取得する。
         * @summary Get Email Templates
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {string} [q] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmailTemplates: async (authorization: string, clientId: string, q?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('getEmailTemplates', 'authorization', authorization)
            // verify required parameter 'clientId' is not null or undefined
            assertParamExists('getEmailTemplates', 'clientId', clientId)
            const localVarPath = `/clients/{clientId}/EmailTemplates`
                .replace(`{${"clientId"}}`, encodeURIComponent(String(clientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2PasswordBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 人材基準一覧を取得する。
         * @summary Get a human resource criteria list
         * @param {string} authorization 認証情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHrCriteriaList: async (authorization: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('getHrCriteriaList', 'authorization', authorization)
            const localVarPath = `/hrCriteria`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 職種一覧を取得する。
         * @summary Get occupation list
         * @param {string} authorization 認証情報
         * @param {boolean} [usedWithinClient] 
         * @param {string} [participantType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOccupations: async (authorization: string, usedWithinClient?: boolean, participantType?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('getOccupations', 'authorization', authorization)
            const localVarPath = `/occupations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (usedWithinClient !== undefined) {
                localVarQueryParameter['usedWithinClient'] = usedWithinClient;
            }

            if (participantType !== undefined) {
                localVarQueryParameter['participantType'] = participantType;
            }

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 料金プラン一覧を取得する。
         * @summary Get price plan list
         * @param {string} authorization 認証情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPricePlans: async (authorization: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('getPricePlans', 'authorization', authorization)
            const localVarPath = `/priceplans`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 対象クライアントのプライバシーポリシーを取得する。
         * @summary Get privacy policy
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {string} [language] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPrivacyPolicy: async (authorization: string, clientId: string, language?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('getPrivacyPolicy', 'authorization', authorization)
            // verify required parameter 'clientId' is not null or undefined
            assertParamExists('getPrivacyPolicy', 'clientId', clientId)
            const localVarPath = `/clients/{clientId}/privacy_policy`
                .replace(`{${"clientId"}}`, encodeURIComponent(String(clientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (language !== undefined) {
                localVarQueryParameter['language'] = language;
            }

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 退職理由一覧を取得する。
         * @summary Get retirement reasons
         * @param {string} authorization 認証情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRetirementReasons: async (authorization: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('getRetirementReasons', 'authorization', authorization)
            const localVarPath = `/retirementReasons`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * サービスプラン一覧を取得する。\"
         * @summary Get service plan list
         * @param {string} authorization 認証情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getServicePlans: async (authorization: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('getServicePlans', 'authorization', authorization)
            const localVarPath = `/serviceplans`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 対象クライアントのタグ一覧を取得する。
         * @summary Get tags
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {string} [type] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTags: async (authorization: string, clientId: string, type?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('getTags', 'authorization', authorization)
            // verify required parameter 'clientId' is not null or undefined
            assertParamExists('getTags', 'clientId', clientId)
            const localVarPath = `/clients/{clientId}/tags`
                .replace(`{${"clientId"}}`, encodeURIComponent(String(clientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Import Excel file(.xlsm) for something
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {ImportItemEnum} item 
         * @param {any} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importExcel: async (authorization: string, clientId: string, item: ImportItemEnum, file: any, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('importExcel', 'authorization', authorization)
            // verify required parameter 'clientId' is not null or undefined
            assertParamExists('importExcel', 'clientId', clientId)
            // verify required parameter 'item' is not null or undefined
            assertParamExists('importExcel', 'item', item)
            // verify required parameter 'file' is not null or undefined
            assertParamExists('importExcel', 'file', file)
            const localVarPath = `/clients/{clientId}/{item}/xlsImport`
                .replace(`{${"clientId"}}`, encodeURIComponent(String(clientId)))
                .replace(`{${"item"}}`, encodeURIComponent(String(item)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 対象クライアントのデータをもとにCSVを出力する。
         * @summary Output CSV file for anything
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {StatsItemEnum} type 
         * @param {Array<string>} [peopleIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        printCsv: async (authorization: string, clientId: string, type: StatsItemEnum, peopleIds?: Array<string>, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('printCsv', 'authorization', authorization)
            // verify required parameter 'clientId' is not null or undefined
            assertParamExists('printCsv', 'clientId', clientId)
            // verify required parameter 'type' is not null or undefined
            assertParamExists('printCsv', 'type', type)
            const localVarPath = `/clients/{clientId}/csv/stats`
                .replace(`{${"clientId"}}`, encodeURIComponent(String(clientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }

            if (peopleIds) {
                localVarQueryParameter['peopleIds'] = peopleIds;
            }

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 対象の従業員に招待メールを再送する。
         * @summary Resend invite mail
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {string} employeeId 従業員ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resendInviteMail: async (authorization: string, clientId: string, employeeId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('resendInviteMail', 'authorization', authorization)
            // verify required parameter 'clientId' is not null or undefined
            assertParamExists('resendInviteMail', 'clientId', clientId)
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('resendInviteMail', 'employeeId', employeeId)
            const localVarPath = `/clients/{clientId}/resendInviteMail/{employeeId}`
                .replace(`{${"clientId"}}`, encodeURIComponent(String(clientId)))
                .replace(`{${"employeeId"}}`, encodeURIComponent(String(employeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 対象クライアントのメールテンプレートを更新する。
         * @summary Update Email Template
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {EmailTemplateTypeEnum} emailTemplateType 
         * @param {string} emailTemplateId 
         * @param {EmailTemplateUpdate} [emailTemplateUpdate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEmailTemplate: async (authorization: string, clientId: string, emailTemplateType: EmailTemplateTypeEnum, emailTemplateId: string, emailTemplateUpdate?: EmailTemplateUpdate, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('updateEmailTemplate', 'authorization', authorization)
            // verify required parameter 'clientId' is not null or undefined
            assertParamExists('updateEmailTemplate', 'clientId', clientId)
            // verify required parameter 'emailTemplateType' is not null or undefined
            assertParamExists('updateEmailTemplate', 'emailTemplateType', emailTemplateType)
            // verify required parameter 'emailTemplateId' is not null or undefined
            assertParamExists('updateEmailTemplate', 'emailTemplateId', emailTemplateId)
            const localVarPath = `/clients/{clientId}/EmailTemplates/{emailTemplateType}/{emailTemplateId}`
                .replace(`{${"clientId"}}`, encodeURIComponent(String(clientId)))
                .replace(`{${"emailTemplateType"}}`, encodeURIComponent(String(emailTemplateType)))
                .replace(`{${"emailTemplateId"}}`, encodeURIComponent(String(emailTemplateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2PasswordBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(emailTemplateUpdate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 対象クライアントのプライバシーポリシーを更新する。
         * @summary Update privacy policy
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {PrivacyPolicyRequest} privacyPolicyRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePrivacyPolicy: async (authorization: string, clientId: string, privacyPolicyRequest: PrivacyPolicyRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('updatePrivacyPolicy', 'authorization', authorization)
            // verify required parameter 'clientId' is not null or undefined
            assertParamExists('updatePrivacyPolicy', 'clientId', clientId)
            // verify required parameter 'privacyPolicyRequest' is not null or undefined
            assertParamExists('updatePrivacyPolicy', 'privacyPolicyRequest', privacyPolicyRequest)
            const localVarPath = `/clients/{clientId}/privacy_policy`
                .replace(`{${"clientId"}}`, encodeURIComponent(String(clientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(privacyPolicyRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 対象クライアントのタグを更新する。
         * @summary Put tags
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {string} tagId タグID
         * @param {UpdateTag} updateTag 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTag: async (authorization: string, clientId: string, tagId: string, updateTag: UpdateTag, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('updateTag', 'authorization', authorization)
            // verify required parameter 'clientId' is not null or undefined
            assertParamExists('updateTag', 'clientId', clientId)
            // verify required parameter 'tagId' is not null or undefined
            assertParamExists('updateTag', 'tagId', tagId)
            // verify required parameter 'updateTag' is not null or undefined
            assertParamExists('updateTag', 'updateTag', updateTag)
            const localVarPath = `/clients/{clientId}/tags/{tagId}`
                .replace(`{${"clientId"}}`, encodeURIComponent(String(clientId)))
                .replace(`{${"tagId"}}`, encodeURIComponent(String(tagId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateTag, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 対象クライアントにエクセルファイルをアップロードする。
         * @summary Upload Excel file(.xlsm) for something
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {UploadItemEnum} item 
         * @param {any} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadExcel: async (authorization: string, clientId: string, item: UploadItemEnum, file: any, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('uploadExcel', 'authorization', authorization)
            // verify required parameter 'clientId' is not null or undefined
            assertParamExists('uploadExcel', 'clientId', clientId)
            // verify required parameter 'item' is not null or undefined
            assertParamExists('uploadExcel', 'item', item)
            // verify required parameter 'file' is not null or undefined
            assertParamExists('uploadExcel', 'file', file)
            const localVarPath = `/clients/{clientId}/{item}/xlsUpload`
                .replace(`{${"clientId"}}`, encodeURIComponent(String(clientId)))
                .replace(`{${"item"}}`, encodeURIComponent(String(item)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SystemApi - functional programming interface
 * @export
 */
export const SystemApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SystemApiAxiosParamCreator(configuration)
    return {
        /**
         * 従業員、応募者の受検結果をCSVでダウンロードする。
         * @summary Output CSV file of assessment survey scores for employees and applicants
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {AsExportTypeEnum} type 
         * @param {string} [departmentId] 
         * @param {ApplicantStatsEnum} [applicantStatus] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async asexport(authorization: string, clientId: string, type: AsExportTypeEnum, departmentId?: string, applicantStatus?: ApplicantStatsEnum, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.asexport(authorization, clientId, type, departmentId, applicantStatus, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 対象クライアントのタグをユーザーに付与する。
         * @summary Attach tags
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {AttachTag} attachTag 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async attachTag(authorization: string, clientId: string, attachTag: AttachTag, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AttachTagResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.attachTag(authorization, clientId, attachTag, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 対象クライアントにメールテンプレートを作成する。
         * @summary Create Email Template
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {EmailTemplateCreate} emailTemplateCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createEmailTemplate(authorization: string, clientId: string, emailTemplateCreate: EmailTemplateCreate, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createEmailTemplate(authorization, clientId, emailTemplateCreate, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 対象クライアントのタグを作成する。
         * @summary Post tags
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {CreateTag} createTag 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createTag(authorization: string, clientId: string, createTag: CreateTag, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createTag(authorization, clientId, createTag, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 対象クライアントにトライアルアカウントを作成する。
         * @summary Create trial coount
         * @param {string} authorization 認証情報
         * @param {CreateTrialAccountRequest} createTrialAccountRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createTrialAccount(authorization: string, createTrialAccountRequest: CreateTrialAccountRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createTrialAccount(authorization, createTrialAccountRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 対象クライアントのメールテンプレートを削除する。
         * @summary Delete Email Template
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {EmailTemplateTypeEnum} emailTemplateType 
         * @param {string} emailTemplateId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteEmailTemplate(authorization: string, clientId: string, emailTemplateType: EmailTemplateTypeEnum, emailTemplateId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteEmailTemplate(authorization, clientId, emailTemplateType, emailTemplateId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 対象クライアントのタグを削除する。
         * @summary Delete tags
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {string} tagId タグID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteTag(authorization: string, clientId: string, tagId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteTag(authorization, clientId, tagId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 対象クライアントのタグをユーザーから除去する。
         * @summary Detach tags
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {string} tagId タグID
         * @param {DetachTag} detachTag 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async detachTag(authorization: string, clientId: string, tagId: string, detachTag: DetachTag, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.detachTag(authorization, clientId, tagId, detachTag, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 対象クライアントにアセスメントサーベイの受検URL一覧を取得する。
         * @summary Output URL CSV
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {string} asBroadcastId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exportAsUrlCsv(authorization: string, clientId: string, asBroadcastId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.exportAsUrlCsv(authorization, clientId, asBroadcastId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 対象クライアントの月次データをもとにCSVを出力する。
         * @summary Output CSV file for monthly billing info
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {string} period 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exportBillintCsv(authorization: string, clientId: string, period: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.exportBillintCsv(authorization, clientId, period, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 対象クライアントのメールテンプレート一覧を取得する。
         * @summary Get Email Templates
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {string} [q] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEmailTemplates(authorization: string, clientId: string, q?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetEmailTemplate>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEmailTemplates(authorization, clientId, q, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 人材基準一覧を取得する。
         * @summary Get a human resource criteria list
         * @param {string} authorization 認証情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getHrCriteriaList(authorization: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetHrCriterionItem>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getHrCriteriaList(authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 職種一覧を取得する。
         * @summary Get occupation list
         * @param {string} authorization 認証情報
         * @param {boolean} [usedWithinClient] 
         * @param {string} [participantType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOccupations(authorization: string, usedWithinClient?: boolean, participantType?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Occupation>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOccupations(authorization, usedWithinClient, participantType, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 料金プラン一覧を取得する。
         * @summary Get price plan list
         * @param {string} authorization 認証情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPricePlans(authorization: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetPricePlan>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPricePlans(authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 対象クライアントのプライバシーポリシーを取得する。
         * @summary Get privacy policy
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {string} [language] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPrivacyPolicy(authorization: string, clientId: string, language?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PrivacyPolicyResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPrivacyPolicy(authorization, clientId, language, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 退職理由一覧を取得する。
         * @summary Get retirement reasons
         * @param {string} authorization 認証情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRetirementReasons(authorization: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CodeName>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRetirementReasons(authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * サービスプラン一覧を取得する。\"
         * @summary Get service plan list
         * @param {string} authorization 認証情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getServicePlans(authorization: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetServicePlan>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getServicePlans(authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 対象クライアントのタグ一覧を取得する。
         * @summary Get tags
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {string} [type] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTags(authorization: string, clientId: string, type?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Tag>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTags(authorization, clientId, type, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Import Excel file(.xlsm) for something
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {ImportItemEnum} item 
         * @param {any} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async importExcel(authorization: string, clientId: string, item: ImportItemEnum, file: any, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.importExcel(authorization, clientId, item, file, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 対象クライアントのデータをもとにCSVを出力する。
         * @summary Output CSV file for anything
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {StatsItemEnum} type 
         * @param {Array<string>} [peopleIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async printCsv(authorization: string, clientId: string, type: StatsItemEnum, peopleIds?: Array<string>, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.printCsv(authorization, clientId, type, peopleIds, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 対象の従業員に招待メールを再送する。
         * @summary Resend invite mail
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {string} employeeId 従業員ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resendInviteMail(authorization: string, clientId: string, employeeId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resendInviteMail(authorization, clientId, employeeId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 対象クライアントのメールテンプレートを更新する。
         * @summary Update Email Template
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {EmailTemplateTypeEnum} emailTemplateType 
         * @param {string} emailTemplateId 
         * @param {EmailTemplateUpdate} [emailTemplateUpdate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateEmailTemplate(authorization: string, clientId: string, emailTemplateType: EmailTemplateTypeEnum, emailTemplateId: string, emailTemplateUpdate?: EmailTemplateUpdate, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateEmailTemplate(authorization, clientId, emailTemplateType, emailTemplateId, emailTemplateUpdate, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 対象クライアントのプライバシーポリシーを更新する。
         * @summary Update privacy policy
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {PrivacyPolicyRequest} privacyPolicyRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePrivacyPolicy(authorization: string, clientId: string, privacyPolicyRequest: PrivacyPolicyRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePrivacyPolicy(authorization, clientId, privacyPolicyRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 対象クライアントのタグを更新する。
         * @summary Put tags
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {string} tagId タグID
         * @param {UpdateTag} updateTag 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateTag(authorization: string, clientId: string, tagId: string, updateTag: UpdateTag, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateTag(authorization, clientId, tagId, updateTag, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 対象クライアントにエクセルファイルをアップロードする。
         * @summary Upload Excel file(.xlsm) for something
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {UploadItemEnum} item 
         * @param {any} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadExcel(authorization: string, clientId: string, item: UploadItemEnum, file: any, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadExcel(authorization, clientId, item, file, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * SystemApi - factory interface
 * @export
 */
export const SystemApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SystemApiFp(configuration)
    return {
        /**
         * 従業員、応募者の受検結果をCSVでダウンロードする。
         * @summary Output CSV file of assessment survey scores for employees and applicants
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {AsExportTypeEnum} type 
         * @param {string} [departmentId] 
         * @param {ApplicantStatsEnum} [applicantStatus] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        asexport(authorization: string, clientId: string, type: AsExportTypeEnum, departmentId?: string, applicantStatus?: ApplicantStatsEnum, options?: any): AxiosPromise<void> {
            return localVarFp.asexport(authorization, clientId, type, departmentId, applicantStatus, options).then((request) => request(axios, basePath));
        },
        /**
         * 対象クライアントのタグをユーザーに付与する。
         * @summary Attach tags
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {AttachTag} attachTag 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        attachTag(authorization: string, clientId: string, attachTag: AttachTag, options?: any): AxiosPromise<AttachTagResponse> {
            return localVarFp.attachTag(authorization, clientId, attachTag, options).then((request) => request(axios, basePath));
        },
        /**
         * 対象クライアントにメールテンプレートを作成する。
         * @summary Create Email Template
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {EmailTemplateCreate} emailTemplateCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEmailTemplate(authorization: string, clientId: string, emailTemplateCreate: EmailTemplateCreate, options?: any): AxiosPromise<void> {
            return localVarFp.createEmailTemplate(authorization, clientId, emailTemplateCreate, options).then((request) => request(axios, basePath));
        },
        /**
         * 対象クライアントのタグを作成する。
         * @summary Post tags
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {CreateTag} createTag 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTag(authorization: string, clientId: string, createTag: CreateTag, options?: any): AxiosPromise<object> {
            return localVarFp.createTag(authorization, clientId, createTag, options).then((request) => request(axios, basePath));
        },
        /**
         * 対象クライアントにトライアルアカウントを作成する。
         * @summary Create trial coount
         * @param {string} authorization 認証情報
         * @param {CreateTrialAccountRequest} createTrialAccountRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTrialAccount(authorization: string, createTrialAccountRequest: CreateTrialAccountRequest, options?: any): AxiosPromise<void> {
            return localVarFp.createTrialAccount(authorization, createTrialAccountRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 対象クライアントのメールテンプレートを削除する。
         * @summary Delete Email Template
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {EmailTemplateTypeEnum} emailTemplateType 
         * @param {string} emailTemplateId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEmailTemplate(authorization: string, clientId: string, emailTemplateType: EmailTemplateTypeEnum, emailTemplateId: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteEmailTemplate(authorization, clientId, emailTemplateType, emailTemplateId, options).then((request) => request(axios, basePath));
        },
        /**
         * 対象クライアントのタグを削除する。
         * @summary Delete tags
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {string} tagId タグID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTag(authorization: string, clientId: string, tagId: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteTag(authorization, clientId, tagId, options).then((request) => request(axios, basePath));
        },
        /**
         * 対象クライアントのタグをユーザーから除去する。
         * @summary Detach tags
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {string} tagId タグID
         * @param {DetachTag} detachTag 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        detachTag(authorization: string, clientId: string, tagId: string, detachTag: DetachTag, options?: any): AxiosPromise<void> {
            return localVarFp.detachTag(authorization, clientId, tagId, detachTag, options).then((request) => request(axios, basePath));
        },
        /**
         * 対象クライアントにアセスメントサーベイの受検URL一覧を取得する。
         * @summary Output URL CSV
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {string} asBroadcastId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportAsUrlCsv(authorization: string, clientId: string, asBroadcastId: string, options?: any): AxiosPromise<void> {
            return localVarFp.exportAsUrlCsv(authorization, clientId, asBroadcastId, options).then((request) => request(axios, basePath));
        },
        /**
         * 対象クライアントの月次データをもとにCSVを出力する。
         * @summary Output CSV file for monthly billing info
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {string} period 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportBillintCsv(authorization: string, clientId: string, period: string, options?: any): AxiosPromise<void> {
            return localVarFp.exportBillintCsv(authorization, clientId, period, options).then((request) => request(axios, basePath));
        },
        /**
         * 対象クライアントのメールテンプレート一覧を取得する。
         * @summary Get Email Templates
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {string} [q] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmailTemplates(authorization: string, clientId: string, q?: string, options?: any): AxiosPromise<Array<GetEmailTemplate>> {
            return localVarFp.getEmailTemplates(authorization, clientId, q, options).then((request) => request(axios, basePath));
        },
        /**
         * 人材基準一覧を取得する。
         * @summary Get a human resource criteria list
         * @param {string} authorization 認証情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHrCriteriaList(authorization: string, options?: any): AxiosPromise<Array<GetHrCriterionItem>> {
            return localVarFp.getHrCriteriaList(authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 職種一覧を取得する。
         * @summary Get occupation list
         * @param {string} authorization 認証情報
         * @param {boolean} [usedWithinClient] 
         * @param {string} [participantType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOccupations(authorization: string, usedWithinClient?: boolean, participantType?: string, options?: any): AxiosPromise<Array<Occupation>> {
            return localVarFp.getOccupations(authorization, usedWithinClient, participantType, options).then((request) => request(axios, basePath));
        },
        /**
         * 料金プラン一覧を取得する。
         * @summary Get price plan list
         * @param {string} authorization 認証情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPricePlans(authorization: string, options?: any): AxiosPromise<Array<GetPricePlan>> {
            return localVarFp.getPricePlans(authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 対象クライアントのプライバシーポリシーを取得する。
         * @summary Get privacy policy
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {string} [language] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPrivacyPolicy(authorization: string, clientId: string, language?: string, options?: any): AxiosPromise<PrivacyPolicyResponse> {
            return localVarFp.getPrivacyPolicy(authorization, clientId, language, options).then((request) => request(axios, basePath));
        },
        /**
         * 退職理由一覧を取得する。
         * @summary Get retirement reasons
         * @param {string} authorization 認証情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRetirementReasons(authorization: string, options?: any): AxiosPromise<Array<CodeName>> {
            return localVarFp.getRetirementReasons(authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * サービスプラン一覧を取得する。\"
         * @summary Get service plan list
         * @param {string} authorization 認証情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getServicePlans(authorization: string, options?: any): AxiosPromise<Array<GetServicePlan>> {
            return localVarFp.getServicePlans(authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 対象クライアントのタグ一覧を取得する。
         * @summary Get tags
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {string} [type] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTags(authorization: string, clientId: string, type?: string, options?: any): AxiosPromise<Array<Tag>> {
            return localVarFp.getTags(authorization, clientId, type, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Import Excel file(.xlsm) for something
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {ImportItemEnum} item 
         * @param {any} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importExcel(authorization: string, clientId: string, item: ImportItemEnum, file: any, options?: any): AxiosPromise<void> {
            return localVarFp.importExcel(authorization, clientId, item, file, options).then((request) => request(axios, basePath));
        },
        /**
         * 対象クライアントのデータをもとにCSVを出力する。
         * @summary Output CSV file for anything
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {StatsItemEnum} type 
         * @param {Array<string>} [peopleIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        printCsv(authorization: string, clientId: string, type: StatsItemEnum, peopleIds?: Array<string>, options?: any): AxiosPromise<void> {
            return localVarFp.printCsv(authorization, clientId, type, peopleIds, options).then((request) => request(axios, basePath));
        },
        /**
         * 対象の従業員に招待メールを再送する。
         * @summary Resend invite mail
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {string} employeeId 従業員ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resendInviteMail(authorization: string, clientId: string, employeeId: string, options?: any): AxiosPromise<void> {
            return localVarFp.resendInviteMail(authorization, clientId, employeeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 対象クライアントのメールテンプレートを更新する。
         * @summary Update Email Template
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {EmailTemplateTypeEnum} emailTemplateType 
         * @param {string} emailTemplateId 
         * @param {EmailTemplateUpdate} [emailTemplateUpdate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEmailTemplate(authorization: string, clientId: string, emailTemplateType: EmailTemplateTypeEnum, emailTemplateId: string, emailTemplateUpdate?: EmailTemplateUpdate, options?: any): AxiosPromise<void> {
            return localVarFp.updateEmailTemplate(authorization, clientId, emailTemplateType, emailTemplateId, emailTemplateUpdate, options).then((request) => request(axios, basePath));
        },
        /**
         * 対象クライアントのプライバシーポリシーを更新する。
         * @summary Update privacy policy
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {PrivacyPolicyRequest} privacyPolicyRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePrivacyPolicy(authorization: string, clientId: string, privacyPolicyRequest: PrivacyPolicyRequest, options?: any): AxiosPromise<void> {
            return localVarFp.updatePrivacyPolicy(authorization, clientId, privacyPolicyRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 対象クライアントのタグを更新する。
         * @summary Put tags
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {string} tagId タグID
         * @param {UpdateTag} updateTag 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTag(authorization: string, clientId: string, tagId: string, updateTag: UpdateTag, options?: any): AxiosPromise<void> {
            return localVarFp.updateTag(authorization, clientId, tagId, updateTag, options).then((request) => request(axios, basePath));
        },
        /**
         * 対象クライアントにエクセルファイルをアップロードする。
         * @summary Upload Excel file(.xlsm) for something
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {UploadItemEnum} item 
         * @param {any} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadExcel(authorization: string, clientId: string, item: UploadItemEnum, file: any, options?: any): AxiosPromise<void> {
            return localVarFp.uploadExcel(authorization, clientId, item, file, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SystemApi - object-oriented interface
 * @export
 * @class SystemApi
 * @extends {BaseAPI}
 */
export class SystemApi extends BaseAPI {
    /**
     * 従業員、応募者の受検結果をCSVでダウンロードする。
     * @summary Output CSV file of assessment survey scores for employees and applicants
     * @param {string} authorization 認証情報
     * @param {string} clientId クライアントID
     * @param {AsExportTypeEnum} type 
     * @param {string} [departmentId] 
     * @param {ApplicantStatsEnum} [applicantStatus] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SystemApi
     */
    public asexport(params: { authorization?: string, clientId?: string, type: AsExportTypeEnum, departmentId?: string, applicantStatus?: ApplicantStatsEnum,  }, options?: any) {
				const _params = {} as any;
				_params['authorization'] = params['authorization']
				_params['clientId'] = params['clientId']
				_params['type'] = params['type']
				_params['departmentId'] = params['departmentId']
				_params['applicantStatus'] = params['applicantStatus']
				// @ts-ignore
				_params.authorization = 'Bearer ' + ( params.authorization || Store.getInstance().getAccessToken())!
				_params.clientId = ((params as any).clientId || (Store.getInstance().getAuth() || {}).clientId)!;
        return SystemApiFp(this.configuration).asexport(_params.authorization, _params.clientId, _params.type, _params.departmentId, _params.applicantStatus, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 対象クライアントのタグをユーザーに付与する。
     * @summary Attach tags
     * @param {string} authorization 認証情報
     * @param {string} clientId クライアントID
     * @param {AttachTag} attachTag 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SystemApi
     */
    public attachTag(params: { authorization?: string, clientId?: string, attachTag: AttachTag,  }, options?: any) {
				const _params = {} as any;
				_params['authorization'] = params['authorization']
				_params['clientId'] = params['clientId']
				_params['attachTag'] = params['attachTag']
				// @ts-ignore
				_params.authorization = 'Bearer ' + ( params.authorization || Store.getInstance().getAccessToken())!
				_params.clientId = ((params as any).clientId || (Store.getInstance().getAuth() || {}).clientId)!;
        return SystemApiFp(this.configuration).attachTag(_params.authorization, _params.clientId, _params.attachTag, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 対象クライアントにメールテンプレートを作成する。
     * @summary Create Email Template
     * @param {string} authorization 認証情報
     * @param {string} clientId クライアントID
     * @param {EmailTemplateCreate} emailTemplateCreate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SystemApi
     */
    public createEmailTemplate(params: { authorization?: string, clientId?: string, emailTemplateCreate: EmailTemplateCreate,  }, options?: any) {
				const _params = {} as any;
				_params['authorization'] = params['authorization']
				_params['clientId'] = params['clientId']
				_params['emailTemplateCreate'] = params['emailTemplateCreate']
				// @ts-ignore
				_params.authorization = 'Bearer ' + ( params.authorization || Store.getInstance().getAccessToken())!
				_params.clientId = ((params as any).clientId || (Store.getInstance().getAuth() || {}).clientId)!;
        return SystemApiFp(this.configuration).createEmailTemplate(_params.authorization, _params.clientId, _params.emailTemplateCreate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 対象クライアントのタグを作成する。
     * @summary Post tags
     * @param {string} authorization 認証情報
     * @param {string} clientId クライアントID
     * @param {CreateTag} createTag 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SystemApi
     */
    public createTag(params: { authorization?: string, clientId?: string, createTag: CreateTag,  }, options?: any) {
				const _params = {} as any;
				_params['authorization'] = params['authorization']
				_params['clientId'] = params['clientId']
				_params['createTag'] = params['createTag']
				// @ts-ignore
				_params.authorization = 'Bearer ' + ( params.authorization || Store.getInstance().getAccessToken())!
				_params.clientId = ((params as any).clientId || (Store.getInstance().getAuth() || {}).clientId)!;
        return SystemApiFp(this.configuration).createTag(_params.authorization, _params.clientId, _params.createTag, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 対象クライアントにトライアルアカウントを作成する。
     * @summary Create trial coount
     * @param {string} authorization 認証情報
     * @param {CreateTrialAccountRequest} createTrialAccountRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SystemApi
     */
    public createTrialAccount(params: { authorization?: string, createTrialAccountRequest: CreateTrialAccountRequest,  }, options?: any) {
				const _params = {} as any;
				_params['authorization'] = params['authorization']
				_params['createTrialAccountRequest'] = params['createTrialAccountRequest']
				// @ts-ignore
				_params.authorization = 'Bearer ' + ( params.authorization || Store.getInstance().getAccessToken())!
				_params.clientId = ((params as any).clientId || (Store.getInstance().getAuth() || {}).clientId)!;
        return SystemApiFp(this.configuration).createTrialAccount(_params.authorization, _params.createTrialAccountRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 対象クライアントのメールテンプレートを削除する。
     * @summary Delete Email Template
     * @param {string} authorization 認証情報
     * @param {string} clientId クライアントID
     * @param {EmailTemplateTypeEnum} emailTemplateType 
     * @param {string} emailTemplateId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SystemApi
     */
    public deleteEmailTemplate(params: { authorization?: string, clientId?: string, emailTemplateType: EmailTemplateTypeEnum, emailTemplateId: string,  }, options?: any) {
				const _params = {} as any;
				_params['authorization'] = params['authorization']
				_params['clientId'] = params['clientId']
				_params['emailTemplateType'] = params['emailTemplateType']
				_params['emailTemplateId'] = params['emailTemplateId']
				// @ts-ignore
				_params.authorization = 'Bearer ' + ( params.authorization || Store.getInstance().getAccessToken())!
				_params.clientId = ((params as any).clientId || (Store.getInstance().getAuth() || {}).clientId)!;
        return SystemApiFp(this.configuration).deleteEmailTemplate(_params.authorization, _params.clientId, _params.emailTemplateType, _params.emailTemplateId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 対象クライアントのタグを削除する。
     * @summary Delete tags
     * @param {string} authorization 認証情報
     * @param {string} clientId クライアントID
     * @param {string} tagId タグID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SystemApi
     */
    public deleteTag(params: { authorization?: string, clientId?: string, tagId: string,  }, options?: any) {
				const _params = {} as any;
				_params['authorization'] = params['authorization']
				_params['clientId'] = params['clientId']
				_params['tagId'] = params['tagId']
				// @ts-ignore
				_params.authorization = 'Bearer ' + ( params.authorization || Store.getInstance().getAccessToken())!
				_params.clientId = ((params as any).clientId || (Store.getInstance().getAuth() || {}).clientId)!;
        return SystemApiFp(this.configuration).deleteTag(_params.authorization, _params.clientId, _params.tagId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 対象クライアントのタグをユーザーから除去する。
     * @summary Detach tags
     * @param {string} authorization 認証情報
     * @param {string} clientId クライアントID
     * @param {string} tagId タグID
     * @param {DetachTag} detachTag 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SystemApi
     */
    public detachTag(params: { authorization?: string, clientId?: string, tagId: string, detachTag: DetachTag,  }, options?: any) {
				const _params = {} as any;
				_params['authorization'] = params['authorization']
				_params['clientId'] = params['clientId']
				_params['tagId'] = params['tagId']
				_params['detachTag'] = params['detachTag']
				// @ts-ignore
				_params.authorization = 'Bearer ' + ( params.authorization || Store.getInstance().getAccessToken())!
				_params.clientId = ((params as any).clientId || (Store.getInstance().getAuth() || {}).clientId)!;
        return SystemApiFp(this.configuration).detachTag(_params.authorization, _params.clientId, _params.tagId, _params.detachTag, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 対象クライアントにアセスメントサーベイの受検URL一覧を取得する。
     * @summary Output URL CSV
     * @param {string} authorization 認証情報
     * @param {string} clientId クライアントID
     * @param {string} asBroadcastId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SystemApi
     */
    public exportAsUrlCsv(params: { authorization?: string, clientId?: string, asBroadcastId: string,  }, options?: any) {
				const _params = {} as any;
				_params['authorization'] = params['authorization']
				_params['clientId'] = params['clientId']
				_params['asBroadcastId'] = params['asBroadcastId']
				// @ts-ignore
				_params.authorization = 'Bearer ' + ( params.authorization || Store.getInstance().getAccessToken())!
				_params.clientId = ((params as any).clientId || (Store.getInstance().getAuth() || {}).clientId)!;
        return SystemApiFp(this.configuration).exportAsUrlCsv(_params.authorization, _params.clientId, _params.asBroadcastId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 対象クライアントの月次データをもとにCSVを出力する。
     * @summary Output CSV file for monthly billing info
     * @param {string} authorization 認証情報
     * @param {string} clientId クライアントID
     * @param {string} period 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SystemApi
     */
    public exportBillintCsv(params: { authorization?: string, clientId?: string, period: string,  }, options?: any) {
				const _params = {} as any;
				_params['authorization'] = params['authorization']
				_params['clientId'] = params['clientId']
				_params['period'] = params['period']
				// @ts-ignore
				_params.authorization = 'Bearer ' + ( params.authorization || Store.getInstance().getAccessToken())!
				_params.clientId = ((params as any).clientId || (Store.getInstance().getAuth() || {}).clientId)!;
        return SystemApiFp(this.configuration).exportBillintCsv(_params.authorization, _params.clientId, _params.period, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 対象クライアントのメールテンプレート一覧を取得する。
     * @summary Get Email Templates
     * @param {string} authorization 認証情報
     * @param {string} clientId クライアントID
     * @param {string} [q] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SystemApi
     */
    public getEmailTemplates(params: { authorization?: string, clientId?: string, q?: string,  }, options?: any) {
				const _params = {} as any;
				_params['authorization'] = params['authorization']
				_params['clientId'] = params['clientId']
				_params['q'] = params['q']
				// @ts-ignore
				_params.authorization = 'Bearer ' + ( params.authorization || Store.getInstance().getAccessToken())!
				_params.clientId = ((params as any).clientId || (Store.getInstance().getAuth() || {}).clientId)!;
        return SystemApiFp(this.configuration).getEmailTemplates(_params.authorization, _params.clientId, _params.q, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 人材基準一覧を取得する。
     * @summary Get a human resource criteria list
     * @param {string} authorization 認証情報
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SystemApi
     */
    public getHrCriteriaList(params: { authorization?: string,  }, options?: any) {
				const _params = {} as any;
				_params['authorization'] = params['authorization']
				// @ts-ignore
				_params.authorization = 'Bearer ' + ( params.authorization || Store.getInstance().getAccessToken())!
				_params.clientId = ((params as any).clientId || (Store.getInstance().getAuth() || {}).clientId)!;
        return SystemApiFp(this.configuration).getHrCriteriaList(_params.authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 職種一覧を取得する。
     * @summary Get occupation list
     * @param {string} authorization 認証情報
     * @param {boolean} [usedWithinClient] 
     * @param {string} [participantType] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SystemApi
     */
    public getOccupations(params: { authorization?: string, usedWithinClient?: boolean, participantType?: string,  }, options?: any) {
				const _params = {} as any;
				_params['authorization'] = params['authorization']
				_params['usedWithinClient'] = params['usedWithinClient']
				_params['participantType'] = params['participantType']
				// @ts-ignore
				_params.authorization = 'Bearer ' + ( params.authorization || Store.getInstance().getAccessToken())!
				_params.clientId = ((params as any).clientId || (Store.getInstance().getAuth() || {}).clientId)!;
        return SystemApiFp(this.configuration).getOccupations(_params.authorization, _params.usedWithinClient, _params.participantType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 料金プラン一覧を取得する。
     * @summary Get price plan list
     * @param {string} authorization 認証情報
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SystemApi
     */
    public getPricePlans(params: { authorization?: string,  }, options?: any) {
				const _params = {} as any;
				_params['authorization'] = params['authorization']
				// @ts-ignore
				_params.authorization = 'Bearer ' + ( params.authorization || Store.getInstance().getAccessToken())!
				_params.clientId = ((params as any).clientId || (Store.getInstance().getAuth() || {}).clientId)!;
        return SystemApiFp(this.configuration).getPricePlans(_params.authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 対象クライアントのプライバシーポリシーを取得する。
     * @summary Get privacy policy
     * @param {string} authorization 認証情報
     * @param {string} clientId クライアントID
     * @param {string} [language] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SystemApi
     */
    public getPrivacyPolicy(params: { authorization?: string, clientId?: string, language?: string,  }, options?: any) {
				const _params = {} as any;
				_params['authorization'] = params['authorization']
				_params['clientId'] = params['clientId']
				_params['language'] = params['language']
				// @ts-ignore
				_params.authorization = 'Bearer ' + ( params.authorization || Store.getInstance().getAccessToken())!
				_params.clientId = ((params as any).clientId || (Store.getInstance().getAuth() || {}).clientId)!;
        return SystemApiFp(this.configuration).getPrivacyPolicy(_params.authorization, _params.clientId, _params.language, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 退職理由一覧を取得する。
     * @summary Get retirement reasons
     * @param {string} authorization 認証情報
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SystemApi
     */
    public getRetirementReasons(params: { authorization?: string,  }, options?: any) {
				const _params = {} as any;
				_params['authorization'] = params['authorization']
				// @ts-ignore
				_params.authorization = 'Bearer ' + ( params.authorization || Store.getInstance().getAccessToken())!
				_params.clientId = ((params as any).clientId || (Store.getInstance().getAuth() || {}).clientId)!;
        return SystemApiFp(this.configuration).getRetirementReasons(_params.authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * サービスプラン一覧を取得する。\"
     * @summary Get service plan list
     * @param {string} authorization 認証情報
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SystemApi
     */
    public getServicePlans(params: { authorization?: string,  }, options?: any) {
				const _params = {} as any;
				_params['authorization'] = params['authorization']
				// @ts-ignore
				_params.authorization = 'Bearer ' + ( params.authorization || Store.getInstance().getAccessToken())!
				_params.clientId = ((params as any).clientId || (Store.getInstance().getAuth() || {}).clientId)!;
        return SystemApiFp(this.configuration).getServicePlans(_params.authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 対象クライアントのタグ一覧を取得する。
     * @summary Get tags
     * @param {string} authorization 認証情報
     * @param {string} clientId クライアントID
     * @param {string} [type] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SystemApi
     */
    public getTags(params: { authorization?: string, clientId?: string, type?: string,  }, options?: any) {
				const _params = {} as any;
				_params['authorization'] = params['authorization']
				_params['clientId'] = params['clientId']
				_params['type'] = params['type']
				// @ts-ignore
				_params.authorization = 'Bearer ' + ( params.authorization || Store.getInstance().getAccessToken())!
				_params.clientId = ((params as any).clientId || (Store.getInstance().getAuth() || {}).clientId)!;
        return SystemApiFp(this.configuration).getTags(_params.authorization, _params.clientId, _params.type, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Import Excel file(.xlsm) for something
     * @param {string} authorization 認証情報
     * @param {string} clientId クライアントID
     * @param {ImportItemEnum} item 
     * @param {any} file 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SystemApi
     */
    public importExcel(params: { authorization?: string, clientId?: string, item: ImportItemEnum, file: any,  }, options?: any) {
				const _params = {} as any;
				_params['authorization'] = params['authorization']
				_params['clientId'] = params['clientId']
				_params['item'] = params['item']
				_params['file'] = params['file']
				// @ts-ignore
				_params.authorization = 'Bearer ' + ( params.authorization || Store.getInstance().getAccessToken())!
				_params.clientId = ((params as any).clientId || (Store.getInstance().getAuth() || {}).clientId)!;
        return SystemApiFp(this.configuration).importExcel(_params.authorization, _params.clientId, _params.item, _params.file, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 対象クライアントのデータをもとにCSVを出力する。
     * @summary Output CSV file for anything
     * @param {string} authorization 認証情報
     * @param {string} clientId クライアントID
     * @param {StatsItemEnum} type 
     * @param {Array<string>} [peopleIds] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SystemApi
     */
    public printCsv(params: { authorization?: string, clientId?: string, type: StatsItemEnum, peopleIds?: Array<string>,  }, options?: any) {
				const _params = {} as any;
				_params['authorization'] = params['authorization']
				_params['clientId'] = params['clientId']
				_params['type'] = params['type']
				_params['peopleIds'] = params['peopleIds']
				// @ts-ignore
				_params.authorization = 'Bearer ' + ( params.authorization || Store.getInstance().getAccessToken())!
				_params.clientId = ((params as any).clientId || (Store.getInstance().getAuth() || {}).clientId)!;
        return SystemApiFp(this.configuration).printCsv(_params.authorization, _params.clientId, _params.type, _params.peopleIds, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 対象の従業員に招待メールを再送する。
     * @summary Resend invite mail
     * @param {string} authorization 認証情報
     * @param {string} clientId クライアントID
     * @param {string} employeeId 従業員ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SystemApi
     */
    public resendInviteMail(params: { authorization?: string, clientId?: string, employeeId: string,  }, options?: any) {
				const _params = {} as any;
				_params['authorization'] = params['authorization']
				_params['clientId'] = params['clientId']
				_params['employeeId'] = params['employeeId']
				// @ts-ignore
				_params.authorization = 'Bearer ' + ( params.authorization || Store.getInstance().getAccessToken())!
				_params.clientId = ((params as any).clientId || (Store.getInstance().getAuth() || {}).clientId)!;
        return SystemApiFp(this.configuration).resendInviteMail(_params.authorization, _params.clientId, _params.employeeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 対象クライアントのメールテンプレートを更新する。
     * @summary Update Email Template
     * @param {string} authorization 認証情報
     * @param {string} clientId クライアントID
     * @param {EmailTemplateTypeEnum} emailTemplateType 
     * @param {string} emailTemplateId 
     * @param {EmailTemplateUpdate} [emailTemplateUpdate] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SystemApi
     */
    public updateEmailTemplate(params: { authorization?: string, clientId?: string, emailTemplateType: EmailTemplateTypeEnum, emailTemplateId: string, emailTemplateUpdate?: EmailTemplateUpdate,  }, options?: any) {
				const _params = {} as any;
				_params['authorization'] = params['authorization']
				_params['clientId'] = params['clientId']
				_params['emailTemplateType'] = params['emailTemplateType']
				_params['emailTemplateId'] = params['emailTemplateId']
				_params['emailTemplateUpdate'] = params['emailTemplateUpdate']
				// @ts-ignore
				_params.authorization = 'Bearer ' + ( params.authorization || Store.getInstance().getAccessToken())!
				_params.clientId = ((params as any).clientId || (Store.getInstance().getAuth() || {}).clientId)!;
        return SystemApiFp(this.configuration).updateEmailTemplate(_params.authorization, _params.clientId, _params.emailTemplateType, _params.emailTemplateId, _params.emailTemplateUpdate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 対象クライアントのプライバシーポリシーを更新する。
     * @summary Update privacy policy
     * @param {string} authorization 認証情報
     * @param {string} clientId クライアントID
     * @param {PrivacyPolicyRequest} privacyPolicyRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SystemApi
     */
    public updatePrivacyPolicy(params: { authorization?: string, clientId?: string, privacyPolicyRequest: PrivacyPolicyRequest,  }, options?: any) {
				const _params = {} as any;
				_params['authorization'] = params['authorization']
				_params['clientId'] = params['clientId']
				_params['privacyPolicyRequest'] = params['privacyPolicyRequest']
				// @ts-ignore
				_params.authorization = 'Bearer ' + ( params.authorization || Store.getInstance().getAccessToken())!
				_params.clientId = ((params as any).clientId || (Store.getInstance().getAuth() || {}).clientId)!;
        return SystemApiFp(this.configuration).updatePrivacyPolicy(_params.authorization, _params.clientId, _params.privacyPolicyRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 対象クライアントのタグを更新する。
     * @summary Put tags
     * @param {string} authorization 認証情報
     * @param {string} clientId クライアントID
     * @param {string} tagId タグID
     * @param {UpdateTag} updateTag 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SystemApi
     */
    public updateTag(params: { authorization?: string, clientId?: string, tagId: string, updateTag: UpdateTag,  }, options?: any) {
				const _params = {} as any;
				_params['authorization'] = params['authorization']
				_params['clientId'] = params['clientId']
				_params['tagId'] = params['tagId']
				_params['updateTag'] = params['updateTag']
				// @ts-ignore
				_params.authorization = 'Bearer ' + ( params.authorization || Store.getInstance().getAccessToken())!
				_params.clientId = ((params as any).clientId || (Store.getInstance().getAuth() || {}).clientId)!;
        return SystemApiFp(this.configuration).updateTag(_params.authorization, _params.clientId, _params.tagId, _params.updateTag, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 対象クライアントにエクセルファイルをアップロードする。
     * @summary Upload Excel file(.xlsm) for something
     * @param {string} authorization 認証情報
     * @param {string} clientId クライアントID
     * @param {UploadItemEnum} item 
     * @param {any} file 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SystemApi
     */
    public uploadExcel(params: { authorization?: string, clientId?: string, item: UploadItemEnum, file: any,  }, options?: any) {
				const _params = {} as any;
				_params['authorization'] = params['authorization']
				_params['clientId'] = params['clientId']
				_params['item'] = params['item']
				_params['file'] = params['file']
				// @ts-ignore
				_params.authorization = 'Bearer ' + ( params.authorization || Store.getInstance().getAccessToken())!
				_params.clientId = ((params as any).clientId || (Store.getInstance().getAuth() || {}).clientId)!;
        return SystemApiFp(this.configuration).uploadExcel(_params.authorization, _params.clientId, _params.item, _params.file, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * UserApi - axios parameter creator
 * @export
 */
export const UserApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 対象クライアントのシステム管理者ユーザーを作成する。
         * @summary Create a user
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {CreateUserRequest} createUserRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUser: async (authorization: string, clientId: string, createUserRequest: CreateUserRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('createUser', 'authorization', authorization)
            // verify required parameter 'clientId' is not null or undefined
            assertParamExists('createUser', 'clientId', clientId)
            // verify required parameter 'createUserRequest' is not null or undefined
            assertParamExists('createUser', 'createUserRequest', createUserRequest)
            const localVarPath = `/clients/{clientId}/users`
                .replace(`{${"clientId"}}`, encodeURIComponent(String(clientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createUserRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 対象クライアントのシステム管理者ユーザーを削除する。
         * @summary Delete a user
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {string} userId ユーザーID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUser: async (authorization: string, clientId: string, userId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('deleteUser', 'authorization', authorization)
            // verify required parameter 'clientId' is not null or undefined
            assertParamExists('deleteUser', 'clientId', clientId)
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('deleteUser', 'userId', userId)
            const localVarPath = `/clients/{clientId}/users/{userId}`
                .replace(`{${"clientId"}}`, encodeURIComponent(String(clientId)))
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 対象クライアントのシステム管理者ユーザーを取得する。
         * @summary Get a user
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {string} userId ユーザーID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUser: async (authorization: string, clientId: string, userId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('getUser', 'authorization', authorization)
            // verify required parameter 'clientId' is not null or undefined
            assertParamExists('getUser', 'clientId', clientId)
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getUser', 'userId', userId)
            const localVarPath = `/clients/{clientId}/users/{userId}`
                .replace(`{${"clientId"}}`, encodeURIComponent(String(clientId)))
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 対象クライアントのシステム管理者ユーザー一覧を取得する。
         * @summary Get user list
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {string} [q] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsers: async (authorization: string, clientId: string, q?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('getUsers', 'authorization', authorization)
            // verify required parameter 'clientId' is not null or undefined
            assertParamExists('getUsers', 'clientId', clientId)
            const localVarPath = `/clients/{clientId}/users`
                .replace(`{${"clientId"}}`, encodeURIComponent(String(clientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 対象クライアントのシステム管理者ユーザーを更新する。
         * @summary Update a user
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {string} userId ユーザーID
         * @param {UpdateUserRequest} updateUserRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUser: async (authorization: string, clientId: string, userId: string, updateUserRequest: UpdateUserRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('updateUser', 'authorization', authorization)
            // verify required parameter 'clientId' is not null or undefined
            assertParamExists('updateUser', 'clientId', clientId)
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('updateUser', 'userId', userId)
            // verify required parameter 'updateUserRequest' is not null or undefined
            assertParamExists('updateUser', 'updateUserRequest', updateUserRequest)
            const localVarPath = `/clients/{clientId}/users/{userId}`
                .replace(`{${"clientId"}}`, encodeURIComponent(String(clientId)))
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateUserRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UserApi - functional programming interface
 * @export
 */
export const UserApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UserApiAxiosParamCreator(configuration)
    return {
        /**
         * 対象クライアントのシステム管理者ユーザーを作成する。
         * @summary Create a user
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {CreateUserRequest} createUserRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createUser(authorization: string, clientId: string, createUserRequest: CreateUserRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<User>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createUser(authorization, clientId, createUserRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 対象クライアントのシステム管理者ユーザーを削除する。
         * @summary Delete a user
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {string} userId ユーザーID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteUser(authorization: string, clientId: string, userId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteUser(authorization, clientId, userId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 対象クライアントのシステム管理者ユーザーを取得する。
         * @summary Get a user
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {string} userId ユーザーID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUser(authorization: string, clientId: string, userId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<User>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUser(authorization, clientId, userId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 対象クライアントのシステム管理者ユーザー一覧を取得する。
         * @summary Get user list
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {string} [q] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUsers(authorization: string, clientId: string, q?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<User>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUsers(authorization, clientId, q, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 対象クライアントのシステム管理者ユーザーを更新する。
         * @summary Update a user
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {string} userId ユーザーID
         * @param {UpdateUserRequest} updateUserRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateUser(authorization: string, clientId: string, userId: string, updateUserRequest: UpdateUserRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateUser(authorization, clientId, userId, updateUserRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * UserApi - factory interface
 * @export
 */
export const UserApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UserApiFp(configuration)
    return {
        /**
         * 対象クライアントのシステム管理者ユーザーを作成する。
         * @summary Create a user
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {CreateUserRequest} createUserRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUser(authorization: string, clientId: string, createUserRequest: CreateUserRequest, options?: any): AxiosPromise<User> {
            return localVarFp.createUser(authorization, clientId, createUserRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 対象クライアントのシステム管理者ユーザーを削除する。
         * @summary Delete a user
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {string} userId ユーザーID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUser(authorization: string, clientId: string, userId: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteUser(authorization, clientId, userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 対象クライアントのシステム管理者ユーザーを取得する。
         * @summary Get a user
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {string} userId ユーザーID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUser(authorization: string, clientId: string, userId: string, options?: any): AxiosPromise<User> {
            return localVarFp.getUser(authorization, clientId, userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 対象クライアントのシステム管理者ユーザー一覧を取得する。
         * @summary Get user list
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {string} [q] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsers(authorization: string, clientId: string, q?: string, options?: any): AxiosPromise<Array<User>> {
            return localVarFp.getUsers(authorization, clientId, q, options).then((request) => request(axios, basePath));
        },
        /**
         * 対象クライアントのシステム管理者ユーザーを更新する。
         * @summary Update a user
         * @param {string} authorization 認証情報
         * @param {string} clientId クライアントID
         * @param {string} userId ユーザーID
         * @param {UpdateUserRequest} updateUserRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUser(authorization: string, clientId: string, userId: string, updateUserRequest: UpdateUserRequest, options?: any): AxiosPromise<void> {
            return localVarFp.updateUser(authorization, clientId, userId, updateUserRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UserApi - object-oriented interface
 * @export
 * @class UserApi
 * @extends {BaseAPI}
 */
export class UserApi extends BaseAPI {
    /**
     * 対象クライアントのシステム管理者ユーザーを作成する。
     * @summary Create a user
     * @param {string} authorization 認証情報
     * @param {string} clientId クライアントID
     * @param {CreateUserRequest} createUserRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public createUser(params: { authorization?: string, clientId?: string, createUserRequest: CreateUserRequest,  }, options?: any) {
				const _params = {} as any;
				_params['authorization'] = params['authorization']
				_params['clientId'] = params['clientId']
				_params['createUserRequest'] = params['createUserRequest']
				// @ts-ignore
				_params.authorization = 'Bearer ' + ( params.authorization || Store.getInstance().getAccessToken())!
				_params.clientId = ((params as any).clientId || (Store.getInstance().getAuth() || {}).clientId)!;
        return UserApiFp(this.configuration).createUser(_params.authorization, _params.clientId, _params.createUserRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 対象クライアントのシステム管理者ユーザーを削除する。
     * @summary Delete a user
     * @param {string} authorization 認証情報
     * @param {string} clientId クライアントID
     * @param {string} userId ユーザーID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public deleteUser(params: { authorization?: string, clientId?: string, userId: string,  }, options?: any) {
				const _params = {} as any;
				_params['authorization'] = params['authorization']
				_params['clientId'] = params['clientId']
				_params['userId'] = params['userId']
				// @ts-ignore
				_params.authorization = 'Bearer ' + ( params.authorization || Store.getInstance().getAccessToken())!
				_params.clientId = ((params as any).clientId || (Store.getInstance().getAuth() || {}).clientId)!;
        return UserApiFp(this.configuration).deleteUser(_params.authorization, _params.clientId, _params.userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 対象クライアントのシステム管理者ユーザーを取得する。
     * @summary Get a user
     * @param {string} authorization 認証情報
     * @param {string} clientId クライアントID
     * @param {string} userId ユーザーID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public getUser(params: { authorization?: string, clientId?: string, userId: string,  }, options?: any) {
				const _params = {} as any;
				_params['authorization'] = params['authorization']
				_params['clientId'] = params['clientId']
				_params['userId'] = params['userId']
				// @ts-ignore
				_params.authorization = 'Bearer ' + ( params.authorization || Store.getInstance().getAccessToken())!
				_params.clientId = ((params as any).clientId || (Store.getInstance().getAuth() || {}).clientId)!;
        return UserApiFp(this.configuration).getUser(_params.authorization, _params.clientId, _params.userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 対象クライアントのシステム管理者ユーザー一覧を取得する。
     * @summary Get user list
     * @param {string} authorization 認証情報
     * @param {string} clientId クライアントID
     * @param {string} [q] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public getUsers(params: { authorization?: string, clientId?: string, q?: string,  }, options?: any) {
				const _params = {} as any;
				_params['authorization'] = params['authorization']
				_params['clientId'] = params['clientId']
				_params['q'] = params['q']
				// @ts-ignore
				_params.authorization = 'Bearer ' + ( params.authorization || Store.getInstance().getAccessToken())!
				_params.clientId = ((params as any).clientId || (Store.getInstance().getAuth() || {}).clientId)!;
        return UserApiFp(this.configuration).getUsers(_params.authorization, _params.clientId, _params.q, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 対象クライアントのシステム管理者ユーザーを更新する。
     * @summary Update a user
     * @param {string} authorization 認証情報
     * @param {string} clientId クライアントID
     * @param {string} userId ユーザーID
     * @param {UpdateUserRequest} updateUserRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public updateUser(params: { authorization?: string, clientId?: string, userId: string, updateUserRequest: UpdateUserRequest,  }, options?: any) {
				const _params = {} as any;
				_params['authorization'] = params['authorization']
				_params['clientId'] = params['clientId']
				_params['userId'] = params['userId']
				_params['updateUserRequest'] = params['updateUserRequest']
				// @ts-ignore
				_params.authorization = 'Bearer ' + ( params.authorization || Store.getInstance().getAccessToken())!
				_params.clientId = ((params as any).clientId || (Store.getInstance().getAuth() || {}).clientId)!;
        return UserApiFp(this.configuration).updateUser(_params.authorization, _params.clientId, _params.userId, _params.updateUserRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


